import React, {useContext, useRef, useState, useEffect, useImperativeHandle, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import {connect, useDispatch, useSelector} from 'react-redux';
import {bindActionCreators} from 'redux';
import _ from 'lodash';
import {FmlxIcon} from 'fmlx-common-ui';
import {InitialPicklistHoverState, PicklistPlateType} from 'constants/protocolEditorEnum';
import {UTILITY_CARD_TYPES} from 'constants/cardStateEnum';

import {getFocusedDeckNumber, getIsAspirateDispenseModalShown} from 'stores/selectors/virtualTraySelectors';
import {
  hideAspirateDispenseVolumeModal,
  setAspirateDispenseVolumeModal,
  setDeckLabwareRefs,
  setFocusedDeckNumber,
} from 'stores/actions/virtualTrayAction';
import {
  AspirateDispenseVolumeModalBusiness,
  checkTipVolumeAndShowAspirateDispenseModal,
} from 'stores/business/aspirateDispenseVolumeModalBusiness';
import {restoreTipCountForSingleCard} from 'stores/business/protocolManagementBusiness';
import {setOpenedProtocolEjectToCaddy} from 'stores/actions/protocolAction';

import {selectOpenedProtocolIsEjectToCaddy} from 'stores/selectors/protocolSelectors';

import FormattedHTMLMessage from 'components/FormattedHTMLMessage';

import {getUncompleteMixingTask, mergeArrayOfWellStylesByNest, mergeWellStyleByNest} from 'lib/virtualTrayHelper';
import {getMicroplateLabel} from 'contents/PlateTypeEditor/plateTypeHelper';

import WellItem from 'models/wellItem';

import DeckInsert from './DeckInsert';
import DeckLabware from './DeckLabware';
import TipCaddy from './TipCaddy';
import TipsWasteBin from './TipsWasteBin';
import VirtualTrayFooter from './VirtualTrayFooter';

import {
  normalizeHighlightedWell,
  normalizeSwipingInfo,
  initSwipingInfo,
  updateSwipingInfo,
  generateRowColumnsListFromSwipingInfo,
  convertRowToNumeric,
  SKIP_WELL_MODE,
  getSkipWellMode,
  normalizeRowColoumnList,
  getTaskGroups,
  getHighlightedWellFromTask,
  getMinMaxPositionFromTaskList,
  getHighlightedWell,
  OPTIMIZE_MODE,
  isTasksSameQuadrant,
  getDragHandlePosition,
  getDragDropRowCol,
  getNewStartFromTaskList,
  isIFCLabwareAllowed,
  is24Or48WellLabwareAllowed,
  getTipCountInString,
  checkIs24Or48WellLabware,
  isLabware384,
  isTipCountInLabwareValid,
} from './labwareHelper';

import {ProtocolEditorContext} from '../ContextProviders/ProtocolEditorContext';
import SetVolumeModal from '../SetVolumeModal';
import SetAspirateDispenseModal from '../SetAspirateDispenseModal/SetAspirateDispenseModal';
import CustomDragLayer from '../TransformSelectionLayer/CustomDragLayer';
import {VirtualTrayContext} from './VirtualTrayContext';

import {ColumnLayout, RowLayout} from '../../../components/Layout/Layout';
import jsonCopy from '../../../lib/jsonCopy';

import {
  DragDropType,
  TaskType,
  Feedback,
  ProtocolEditorViewMode,
  CardType,
  RuntimeMode,
  SerialDilutionStep,
  WellCount,
  TipChannelType,
  LabwareWellCount,
  SWIPING_DIRECTION_Y,
  SWIPING_DIRECTION_X,
  NormalizationStep,
  TransformSelectionType,
  KeyboardKey,
  TrayType,
  ViewMode,
  UserRoleLevel,
  NormalizationType,
  RuntimeType,
  TipCaddyLocationType,
  CSVImportPlateColumnPreference,
  VolumeModalType,
} from '../../../constants/dataEnum';

import {draggable, droppable} from '../../../lib/dragAndDrop';
import withIntl from '../../../lib/withIntl';
import {filter, filterToArray, find, selectDistinct, findKeyByValue} from '../../../lib/objectHelper';

import {
  setDeckLabware,
  checkAndRemoveLabware,
  renameLabware,
  getWellStyleColorMapFromTasks,
  getWellStyleColor,
  getAllWellStyleColorMapFromTasks,
  moveAndDuplicateTaskIntoQuadrant,
  moveAndMergeTaskIntoNonQuadrantBase,
  getWellStyleColorMapForNormalizationSelectedPlate,
} from '../../../stores/business/labwareBusinessAction';
import {
  addSimpleTransferTask,
  editSimpleTransferWellTargetTask,
  addCardGroup,
  smarterDefaultDispenseTipPosition,
  addEjectTipTask,
} from '../../../stores/business/taskListBusinessAction';
import {
  setSdRawTask,
  setSdRawDiluentTargetTasks,
  removeSdDiluentTargetRawTask,
  getSdRawTaskIds,
  processSerialDilutionHoveredWell,
  validateLabwareForSerialDilution,
  handleSerialDilutionInvalidLabware,
  getSDRawTasksOnLabware,
  getSDAllowedSwipeDirection,
  getIsChangingSDWellCountAllowed,
  ensureSDSwipeValidity,
  handleSerialDilutionPlateCriteriaMismatch,
  getSerialDilutionTipCount,
} from '../../../stores/business/taskListSerialDilutionBusiness';
import {
  addBroadcastTask,
  addBroadcastDispenseTasks,
  setBroadcastVolume,
  backHandler,
  saveBroadcastStateBeforeEdit,
  restoreBroadcastStateAfterCancelEdit,
  batchEditBroadcastAspirateTasks,
  setBroadcastAspirateVolume,
  optimizeBroadcastCard,
  batchEditBroadcastDispenseTasks,
  onFinishedBroadcastWizard,
} from '../../../stores/business/taskListBroadcastBusiness';
import {setLabwareBarcode, unselectAllLabware} from '../../../stores/actions/labwareStateAction';
import {removeAllCardTask, setTaskIsSelected, removeCardTasks} from '../../../stores/actions/cardStateAction';
import {hideLoading, showLoading, showSnackbar} from '../../../stores/actions/appStateAction';
import {showModal, hideModal} from '../../../stores/actions/modalStateAction';
import {
  addPoolingDispenseTasks,
  poolingBackHandler,
  addPoolingAspirateTasks,
  savePoolingStateBeforeEdit,
  batchRedefinePoolingAspirateTasks,
  restorePoolingStateAfterCancelEdit,
  batchEditPoolingDispenseTasks,
  generateAspirateRowColumnsListFromSwipingInfo,
  setPoolingHelperState,
  batchEditPoolingAspirateTasks,
  removeExcesPoolingTask,
  clearPoolingStateBeforeEdit,
  getPoolingStateBeforeEdit,
  batchMovePoolingAspirateTasks,
  closePoolingVolumeModal as closePoolingVolumeModalBusiness,
  getPoolingDestinationAllowedTip,
  onFinishPoolingWizard,
} from '../../../stores/business/taskListPoolingBusiness';
import {addMixingTask, editMixingTask} from '../../../stores/business/taskListMixingBusiness';
import {
  generateNormalizationTask,
  setAndGeneratePreviewData,
  normalizationBackHandler,
  normalizationEditStep,
  restoreNormalizationStateAfterCancelEdit,
  removeAspirateDispenseTask,
  selectNormalizationSamplePlate,
  selectNormalizationDiluentPlate,
  isLabwareAllowedForNormalization,
  editNormalizationSamplePlate,
  editNormalizationDiluentPlate,
} from '../../../stores/business/taskListNormalizationBusinessAction';
import {
  setCurrentWizardView,
  setDiluentWell,
  setNormalizationCurrentVolume,
  setNormalizationDiluentLabware,
} from '../../../stores/actions/normalizationStateAction';

import './VirtualTray.scss';
import {
  finalizePicklist,
  incrementCurrentStep,
  setPicklistDeckId,
  unSetPicklistDeckId,
  swapPicklistDeckId,
  picklistOnDroppedLabware,
  updatePicklistOriginalLabware,
  getPicklistLabwareIDs,
} from '../../../stores/business/taskListPicklistBusiness';
import {
  globalAddUndoItem,
  globalRedo,
  globalUndo,
  globalUndoRedoUpdatePresentState,
} from '../../../stores/business/undoRedoBusinessAction';
import ChooseQuadrantOnPlateSwabModal from './ChooseQuadrantOnSwapLabwareModal';
import {
  setADModalShown,
  setBroadcastTaskEditStep,
  setCustomTipCount,
  setIsEditMixing,
  setSerialDilutionEditStep,
  setNormalizationTaskEditStep,
  setPoolingTaskEditStep,
  setPoolingTaskStep,
  setSelectedMenu,
  setSelectedTipChannel,
  setSerialDilutionStep,
  setSerialDilutionPrevStep,
  setVolumeModalOpen,
} from '../../../stores/actions/protocolEditorAction';
import {useStaticCallback} from '../../../lib/customHooks';
import {HighlightTaskContext} from '../ContextProviders/HighlightTaskContext';
import {initiateGlobalWorker} from '../../../workers/initiateWorker';
import {removeTemporaryState} from '../../../stores/actions/temporaryStateAction';
import {isRoleLevel} from '../../../stores/business/userManagementBusiness';
import {getTipCount} from '../../../stores/business/commonTaskListBusiness';
import {saveState} from '../../../stores/business/stateBusiness';
import TessaraLogo from '../../../components/TessaraLogo';
import {
  SerialDilutionLabwareValidator,
  restrictSDSwipeByExistingTasks,
  convertSwipePatternToStamping,
  isSDSwipeConvertibleToStamping,
  mapToSDSwipeData,
} from '../../../lib/serialDilutionHelper';
import {
  is12WellTrough,
  is1WellTrough,
  is8WellTrough,
  mergeNormalizationLabwareWellColor,
} from '../../../lib/normalizationHelper';
import {getIsConsolidateTipsCardExist} from '../../../stores/selectors/cardStateSelector';
import {getBroadcastTaskByType} from '../../../lib/broadcastHelper';
import {getRuntimeType} from '../../../stores/selectors/runtimeSelector';
import DynamicArrowLayer from '../ArrowLayer/DynamicArrowLayer';
import {onEditSimpleTransferHandler} from '../TaskList/Task/SimpleTransfer/Tasks/simpleTransferTaskBusiness';

const hoverWellColorEnum = '#C0D6FB';

const DragAbleDeckLabware = React.memo(
  draggable(DeckLabware),
  (prev, next) =>
    prev.hoverable === next.hoverable &&
    _.isEqual(prev.tasks, next.tasks) &&
    _.isEqual(prev.sdRawTasks, next.sdRawTasks) &&
    prev.cardType === next.cardType &&
    prev.header === next.header &&
    prev.zoomable === next.zoomable &&
    prev.selectable === next.selectable &&
    prev.disallowZoomOut === next.disallowZoomOut &&
    prev.runtimeMode === next.runtimeMode &&
    _.isEqual(prev.selectedWellStyle, next.selectedWellStyle) &&
    _.isEqual(prev.taskWellColor, next.taskWellColor) &&
    prev.swipeEnable === next.swipeEnable &&
    _.isEqual(prev.normalizationTasks, next.normalizationTasks) &&
    prev.hoveredLabwareId === next.hoveredLabwareId &&
    _.isEqual(prev.initHoveredWell, next.initHoveredWell) &&
    prev.maxCharacters === next.maxCharacters &&
    _.isEqual(prev.initHoveredWell, next.initHoveredWell) &&
    prev.showLabwareName === next.showLabwareName &&
    prev.labwareName === next.labwareName &&
    prev.oneDimensionalSwipeOnly === next.oneDimensionalSwipeOnly &&
    prev.isDeepWell === next.isDeepWell &&
    prev.isSelected === next.isSelected &&
    prev.showTS === next.showTS &&
    _.isEqual(prev.prevlayouts, next.prevlayouts) &&
    prev.protocolEditorMode === next.protocolEditorMode &&
    prev.showLabwareButton === next.showLabwareButton &&
    prev.onMouseLeave === next.onMouseLeave &&
    prev.labwareSelectedForNormalization === next.labwareSelectedForNormalization,
);

const DropAbleDeckInsert = React.memo(
  droppable(DeckInsert),
  (prev, next) =>
    prev.isOver === next.isOver &&
    prev.canDrop === next.canDrop &&
    prev.allowedToSwitchLabware === next.allowedToSwitchLabware &&
    _.isEqual(prev.children, next.children) &&
    _.isEqual(prev.onHoverDeck, next.onHoverDeck) &&
    _.isEqual(prev.deepWellOnly, next.deepWellOnly) &&
    prev.selectionMode === next.selectionMode,
);

const DeckInsertMemo = React.memo(
  DeckInsert,
  (prev, next) =>
    prev.isOver === next.isOver &&
    prev.canDrop === next.canDrop &&
    prev.allowedToSwitchLabware === next.allowedToSwitchLabware &&
    prev.tasks === next.tasks &&
    prev.isSelected === next.isSelected &&
    prev.selectionMode === next.selectionMode &&
    _.isEqual(prev.children.props, next.children.props),
);

const VirtualTray = React.forwardRef(
  (
    {
      intl,
      selectedCard,
      availableLabwareState,
      labwareState,
      cardState,
      cardStateTasks,
      cardStateGroups,
      runtimeMode,
      runtimeStateCsvRecordID,
      runtimeStateDoneRecordCSVIDs,
      runtimeStateStatus,
      runtimeStateTrayType,
      configStateMaxAspirateVolume,
      configStateMaxAspirateHighVolume,
      normalizationState,
      isTessaraProtocol,
      appStateActionShowSnackbar,
      appStateViewMode,
      labwareActionUnselectAllLabware,
      labwareBusinessRenameLabware,
      labwareBusinessSetDeckLabware,
      labwareBusinessRemoveLabware,
      labwareBusinessGetWellStyleColorMapFromTasks,
      labwareBusinessGetWellStyleColor,
      labwareBusinessGetAllWellStyleColorMapFromTasks,
      labwareBusinessMoveAndDuplicateTaskIntoQuadrant,
      labwareBusinessMoveAndMergeTaskIntoNonQuadrantBase,
      labwareStateActionSetLabwareBarcode,
      taskListBusinessAddTask,
      taskListBusinessAddCardGroup,
      taskListBusinessEditWellTargetTask,
      taskListBusinessSmarterDefaultDispenseTipPosition,
      taskListSerialDilutionBusinessSetSdRawTask,
      taskListSerialDilutionBusinessRemoveSdDiluentTargetRawTask,
      taskListSerialDilutionBusinessGetSdRawTaskIds,
      taskListBroadcastBusinessAddBroadcastTask,
      taskListBroadcastBusinessAddBroadcastDispenseTasks,
      taskListBroadcastBusinessSetBroadcastVolume,
      taskListBroadcastBusinessBackHandler,
      taskListBroadcastBusinessSaveBroadcastStateBeforeEdit,
      taskListBroadcastBusinessRestoreBroadcastStateAfterCancelEdit,
      taskListBroadcastBusinessBatchEditBroadcastAspirateTasks,
      taskListBroadcastBusinessSetBroadcastAspirateVolume,
      taskListBroadcastBusinessOptimizeBroadcastCard,
      taskListBroadcastBusinessBatchEditBroadcastDispenseTasks,
      cardActionSetTaskIsSelected,
      cardActionRemoveAllCardTask,
      modalStateActionShowModal,
      modalStateActionHideModal,
      taskListPoolingBusinessAddPoolingDispenseTasks,
      taskListPoolingBusinessAddPoolingAspirateTasks,
      taskListPoolingBusinessBackHandler,
      taskListPoolingBusinessSavePoolingStateBeforeEdit,
      taskListPoolingBusinessBatchEditPoolingDispenseTasks,
      taskListPoolingBusinessBatchMovePoolingAspirateTasks,
      taskListPoolingBusinessRestorePoolingStateAfterCancelEdit,
      taskListPoolingSetPoolingHelperState,
      taskListPoolingBusinessBatchEditPoolingAspirateTasks,
      taskListPoolingBusinessClosePoolingVolumeModal,
      taskListPoolingBusinessGetPoolingDestinationAllowedTip,
      taskListMixingBusinessAddMixingTask,
      taskListMixingBusinessEditMixingTask,
      taskListNormalizationSelectNormalizationSamplePlate,
      taskListNormalizationSelectNormalizationDiluentPlate,
      taskListNormalizationGeneratePreviewData,
      taskListNormalizationGenerateNormalizationTask,
      taskListNormalizationNormalizationBackHandler,
      taskListNormalizationNormalizationEditStep,
      taskListNormalizationRemoveAspirateDispenseTask,
      taskListBroadcastBusinessRestoreNormalizationStateAfterCancelEdit,
      normalizationStateActionSetNormalizationCurrentVolume,
      normalizationStateActionSetDiluentWell,
      protocolConfig,
      poolingStateBeforeEdit,
      cardStateActionRemoveCardTasks,
      taskListPicklistBusinessSetPicklistDeckId,
      taskListPicklistBusinessUnSetPicklistDeckId,
      taskListPicklistBusinessIncrementCurrentStep,
      taskListPicklistBusinessFinalizePicklist,
      taskListPicklistSwapPicklistDeckId,
      taskListPicklistOnDroppedLabware,
      tasklistPicklistBusinessUpdatePicklistOriginalLabware,
      tasklistPicklistBusinessGetPicklistLabwareIDs,
      undoRedoBusinessActionGlobalAddUndoItem,
      undoRedoBusinessActionGlobalUndoRedoUpdatePresentState,
      undoRedoBusinessActionGlobalUndo,
      undoRedoBusinessActionGlobalRedo,
      picklistDefinition,
      temporaryState,
      deepWellThreshold,
      taskListPoolingBusinessClearPoolingStateBeforeEdit,
      taskListPoolingBusinessGetPoolingStateBeforeEdit,
      protocolEditorState,
      protocolEditorStateActionSetADModalShown,
      protocolEditorStateActionSetSelectedTipChannel,
      protocolSelectedTipChannel,
      protocolCustomTipCount,
      protocolEditorStateActionSetCustomTipCount,
      protocolSerialDilutionStep,
      protocolEditorStateActionSetSerialDilutionStep,
      protocolEditorStateActionSetSerialDilutionEditStep,
      protocolEditorStateActionSetSerialDilutionPrevStep,
      protocolBroadcastTaskEditStep,
      protocolEditorStateActionSetBroadcastTaskEditStep,
      protocolPoolingTaskEditStep,
      protocolEditorStateActionSetPoolingTaskEditStep,
      protocolPoolingTaskStep,
      protocolEditorStateActionSetPoolingTaskStep,
      protocolNormalizationTaskEditStep,
      protocolEditorStateActionSetNormalizationTaskEditStep,
      normalizationStateNormalizationStep,
      setNormalizationStep,
      protocolIsEditMixing,
      protocolEditorStateActionSetIsEditMixing,
      protocolVolumeModalOpen,
      protocolEditorStateActionSetVolumeModalOpen,
      protocolEditorMode,
      setProtocolEditorMode,
      appStateActionShowLoading,
      appStateActionHideLoading,
      isModalShowing,
      isLoadingShowing,
      hideWasteBin,
      hideWellHighlight,
      temporaryStateActionRemoveTemporaryState,
      userManagementBusinessIsRoleLevel,
      simpleTransferEditedType,
      lastOpenedProtocol,
      svmExcludedComponentRef,
      stateBusinessSaveState,
      setNormalizationDiluentLabwareTray,
      isRunOnly,
      configMinAspirateVolume,
      configMinAspirateHighVolume,
      configRecommendedAspirateVolume,
      configRecommendedAspirateHighVolume,
    },
    ref,
  ) => {
    const dispatch = useDispatch();
    const protocolEditorContext = useContext(ProtocolEditorContext);
    const {
      volumeDetailViewChecked,
      setVolumeDetailViewChecked,
      arrowDetailViewChecked,
      setArrowDetailViewChecked,
      selectedCardRef,
      draggedLabwareId,
      setDraggedLabwareId,
      cardStateTasksRef,
      setDeckLabwareRefs: setDeckLabwareRefsContext, // TOOD: need to completely replace deckLabwareRefs source to redux state
      isOverCapacityTooltipShow,
      setIsOverCapacityTooltipShow,
      setTooltipPosition,
      setOverCapacityMessage,
      headerRef,
      setSdProperty,
      draggedLabwareType,
      setDraggedLabwareType,
    } = protocolEditorContext || {};

    const {highlightedTask} = useContext(HighlightTaskContext) || {};

    const isAspirateDispenseModalShown = useSelector(getIsAspirateDispenseModalShown);
    const focusedDeckNumber = useSelector(getFocusedDeckNumber);
    const isEjectToCaddy = useSelector(selectOpenedProtocolIsEjectToCaddy);
    const isHighVolumeProtocol = lastOpenedProtocol?.trayType === TrayType.HIGH_VOLUME_CADDY;
    const maxAspirateVolume = isHighVolumeProtocol ? configStateMaxAspirateHighVolume : configStateMaxAspirateVolume;
    const minAspirateVolume = isHighVolumeProtocol ? configMinAspirateHighVolume : configMinAspirateVolume;
    const recommendedAspirateVolume = isHighVolumeProtocol
      ? configRecommendedAspirateHighVolume
      : configRecommendedAspirateVolume;

    const isOperator = userManagementBusinessIsRoleLevel(UserRoleLevel.OPERATOR);
    const isTessaraSuperUser = userManagementBusinessIsRoleLevel(UserRoleLevel.TESSARA_SUPER_USER);

    const isTessaraProtocolAndTessaraSuperUser = isTessaraSuperUser && isTessaraProtocol;
    const isTessaraProtocolAndRegularTessaraUser = !isTessaraSuperUser && isTessaraProtocol;

    const selectLabwareMode = useMemo(
      () =>
        protocolEditorMode === ProtocolEditorViewMode.PICKLIST ||
        (protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION &&
          normalizationStateNormalizationStep === NormalizationStep.SET_SAMPLE_LABWARE),
      [protocolEditorMode, normalizationStateNormalizationStep],
    );

    const isConsolidateTipsCardExist = useSelector(getIsConsolidateTipsCardExist);
    const runtimeType = useSelector(getRuntimeType);

    const [selectedWellStyle, setSelectedWellStyle] = useState({});
    const [colorMap, setColorMap] = useState({});
    const [volumeModalPos, setVolumeModalPos] = useState({top: 0, left: 0});
    const [volumeModalType, setVolumeModalType] = useState(VolumeModalType.BROADCAST);

    const [deckLabwareRefs] = useState({
      1: useRef(null),
      2: useRef(null),
      3: useRef(null),
      4: useRef(null),
      5: useRef(null),
      6: useRef(null),
    });
    const poolingVolumeModalOpenRef = useRef(false);
    const [hoveredLabwareId, setHoveredLabwareId] = useState(null);
    const [TSLayout, setTSLayout] = useState({});
    const [draggedLayout, setDraggedLayout] = useState({});
    const [draggedHandle, setDraggedHandle] = useState({});
    const [showTS, setShowTS] = useState(false);
    const [hoveredNormalization, setHoveredNormalization] = useState(null); // hovered labware for normalization

    const containerRef = useRef(null);
    const ADModalRef = useRef(null);
    const volumeModalRef = useRef(null);

    const swipingInfoRef = useRef();
    const enableHighlightTaskRef = useRef(true);
    const focusedSimpleTransferTaskInfo = useRef(null);
    const groupedWellStylesRef = useRef([]);

    const simpleTransferVolume = useRef(0);
    const prevSimpleTransferVolume = useRef(0);
    const initialValueVolumeModal = useRef(0);

    const previousSelectedTask = useRef(null);

    const previousHoveredLabware = useRef(null);

    const unselectCard = useRef(true);

    const labwareStateRef = useRef(labwareState);

    const ctrlPressedRef = useRef(false);
    const shiftPressedRef = useRef(false);
    const keyCodePressdList = useRef([]);

    const [hoveredWellState, setHoveredWellState] = useState({
      1: {row: null, column: null},
      2: {row: null, column: null},
      3: {row: null, column: null},
      4: {row: null, column: null},
      5: {row: null, column: null},
      6: {row: null, column: null},
    });

    const draggedTasksRef = useRef([]);
    const draggedCornerRef = useRef({row: undefined, column: undefined});
    const targetedWellRef = useRef(null);
    const hoveredWellRef = useRef(null);

    const chooseQuadrantModalRef = useRef(null);

    const [selectedDeckLabware, setSelectedDeckLabware] = useState({
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
      6: false,
    });
    const isSameQuadrant = useRef(true);
    const isSameRowQuadrantRef = useRef(false);
    const isSameColumnQuadrantRef = useRef(false);

    const selectLabwareHandlerRef = useRef();
    const selectLabwareHandler = (id) => {
      const temporarySelectedLabwareState = {
        ...selectedDeckLabware,
        [id]: true,
      };
      setSelectedDeckLabware({
        ...temporarySelectedLabwareState,
      });
    };

    const isOnlyUtilityCardExists = useMemo(() => {
      const cardStateArr = Object.values(cardState);
      const isCardWithEjectTipExists = cardStateArr.find(
        (card) => card.type !== CardType.MIXING && !UTILITY_CARD_TYPES.includes(card.type),
      );

      return !isCardWithEjectTipExists && cardStateArr.length;
    }, [cardState]);

    const selectLabwareHandlerMemo = useCallback((id) => {
      selectLabwareHandlerRef.current(id);
    }, []);

    const unselectLabwareHandlerRef = useRef();
    const unselectLabwareHandler = (id) => {
      setSelectedDeckLabware((pre) => ({
        ...pre,
        [id]: false,
      }));
    };
    const unselectLabwareHandlerMemo = useCallback((id) => {
      unselectLabwareHandlerRef.current(id);
    }, []);

    useEffect(() => {
      selectLabwareHandlerRef.current = selectLabwareHandler;
      unselectLabwareHandlerRef.current = unselectLabwareHandler;
    });

    const setPoolingVolumeModalOpenStatus = (status) => {
      poolingVolumeModalOpenRef.current = status;
      protocolEditorStateActionSetVolumeModalOpen(status);
    };

    const [isDraggingDeckLabware, setIsDraggingDeckLabware] = useState(false);

    const generateColorMap = () => {
      let newColorMap = {};

      if (hideWellHighlight) {
        setColorMap({});
        return;
      }

      if (runtimeMode) {
        newColorMap = labwareBusinessGetWellStyleColorMapFromTasks(
          selectedCard.ID,
          protocolSelectedTipChannel,
          runtimeMode,
        );
      } else {
        newColorMap = labwareBusinessGetAllWellStyleColorMapFromTasks(runtimeMode);
      }

      if (normalizationState.sampleLabwareID) {
        const sampleLabwareColor = dispatch(getWellStyleColorMapForNormalizationSelectedPlate()) || {};
        newColorMap = {
          ...mergeNormalizationLabwareWellColor(normalizationState.sampleLabwareID, sampleLabwareColor, newColorMap),
        };
      }

      if (normalizationState.diluentLabwareID) {
        const diluentLabwareColor = dispatch(getWellStyleColorMapForNormalizationSelectedPlate()) || {};
        newColorMap = {
          ...mergeNormalizationLabwareWellColor(normalizationState.diluentLabwareID, diluentLabwareColor, newColorMap),
        };
      }

      if (!newColorMap) {
        return;
      }
      setColorMap(newColorMap);
    };

    useEffect(() => {
      if (isOnlyUtilityCardExists && isEjectToCaddy && !isRunOnly && !runtimeMode) {
        dispatch(setOpenedProtocolEjectToCaddy(false));
      }
    }, [dispatch, isEjectToCaddy, isOnlyUtilityCardExists, isRunOnly, runtimeMode]);

    useEffect(() => {
      labwareActionUnselectAllLabware(false);
      protocolEditorStateActionSetADModalShown(false);
      protocolEditorStateActionSetVolumeModalOpen(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      generateColorMap();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      cardStateTasks,
      selectedCard,
      runtimeStateCsvRecordID,
      runtimeStateDoneRecordCSVIDs,
      protocolEditorMode,
      normalizationState.sampleLabwareID,
      normalizationState.diluentLabwareID,
      normalizationState.currentWizardView,
      normalizationState.diluentWell,
    ]);

    // hafidz: make sure dispense task is set to done (green color) if last task is not eject tip
    useEffect(() => {
      if (runtimeStateStatus !== RuntimeMode.FINISH) {
        return;
      }

      generateColorMap();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [runtimeStateStatus]);

    // not show direction detail view if card is unchecked
    useEffect(() => {
      if (arrowDetailViewChecked && selectedCard?.isIgnored) {
        setArrowDetailViewChecked(!selectedCard.isIgnored);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCard, arrowDetailViewChecked]);

    // hides detail view and detail volume view for tessara protocol
    useEffect(() => {
      if (!isTessaraProtocol) return;

      if (arrowDetailViewChecked || volumeDetailViewChecked) {
        setArrowDetailViewChecked(false);
        setVolumeDetailViewChecked(false);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTessaraProtocol]);

    useEffect(() => {
      labwareStateRef.current = labwareState;
    }, [labwareState]);

    useEffect(() => {
      if (!runtimeMode) {
        setDeckLabwareRefsContext(deckLabwareRefs);
        dispatch(setDeckLabwareRefs(deckLabwareRefs));
      }
    }, [deckLabwareRefs, dispatch, runtimeMode, setDeckLabwareRefsContext]);

    async function showSetAspirateDispenseModal(task, onApplyCallback) {
      await protocolEditorStateActionSetADModalShown(true);

      const callback = async (result) => {
        await protocolEditorStateActionSetADModalShown(false);
        onApplyCallback(result);
      };

      dispatch(checkTipVolumeAndShowAspirateDispenseModal(selectedCard, task, callback));
    }

    const resetSwipingInfo = () => {
      enableHighlightTaskRef.current = false;
      swipingInfoRef.current = null;
    };

    const reInitializeWellStyleOnShiftChange = (isShift) => {
      // eslint-disable-next-line no-unsafe-optional-chaining
      const {tipCount, labware} = swipingInfoRef?.current;
      const deckID = findKeyByValue(labwareStateRef.current, {LabwareID: labware.LabwareID});
      const is384 = labware.rowCount * labware.colCount === WellCount.WELL_384;
      if (is384) {
        const [skipWellMode, noSkip] = getSkipWellMode(tipCount?.row ?? 1, tipCount?.column ?? 1, isShift, is384);
        const [normalizedSwipingStart, , normalizedSwipingSize, skipWell] = normalizeSwipingInfo(
          swipingInfoRef.current,
          skipWellMode,
          noSkip,
        );

        if (normalizedSwipingStart && normalizedSwipingSize) {
          setSelectedWellStyle({
            [deckID]: labwareBusinessGetWellStyleColor(
              labware.LabwareID,
              normalizedSwipingStart.row,
              normalizedSwipingStart.column,
              hoverWellColorEnum,
              normalizedSwipingSize.row,
              normalizedSwipingSize.column,
              null,
              false,
              null,
              null,
              skipWell?.row,
              skipWell?.column,
              true,
            ),
          });
        }
      }
    };

    // #region common
    const calculateVolumeModalPos = (currentDeckNumber) => {
      const yOffset = 0;
      const xOffset = -150;

      const deckLabwarePos = deckLabwareRefs[currentDeckNumber].current.getBoundingClientRect();

      const top = deckLabwarePos.top + yOffset;
      const left = deckLabwarePos.left + xOffset;

      setVolumeModalPos({top, left});
    };

    // #endregion

    // #region serial dilution
    const sdDiluentTargetShiftPattern = useRef(null);

    useEffect(() => {
      if (selectedCard?.type === CardType.SERIAL_DILUTION) {
        const {sdRawTasksSummary, sdProperty} = selectedCard;
        const step = sdProperty?.step ?? 0;
        const taskDiluentTargets = sdRawTasksSummary?.taskDiluentTargets ?? [];
        const taskSampleTargets = sdRawTasksSummary?.taskSampleTarget ?? [];

        if (
          taskDiluentTargets.length ||
          (taskSampleTargets.length && protocolSerialDilutionStep !== SerialDilutionStep.SET_SAMPLE_TARGET)
        ) {
          const diluentTargetsShift =
            (taskSampleTargets.length > 1 || step !== taskDiluentTargets.length) &&
            protocolSerialDilutionStep === SerialDilutionStep.SET_DILUENT_TARGET;
          const sampleTargetShift =
            step !== taskDiluentTargets.length && protocolSerialDilutionStep === SerialDilutionStep.SET_SAMPLE_TARGET;

          sdDiluentTargetShiftPattern.current = diluentTargetsShift || sampleTargetShift;
          // eslint-disable-next-line no-dupe-else-if
        } else if (taskSampleTargets.length && protocolSerialDilutionStep !== SerialDilutionStep.SET_SAMPLE_TARGET) {
          sdDiluentTargetShiftPattern.current = taskSampleTargets.length > 1;
        } else {
          sdDiluentTargetShiftPattern.current = null;
        }
      } else {
        sdDiluentTargetShiftPattern.current = false;
      }
    }, [protocolSerialDilutionStep, selectedCard]);

    const isSwipeAllowed = () => {
      const sdStep = protocolSerialDilutionStep;

      if (!sdStep) {
        return false;
      }

      const [rowTipCount] = dispatch(getSerialDilutionTipCount(sdStep, selectedCard));

      return (
        (sdStep === SerialDilutionStep.SET_DILUENT_SOURCE && !rowTipCount) ||
        (sdStep === SerialDilutionStep.SET_SAMPLE_SOURCE && !rowTipCount) ||
        (sdStep === SerialDilutionStep.SET_SAMPLE_TARGET && !rowTipCount) ||
        sdStep === SerialDilutionStep.SET_DILUENT_TARGET ||
        dispatch(getIsChangingSDWellCountAllowed(sdStep, selectedCard))
      );
    };

    const isSerialDilutionSwiping = () => {
      const isSd = protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION;

      if (!isSd) {
        return false;
      }

      return !!swipingInfoRef?.current?.swipingStart;
    };

    function onHoverWellSerialDilution(itemID, row, column, labwareIndex, isCtrl, isShift) {
      const labware = labwareState[itemID];
      const {LabwareID: labwareId} = labware;

      if (isSerialDilutionSwiping()) {
        if (labwareId !== swipingInfoRef.current.labwareId) {
          return;
        }
      }

      const is384 = isLabware384(labware);
      const is2DSelection = sdDiluentTargetShiftPattern.current ?? isShift;

      const {hoveredWell} = dispatch(
        processSerialDilutionHoveredWell({labware, labwareIndex, row, column, is2DSelection}),
      );
      let {row: normalizedRow, column: normalizedColumn, rowTipCount, columnTipCount} = hoveredWell;

      // normalize rowTipCount, columnTipCount, normalizedRow, normalizedColumn if full well task already defined in labware 384
      if (is384 && is2DSelection) {
        rowTipCount = rowTipCount > 1 ? rowTipCount * 2 : rowTipCount;
        columnTipCount = columnTipCount > 1 ? columnTipCount * 2 : columnTipCount;

        const is96TipCount = rowTipCount * columnTipCount === LabwareWellCount.LABWARE_96;
        if (is96TipCount) [normalizedRow, normalizedColumn] = [1, 1];
      }

      const validationResult = dispatch(
        validateLabwareForSerialDilution({labware, wellData: hoveredWell, is2DSelection}),
      );

      if (!validationResult.isPassed) {
        setSelectedWellStyle({[itemID]: {}});
        return;
      }

      let noSkipRow = false;
      let noSkipColumn = false;
      if (is384 && columnTipCount > labware.colCount / 2) {
        noSkipColumn = true;
      }

      if (is384 && rowTipCount > labware.rowCount / 2) {
        noSkipRow = true;
      }

      setSelectedWellStyle({
        [itemID]: labwareBusinessGetWellStyleColor(
          labwareId,
          normalizedRow,
          normalizedColumn,
          hoverWellColorEnum,
          rowTipCount ?? 1,
          columnTipCount ?? 1,
          null,
          false,
          null,
          null,
          is2DSelection || noSkipRow ? 0 : null,
          is2DSelection || noSkipColumn ? 0 : null,
          true,
          true,
          labwareIndex,
        ),
      });
    }

    function onSwipeStartSerialDilution(itemID, row, column, isCtrl, isShift) {
      const labware = labwareState[itemID];
      const {isIFC, isSpearBio} = labware;

      const is384 = isLabware384(labware);

      if (isIFC || isSpearBio) {
        return;
      }

      if (!is384 && sdDiluentTargetShiftPattern.current) {
        return;
      }

      const is2DSelection = sdDiluentTargetShiftPattern.current ?? isShift;

      const {hoveredWell} = dispatch(processSerialDilutionHoveredWell({labware, row, column, is2DSelection}));
      const {row: normalizedRow, column: normalizedColumn} = hoveredWell;

      const validationResult = dispatch(
        validateLabwareForSerialDilution({labware, wellData: hoveredWell, is2DSelection}),
      );

      if (!validationResult.isPassed) return;

      swipingInfoRef.current = initSwipingInfo(normalizedRow, normalizedColumn, labware);
      swipingInfoRef.current.originStart = {
        row: normalizedRow,
        column: normalizedColumn,
      };
    }

    function onSwipeMoveSerialDilution(itemID, row, column, swipingDirectionY, swipingDirectionX, isCtrl, isShift) {
      const labware = labwareState[itemID];
      const {LabwareID: labwareId} = labware;

      const swipeInfo = swipingInfoRef.current;
      const sdStep = protocolSerialDilutionStep;

      if (!swipeInfo) {
        return;
      }

      if (!isSwipeAllowed() && sdStep !== SerialDilutionStep.SET_SAMPLE_TARGET) {
        resetSwipingInfo();

        return;
      }

      const is384 = isLabware384(labware);

      if (isSerialDilutionSwiping()) {
        if (labwareId !== swipingInfoRef.current?.labware?.LabwareID) {
          return;
        }
      }

      const [rowTipCount, columnTipCount] = dispatch(getSerialDilutionTipCount(sdStep, selectedCard));

      const isFirstInitializingSDPattern = !rowTipCount && !columnTipCount;

      const [skipWellMode] = getSkipWellMode(
        rowTipCount,
        columnTipCount,
        (sdDiluentTargetShiftPattern.current ?? isShift) &&
          (sdStep === SerialDilutionStep.SET_DILUENT_TARGET || sdStep === SerialDilutionStep.SET_SAMPLE_TARGET),
        is384,
        true,
      );

      const rawTasksOnLabware = dispatch(getSDRawTasksOnLabware(labwareId));
      const currentHoveredWell = new WellItem(row, column, rowTipCount, columnTipCount);

      const [normalizedRow, normalizedColumn] = restrictSDSwipeByExistingTasks({
        rawTasksOnLabware,
        swipingInfo: swipingInfoRef.current,
        wellData: currentHoveredWell,
        is384,
        skipWellMode,
      });

      const {row: swipingStartRow, column: swipingStartColumn} = swipingInfoRef.current.originStart;
      const initialTipCount = {row: rowTipCount, column: columnTipCount};

      const startSwipePattern = new WellItem(
        swipingStartRow,
        swipingStartColumn,
        initialTipCount.row,
        initialTipCount.column,
      );

      const initialSwipeDirection = {x: swipingDirectionX, y: swipingDirectionY};
      const allowedSwipeDirection = dispatch(getSDAllowedSwipeDirection(startSwipePattern, labware));

      const canConvertSwipeToStampingPattern = isSDSwipeConvertibleToStamping(
        startSwipePattern,
        initialSwipeDirection,
        allowedSwipeDirection,
      );

      let adjustedSwipeData = {swipeDirection: initialSwipeDirection, swipePattern: startSwipePattern};

      if (canConvertSwipeToStampingPattern) {
        adjustedSwipeData.swipePattern = convertSwipePatternToStamping(startSwipePattern, is384);
      } else {
        adjustedSwipeData = dispatch(
          ensureSDSwipeValidity(startSwipePattern, initialSwipeDirection, allowedSwipeDirection),
        );
      }

      const mappedSwipeData = mapToSDSwipeData({
        currentHoveredWell: {row: normalizedRow, column: normalizedColumn},
        swipeDirection: adjustedSwipeData.swipeDirection,
        swipePattern: adjustedSwipeData.swipePattern,
      });

      const newSwipingInfo = updateSwipingInfo(
        swipingInfoRef.current,
        mappedSwipeData.tipCount,
        mappedSwipeData.startSwipePosition,
        mappedSwipeData.endSwipePosition,
        adjustedSwipeData.swipeDirection.y,
        adjustedSwipeData.swipeDirection.x,
        [],
        false,
        false,
        false,
        false,
      );

      if (!newSwipingInfo) {
        resetSwipingInfo();

        return;
      }

      const temporarySwipingInfo = {...swipingInfoRef.current};
      swipingInfoRef.current = newSwipingInfo;

      const [normalizedSwipingStart, , normalizedSwipingSize, skipWell] = normalizeSwipingInfo(
        swipingInfoRef.current,
        skipWellMode,
        is384 &&
          (sdDiluentTargetShiftPattern.current ?? isShift) &&
          (sdStep === SerialDilutionStep.SET_DILUENT_TARGET || sdStep === SerialDilutionStep.SET_SAMPLE_TARGET) &&
          !rowTipCount &&
          !columnTipCount,
      );

      const tipCountToCheck = {
        row: isFirstInitializingSDPattern ? normalizedSwipingSize?.row : rowTipCount,
        column: isFirstInitializingSDPattern ? normalizedSwipingSize?.column : columnTipCount,
      };

      const isTipCountValidForLabware = isTipCountInLabwareValid(
        labware,
        tipCountToCheck?.row,
        tipCountToCheck?.column,
      );

      const isAllowedToBypassLabwareTipCountRule =
        sdStep === SerialDilutionStep.SET_DILUENT_TARGET && !isFirstInitializingSDPattern;

      // prevent multiple-well selection except for setting the dilution target
      if (!isTipCountValidForLabware && !isAllowedToBypassLabwareTipCountRule) {
        swipingInfoRef.current = temporarySwipingInfo;
        return;
      }

      let noSkipRow = false;
      let noSkipColumn = false;
      if (is384 && columnTipCount > labware.colCount / 2) {
        noSkipColumn = true;
      }

      if (is384 && rowTipCount > labware.rowCount / 2) {
        noSkipRow = true;
      }

      if (normalizedSwipingStart && normalizedSwipingSize) {
        setSelectedWellStyle({
          [itemID]: labwareBusinessGetWellStyleColor(
            labwareId,
            normalizedSwipingStart.row,
            normalizedSwipingStart.column,
            hoverWellColorEnum,
            normalizedSwipingSize.row,
            normalizedSwipingSize.column,
            null,
            false,
            null,
            null,
            noSkipRow ? 0 : skipWell?.row,
            noSkipColumn ? 0 : skipWell?.column,
            true,
          ),
        });
      }
    }

    async function onSwipeEndSerialDilution(itemID, row, column, labwareIndex, isCtrl, isShift) {
      const labware = labwareState[itemID];
      const is2DSelection = sdDiluentTargetShiftPattern.current ?? isShift;
      const sdStep = protocolSerialDilutionStep;
      const {sdProperty} = selectedCard;

      const labwareValidator = SerialDilutionLabwareValidator(labware);
      const isLabwareValid = labwareValidator.validateLabware(sdStep);
      const is384 = isLabware384(labware);

      if (!isLabwareValid) {
        dispatch(handleSerialDilutionInvalidLabware(labware, is2DSelection));
        return;
      }

      if (!sdStep) {
        return;
      }

      const labwareInteractionState = dispatch(
        processSerialDilutionHoveredWell({
          labware,
          labwareIndex,
          row,
          column,
          is2DSelection,
          isLockWellPattern: true,
        }),
      );

      if (
        sdProperty.replicateWell > 1 &&
        (labwareInteractionState.hoveredWell.columnTipCount > labware.colCount ||
          labwareInteractionState.hoveredWell.rowTipCount > labware.rowCount)
      ) {
        dispatch(
          handleSerialDilutionPlateCriteriaMismatch({
            replicateWell: sdProperty.replicateWell,
            columnTipCount: labwareInteractionState.hoveredWell.columnTipCount,
            rowTipCount: labwareInteractionState.hoveredWell.rowTipCount,
            labware,
          }),
        );
        return;
      }

      if (!swipingInfoRef.current) {
        return;
      }

      if (!enableHighlightTaskRef.current) {
        return;
      }

      const currentSelectedCard = selectedCardRef?.current;
      const {sdRawTasks} = currentSelectedCard;
      const {hoveredWell, skipWellMode, isNoSkipWell: noSkip} = labwareInteractionState;

      const {
        row: normalizedRow,
        column: normalizedColumn,
        rowTipCount: rowTipCountFromTask,
        columnTipCount: columnTipCountFromTask,
      } = hoveredWell;

      const {swipingDirectionY, swipingDirectionX} = swipingInfoRef.current;

      const isDiluentTargetStep = sdStep === SerialDilutionStep.SET_DILUENT_TARGET;
      const isSingleDiluentTarget = isDiluentTargetStep && !swipingDirectionY && !swipingDirectionX;
      const isToggling = !swipingDirectionY && !swipingDirectionX;

      if (!isSwipeAllowed() || isSingleDiluentTarget) {
        const is96Well = rowTipCountFromTask * columnTipCountFromTask === LabwareWellCount.LABWARE_96;
        const newSwipingInfo = updateSwipingInfo(
          swipingInfoRef.current,
          {row: rowTipCountFromTask, column: columnTipCountFromTask},
          swipingInfoRef.current.swipingStart,
          is96Well || isToggling ? swipingInfoRef.current.swipingStart : {row: normalizedRow, column: normalizedColumn},
          is96Well && is384 ? SWIPING_DIRECTION_Y.DOWN : swipingDirectionY,
          is96Well && is384 ? SWIPING_DIRECTION_X.LEFT : swipingDirectionX,
          [],
        );

        if (newSwipingInfo) {
          swipingInfoRef.current = {
            ...swipingInfoRef.current,
            ...newSwipingInfo,
          };
        }
      }

      const [, , normalizedSwipingSize] = normalizeSwipingInfo(
        swipingInfoRef.current,
        skipWellMode,
        is384 &&
          is2DSelection &&
          (sdStep === SerialDilutionStep.SET_DILUENT_TARGET || sdStep === SerialDilutionStep.SET_SAMPLE_TARGET),
      );

      const changeWellCountAllowed = dispatch(getIsChangingSDWellCountAllowed(sdStep, selectedCard));

      const rowTipCount =
        isToggling && changeWellCountAllowed && sdStep !== SerialDilutionStep.SET_DILUENT_TARGET
          ? 1
          : normalizedSwipingSize.row;
      const columnTipCount =
        isToggling && changeWellCountAllowed && sdStep !== SerialDilutionStep.SET_DILUENT_TARGET
          ? 1
          : normalizedSwipingSize.column;
      const labwareId = labware.LabwareID;

      // set diluent target
      let optimizeMode = null;
      if (
        is2DSelection &&
        (sdStep === SerialDilutionStep.SET_DILUENT_TARGET || sdStep === SerialDilutionStep.SET_SAMPLE_TARGET)
      ) {
        optimizeMode = OPTIMIZE_MODE.ALL;
        if (rowTipCountFromTask === 1 && columnTipCountFromTask === 1) {
          optimizeMode = OPTIMIZE_MODE.ALL;
        } else if (rowTipCountFromTask === 1 && columnTipCountFromTask !== 1) {
          optimizeMode = OPTIMIZE_MODE.COLUMN;
        } else if (rowTipCountFromTask !== 1 && columnTipCountFromTask === 1) {
          optimizeMode = OPTIMIZE_MODE.ROW;
        }
      }

      const isForceGenerateASingleTask =
        sdStep !== SerialDilutionStep.SET_DILUENT_TARGET || (!rowTipCountFromTask && !columnTipCountFromTask);

      const tipCountToGenerateTask =
        isForceGenerateASingleTask && !isToggling
          ? normalizedSwipingSize
          : {row: rowTipCountFromTask, column: columnTipCountFromTask};

      const rowColumnList = generateRowColumnsListFromSwipingInfo(
        swipingInfoRef.current,
        skipWellMode,
        noSkip,
        tipCountToGenerateTask,
        optimizeMode,
        false,
        isForceGenerateASingleTask,
      );

      // delete existing diluent target task
      const filteredSdRawTasks = Object.values(sdRawTasks).filter(
        (sdRawtask) =>
          sdRawtask?.labwareID === labwareId && sdRawtask?.number === SerialDilutionStep.SET_DILUENT_TARGET,
      );

      const [normalizedRowColumnList, taskIdToRemove] = normalizeRowColoumnList({
        rowColumnList,
        taskDispenses: filteredSdRawTasks,
        labwareState,
        skipWellMode,
        is384,
      });

      if (taskIdToRemove.length) {
        taskListSerialDilutionBusinessRemoveSdDiluentTargetRawTask(selectedCard.ID, taskIdToRemove);
      }

      if (!isDiluentTargetStep) {
        const wellData = new WellItem(normalizedRow, normalizedColumn, rowTipCount, columnTipCount);
        const validationResult = dispatch(validateLabwareForSerialDilution({labware, wellData, is2DSelection}));

        if (!validationResult.isPassed) return;

        // define diluent source
        await taskListSerialDilutionBusinessSetSdRawTask(
          protocolSerialDilutionStep,
          normalizedRowColumnList.tipCount.row,
          normalizedRowColumnList.tipCount.column,
          labwareId,
          normalizedRowColumnList.startingRowColumnList,
        );
      } else {
        // add new diluent target task
        await dispatch(
          setSdRawDiluentTargetTasks(
            normalizedRowColumnList.tipCount.row,
            normalizedRowColumnList.tipCount.column,
            labwareId,
            normalizedRowColumnList.startingRowColumnList,
            is2DSelection,
          ),
        );
      }

      undoRedoBusinessActionGlobalAddUndoItem();
    }

    const onShiftKeyReleaseSerialDilution = () => {
      if (shiftPressedRef.current === true) {
        if (
          swipingInfoRef?.current &&
          (protocolSerialDilutionStep === SerialDilutionStep.SET_SAMPLE_TARGET ||
            protocolSerialDilutionStep === SerialDilutionStep.SET_DILUENT_TARGET) &&
          sdDiluentTargetShiftPattern.current === null
        ) {
          reInitializeWellStyleOnShiftChange(false);
        }
        shiftPressedRef.current = false;
      }
    };

    const onShiftKeyPressSerialDilution = () => {
      if (shiftPressedRef.current === false) {
        if (
          swipingInfoRef?.current &&
          (protocolSerialDilutionStep === SerialDilutionStep.SET_SAMPLE_TARGET ||
            protocolSerialDilutionStep === SerialDilutionStep.SET_DILUENT_TARGET) &&
          sdDiluentTargetShiftPattern.current === null
        ) {
          reInitializeWellStyleOnShiftChange(true);
        }
        shiftPressedRef.current = true;
      }
    };

    // #endregion serial dilution

    // #region normalization

    // eslint-disable-next-line default-param-last
    const showNormalizationVolumeModal = async (deckNumber = null, currentVolume = 0, skipAddUndoItem) => {
      const currentDeckNumber = deckNumber;

      calculateVolumeModalPos(currentDeckNumber);
      setVolumeModalType(VolumeModalType.NORMALIZATION);

      protocolEditorStateActionSetVolumeModalOpen(true);
      if (!skipAddUndoItem) {
        undoRedoBusinessActionGlobalAddUndoItem();
      }

      const result = await volumeModalRef.current.show(currentVolume);
      const {volume} = result;

      const parsedVolume = Number.isNaN(parseFloat(volume)) ? 0 : parseFloat(volume);

      if (!parsedVolume) {
        taskListNormalizationNormalizationBackHandler();

        return;
      }

      protocolEditorStateActionSetVolumeModalOpen(false);
      await setNormalizationStep(NormalizationStep.UPLOAD_AND_MANAGE_CSV_FILE);
      undoRedoBusinessActionGlobalAddUndoItem();
    };

    const closeNormalizationVolumeModal = async () => {
      undoRedoBusinessActionGlobalAddUndoItem();
      const result = await volumeModalRef.current.hide();
      protocolEditorStateActionSetVolumeModalOpen(false);

      const {volume} = result;

      if (volume === '' || volume === 0) {
        await setNormalizationStep(NormalizationStep.SET_SAMPLE_LABWARE);
        undoRedoBusinessActionGlobalAddUndoItem();
      } else {
        undoRedoBusinessActionGlobalAddUndoItem();
        await setNormalizationStep(NormalizationStep.UPLOAD_AND_MANAGE_CSV_FILE);
      }
    };

    const onNormalizationHeaderBack = async () => {
      const step = normalizationStateNormalizationStep;

      switch (step) {
        case NormalizationStep.SET_DILUENT_LABWARE:
          volumeModalRef.current.hide();
          protocolEditorStateActionSetVolumeModalOpen(false);
          setNormalizationDiluentLabwareTray('');
          normalizationStateActionSetDiluentWell({});
          break;
        case NormalizationStep.UPLOAD_AND_MANAGE_CSV_FILE:
          volumeModalRef.current.hide();
          protocolEditorStateActionSetVolumeModalOpen(false);
          break;
        case NormalizationStep.SET_TARGET_CONCENTRATION:
          normalizationStateActionSetNormalizationCurrentVolume(0);
          break;
        default:
          break;
      }
      if (!protocolNormalizationTaskEditStep) {
        await taskListNormalizationNormalizationBackHandler();
        undoRedoBusinessActionGlobalAddUndoItem();
      }
      await setNormalizationStep(step - 1);
      undoRedoBusinessActionGlobalAddUndoItem();
    };

    const onNormalizationHeaderNext = async () => {
      const step = normalizationStateNormalizationStep;

      switch (step) {
        case NormalizationStep.SET_SAMPLE_LABWARE:
          await setNormalizationStep(step + 1);
          undoRedoBusinessActionGlobalAddUndoItem();
          break;
        case NormalizationStep.SET_DILUENT_LABWARE:
          volumeModalRef.current.closeAndApply();
          await protocolEditorStateActionSetVolumeModalOpen(false);
          await setNormalizationStep(step + 1);
          undoRedoBusinessActionGlobalAddUndoItem();
          break;
        case NormalizationStep.UPLOAD_AND_MANAGE_CSV_FILE:
          await taskListNormalizationGeneratePreviewData();
          await setNormalizationStep(step + 1);
          undoRedoBusinessActionGlobalAddUndoItem();
          break;
        case NormalizationStep.SET_TARGET_CONCENTRATION:
          if (protocolNormalizationTaskEditStep) {
            await taskListNormalizationGenerateNormalizationTask(() => {
              protocolEditorStateActionSetNormalizationTaskEditStep(null);
              setNormalizationStep(null);
              setProtocolEditorMode(ProtocolEditorViewMode.SIMPLE_TRANSFER);
              undoRedoBusinessActionGlobalAddUndoItem();
            });
          } else {
            // eslint-disable-next-line no-lonely-if
            await taskListNormalizationGenerateNormalizationTask(() => {
              setNormalizationStep(null);
              setProtocolEditorMode(ProtocolEditorViewMode.SIMPLE_TRANSFER);
              undoRedoBusinessActionGlobalAddUndoItem();
            });
          }
          break;
        default:
          break;
      }
    };

    const onNormalizationHeaderCancel = () => {
      volumeModalRef.current.hide();
      protocolEditorStateActionSetVolumeModalOpen(false);
      setNormalizationStep(null);
    };

    const onNormalizationHeaderCancelEdit = () => {
      volumeModalRef.current.hide();
      protocolEditorStateActionSetVolumeModalOpen(false);

      if (protocolNormalizationTaskEditStep === null) {
        return;
      }

      setNormalizationStep(null);
      protocolEditorStateActionSetNormalizationTaskEditStep(null);
      taskListBroadcastBusinessRestoreNormalizationStateAfterCancelEdit();
    };

    const normalizationVolumeModalChange = (volume) => {
      normalizationStateActionSetNormalizationCurrentVolume(parseFloat(volume));
      if (initialValueVolumeModal.current === 0 && volume !== normalizationState.currentVolume) {
        initialValueVolumeModal.current = volume;
        undoRedoBusinessActionGlobalAddUndoItem();
      } else {
        undoRedoBusinessActionGlobalUndoRedoUpdatePresentState('normalizationState', {
          currentVolume: parseFloat(volume),
        });
      }
    };

    const zoomableLabwareNormalization = () => {
      if (protocolEditorMode !== ProtocolEditorViewMode.NORMALIZATION) {
        return true;
      }
      if (normalizationStateNormalizationStep === NormalizationStep.SET_DILUENT_LABWARE) {
        return true;
      }

      return false;
    };

    const isSelectedLabwareNormalization = (labwareID) => {
      if (!runtimeMode && protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION) {
        if (normalizationStateNormalizationStep === NormalizationStep.SET_SAMPLE_LABWARE) {
          return labwareID === normalizationState.sampleLabwareID;
        }
        if (normalizationStateNormalizationStep === NormalizationStep.SET_DILUENT_LABWARE) {
          return labwareID === normalizationState.diluentLabwareID;
        }
      }
      return false;
    };

    const onHoverWellNormalization = (itemID, row, column, labwareIndex) => {
      const {type} = normalizationState;
      const hoveredWellStyle = {
        [itemID]: {},
      };

      const labware = labwareState[itemID];
      const {sampleLabwareID} = normalizationState;
      const selectedLabware = find(labwareState, {LabwareID: sampleLabwareID});

      if (labware.isIFC || labware.isSpearBio) {
        return;
      }

      if (
        (normalizationState.type === NormalizationType.FIXED_DILUENT_VOLUME ||
          normalizationStateNormalizationStep === NormalizationStep.SET_SAMPLE_LABWARE) &&
        (is1WellTrough(labware) || is8WellTrough(labware) || is12WellTrough(labware))
      ) {
        return;
      }

      if (normalizationStateNormalizationStep === NormalizationStep.SET_SAMPLE_LABWARE) {
        return;
      }

      const [normalizedRow, normalizedColumn] = normalizeHighlightedWell(
        row,
        column,
        {row: 1, column: 1},
        labware,
        labwareIndex,
      );

      let isSameOrGreaterPlateDiemensions =
        selectedLabware?.rowCount >= labware?.rowCount && selectedLabware?.colCount >= labware?.colCount;
      let selectedRow = 1;
      let selectedColumn = 1;
      let {rowCount, colCount} = selectedLabware;
      if (type === NormalizationType.FIXED_SAMPLE_VOLUME) {
        // eslint-disable-next-line prefer-destructuring
        selectedRow = normalizedRow;
        selectedColumn = normalizedColumn;
        rowCount = 1;
        colCount = 1;
        isSameOrGreaterPlateDiemensions = true;
      } else if (type === NormalizationType.FIXED_DILUENT_VOLUME && !isSameOrGreaterPlateDiemensions) {
        selectedRow = normalizedRow % 2 === 0 ? 2 : 1;
        selectedColumn = normalizedColumn % 2 === 0 ? 2 : 1;
      }

      hoveredWellStyle[itemID] = labwareBusinessGetWellStyleColor(
        labware.labwareId,
        selectedRow,
        selectedColumn,
        hoverWellColorEnum,
        rowCount,
        colCount,
        null,
        false,
        null,
        null,
        isSameOrGreaterPlateDiemensions ? null : 1,
        isSameOrGreaterPlateDiemensions ? null : 1,
        true,
        true,
        labwareIndex,
      );
      setSelectedWellStyle(hoveredWellStyle);
    };

    const onClickWellNormalization = async (itemID, row, column) => {
      const {toastMessage} = dispatch(isLabwareAllowedForNormalization(itemID));
      if (toastMessage) {
        return;
      }

      const {sampleLabwareID, diluentLabwareID, currentWizardView: step} = normalizationState;
      const labware = labwareState[itemID];
      const diluentLabware = find(labwareState, {LabwareID: diluentLabwareID});

      if (labware.isIFC) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({id: 'protocolEditor.normalization.createNew.disallowIFCLabware'}),
        );
        return;
      }

      if (labware.isSpearBio) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({id: 'protocolEditor.normalization.createNew.disallowSpearBioLabware'}),
        );
        return;
      }

      if (protocolNormalizationTaskEditStep === 1) {
        if (diluentLabware?.LabwareID === labware.LabwareID) {
          appStateActionShowSnackbar(
            Feedback.ERROR,
            intl.formatMessage({id: 'protocolEditor.normalization.createNew.disallowLabware'}),
          );
          return;
        }
        taskListNormalizationRemoveAspirateDispenseTask(false);
      }

      if (step !== NormalizationStep.SET_DILUENT_LABWARE || protocolNormalizationTaskEditStep === 1) {
        return;
      }

      const wellParam = {row, column};

      if (sampleLabwareID === labware?.LabwareID) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({id: 'protocolEditor.normalization.createNew.disallowLabware'}),
        );
        return;
      }

      if (protocolNormalizationTaskEditStep === 3) {
        protocolEditorStateActionSetNormalizationTaskEditStep(null);
        taskListNormalizationRemoveAspirateDispenseTask(true);
      }
      normalizationStateActionSetDiluentWell(wellParam);

      if (protocolNormalizationTaskEditStep === NormalizationStep.SET_DILUENT_LABWARE) {
        dispatch(editNormalizationDiluentPlate(labware));
      } else if (step === NormalizationStep.SET_DILUENT_LABWARE) {
        await taskListNormalizationSelectNormalizationDiluentPlate(labware);
        undoRedoBusinessActionGlobalAddUndoItem();
      }
    };

    const onEditNormalization = (number) => {
      setProtocolEditorMode(ProtocolEditorViewMode.NORMALIZATION);
      protocolEditorStateActionSetNormalizationTaskEditStep(number);
      taskListNormalizationNormalizationEditStep(number);

      switch (number) {
        case 1:
          setNormalizationStep(NormalizationStep.SET_SAMPLE_LABWARE);
          break;
        case 2:
          setNormalizationStep(NormalizationStep.SET_DILUENT_LABWARE);
          break;
        case 3:
          setNormalizationStep(NormalizationStep.UPLOAD_AND_MANAGE_CSV_FILE);
          break;
        default:
          break;
      }
    };

    useEffect(() => {
      if (normalizationState.currentVolume === 0) {
        initialValueVolumeModal.current = 0;
      }
    }, [normalizationState.currentVolume]);

    // #endregion normalization

    // #region broadcast

    const getTaskAspirateBroadcast = (labwareID) =>
      getBroadcastTaskByType(selectedCard, cardStateTasksRef?.current, TaskType.ASPIRATE, labwareID);

    const getTaskDispensesBroadcast = (labwareID) =>
      getBroadcastTaskByType(selectedCard, cardStateTasksRef?.current, TaskType.DISPENSE, labwareID) || [];

    const broadcastTasksRef = useRef({
      ASPIRATE: null,
      DISPENSE: null,
    });
    const broadcastTasksPerLabwareRef = useRef({
      ASPIRATE: null,
      DISPENSE: null,
    });
    const broadcastCurrentLabwareRef = useRef(null);

    const initializeBroadcastTasksPerLabware = (labwareID) => {
      const aspirateTasks = getTaskAspirateBroadcast(labwareID);
      const dispenseTasks = getTaskDispensesBroadcast(labwareID);
      broadcastTasksPerLabwareRef.current = {
        ASPIRATE: aspirateTasks,
        DISPENSE: dispenseTasks,
      };
    };

    const resetAllBroadcastTasksRef = () => {
      broadcastTasksPerLabwareRef.current = {
        ASPIRATE: null,
        DISPENSE: null,
      };
      broadcastTasksRef.current = {
        ASPIRATE: null,
        DISPENSE: null,
      };
      broadcastCurrentLabwareRef.current = null;
    };

    const initializeBroadcastTasks = () => {
      const aspirateTasks = getTaskAspirateBroadcast();
      const dispenseTasks = getTaskDispensesBroadcast();
      broadcastTasksRef.current = {
        ASPIRATE: aspirateTasks,
        DISPENSE: dispenseTasks,
      };
    };

    const getTaskAspirateBroadcastFromRef = (labwareId) => {
      if (!labwareId) {
        return broadcastTasksRef.current.ASPIRATE;
      }

      if (labwareId !== broadcastCurrentLabwareRef.current) {
        return getTaskAspirateBroadcast(labwareId);
      }

      return broadcastTasksPerLabwareRef.current.ASPIRATE;
    };

    const getTaskDispensesBroadcastFromRef = (labwareId) => {
      if (!labwareId) {
        return broadcastTasksRef.current.DISPENSE;
      }

      if (labwareId !== broadcastCurrentLabwareRef.current) {
        return getTaskDispensesBroadcast(labwareId);
      }

      return broadcastTasksPerLabwareRef.current.DISPENSE;
    };

    const getBroadcastTasksFromRef = (labwareId, editStep = null) => {
      const taskAspirates = getTaskAspirateBroadcastFromRef(labwareId);
      const taskDispenses = getTaskDispensesBroadcastFromRef(labwareId);

      let tasks = [];

      if (taskAspirates && editStep !== 1) {
        tasks = [...tasks, taskAspirates];
      }

      if (taskDispenses.length && editStep !== 3) {
        tasks = [...tasks, ...taskDispenses];
      }

      return tasks;
    };

    const showResetBroadcastSourceModal = (cardID, labwareId, row, column, rowTipCount, columnTipCount) => {
      const title = intl.formatMessage({id: 'protocolEditor.broadcast.modal.title'});
      const message = 'protocolEditor.broadcast.modal.text';

      const messageEl = <FormattedHTMLMessage id={message} />;
      const okButtonText = intl.formatMessage({id: 'protocolEditor.broadcast.modal.firstButton'});
      const cancelButtonText = intl.formatMessage({id: 'protocolEditor.broadcast.modal.secondButton'});

      modalStateActionShowModal(
        title,
        messageEl,
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: async () => {
              modalStateActionHideModal();

              cardActionRemoveAllCardTask(cardID);
              protocolEditorStateActionSetBroadcastTaskEditStep(null);
              temporaryStateActionRemoveTemporaryState('broadcastStateBeforeEdit');

              taskListBroadcastBusinessAddBroadcastTask([
                {
                  type: TaskType.ASPIRATE,
                  labwareId,
                  row,
                  column,
                  rowTipCount,
                  columnTipCount,
                },
              ]);

              resetAllBroadcastTasksRef();
              undoRedoBusinessActionGlobalAddUndoItem();
            },
            text: okButtonText,
          },
          {
            className: 'btn-lg',
            style: 'secondary',
            handlerClick: () => modalStateActionHideModal(),
            text: cancelButtonText,
          },
        ],
        () => modalStateActionHideModal(),
        '',
        true,
      );
    };

    // eslint-disable-next-line default-param-last
    const showBroadcastVolumeModal = async (deckNumber = null, skipAddUndoItem = false, updatedVolume) => {
      if (!selectedCard) {
        return;
      }

      const isEdit = !deckNumber && !skipAddUndoItem;

      let currentDeckNumber = deckNumber;
      let currentVolume = updatedVolume ?? 0;

      if (isEdit || skipAddUndoItem) {
        const taskDispenses = getTaskDispensesBroadcast();
        const taskDispenseVolume = taskDispenses[0]?.volume;
        const taskDispenseLabwareId = taskDispenses[0]?.labwareID;

        currentDeckNumber = Object.keys(labwareState).find((e) => labwareState[e].LabwareID === taskDispenseLabwareId);
        currentDeckNumber = parseInt(currentDeckNumber, 10);

        currentVolume = updatedVolume ?? taskDispenseVolume;
      }

      calculateVolumeModalPos(currentDeckNumber);
      setVolumeModalType(VolumeModalType.BROADCAST);

      await protocolEditorStateActionSetVolumeModalOpen(true);
      if (!skipAddUndoItem) {
        undoRedoBusinessActionGlobalAddUndoItem();
      }

      const result = await volumeModalRef.current.show(currentVolume);
      const {volume} = result;

      const parsedVolume = Number.isNaN(parseFloat(volume)) ? 0 : parseFloat(volume);
      const parsedCurrentVolume = Number.isNaN(parseFloat(currentVolume)) ? 0 : parseFloat(currentVolume);

      protocolEditorStateActionSetVolumeModalOpen(false);
      protocolEditorStateActionSetBroadcastTaskEditStep(null);
      if (isEdit) {
        if (!parsedVolume || parsedCurrentVolume === parsedVolume) return;

        const editTaskSuccessMessage = intl.formatMessage({id: 'protocolEditor.broadcast.editTask.successMessage'});
        appStateActionShowSnackbar(Feedback.SUCCESS, editTaskSuccessMessage);
      }

      if (!parsedVolume) {
        await taskListBroadcastBusinessBackHandler();
        return;
      }

      dispatch(onFinishedBroadcastWizard());
      taskListBroadcastBusinessSetBroadcastVolume(parsedVolume);
      undoRedoBusinessActionGlobalAddUndoItem();
    };

    const broadcastVolumeModalChange = (volume) => {
      if (initialValueVolumeModal.current === 0) {
        if (volume !== 0) {
          initialValueVolumeModal.current = volume;
          undoRedoBusinessActionGlobalAddUndoItem(null, {broadcastVolume: volume});
        }
      } else {
        undoRedoBusinessActionGlobalUndoRedoUpdatePresentState('otherState', {broadcastVolume: parseFloat(volume)});
      }
    };

    const getBroadcastTipCount = (isShift = false) => {
      const taskAspirate = getTaskAspirateBroadcastFromRef();

      if (!taskAspirate) {
        return [null, null];
      }

      if (taskAspirate) {
        if (protocolBroadcastTaskEditStep && protocolBroadcastTaskEditStep === 1) {
          return [null, null];
        }

        const taskAspirateLabware = find(labwareStateRef.current, {LabwareID: taskAspirate.labwareID});
        if (!taskAspirateLabware) return [null, null];

        if (taskAspirateLabware.isTrough) {
          if (isShift || taskAspirateLabware.rowCount * taskAspirateLabware.colCount === 1) {
            return [null, null];
          }
          return [
            Math.min(taskAspirate.rowTipCount, taskAspirateLabware.rowCount),
            Math.min(taskAspirate.columnTipCount, taskAspirateLabware.colCount),
          ];
        }

        return [taskAspirate.rowTipCount, taskAspirate.columnTipCount];
      }

      return [null, null];
    };

    const isSwipingBroadcast = () => {
      if (protocolEditorMode !== ProtocolEditorViewMode.BROADCAST) {
        return false;
      }

      return !!swipingInfoRef?.current?.swipingStart;
    };

    const isSwipingAllowedBroadcast = () => true;

    const isLabwareAllowedBroadcast = (labware) => {
      const {isIFC} = labware;

      if (isIFC) {
        return false;
      }
      // allow to select well in different labware when editing aspirate task location
      if (protocolBroadcastTaskEditStep && protocolBroadcastTaskEditStep === 1) {
        return true;
      }

      return true;
    };

    const restrictBroadcastSwipe = (row, column, labwareId, rowTipCount, columnTipCount, skipWellMode, is384) => {
      const taskAspirate = getTaskAspirateBroadcastFromRef(labwareId);
      const {swipingStart, swipingSize} = swipingInfoRef.current;

      let newRow = row;
      let newColumn = column;

      if (taskAspirate) {
        if (protocolBroadcastTaskEditStep && protocolBroadcastTaskEditStep === 1) {
          const taskDispenses = getTaskDispensesBroadcastFromRef(labwareId);
          const highlightedWellDispense = getHighlightedWellFromTask(taskDispenses, skipWellMode);
          const relatedColumns = highlightedWellDispense.filter(
            (e) => swipingStart.row === parseInt(e.split('-')[0], 10),
          );
          const relatedRows = highlightedWellDispense.filter(
            (e) => swipingStart.column === parseInt(e.split('-')[1], 10),
          );
          const columns = relatedColumns.map((e) => parseInt(e.split('-')[1], 10));
          const rows = relatedRows.map((e) => parseInt(e.split('-')[0], 10));

          if (columns.length && (swipingSize?.row === 1 || columns.find((c) => c === column))) {
            const minColumn = Math.min(...columns);
            const maxColumn = Math.max(...columns);
            // swiping down
            if ((swipingStart?.column < column && swipingStart?.column < minColumn) || column === minColumn) {
              newColumn = minColumn - 1;
              return [newRow, newColumn];
            }
            // swiping up
            if (swipingStart?.column > column && swipingStart?.column > maxColumn) {
              newColumn = maxColumn + 1;
              return [newRow, newColumn];
            }
          } else if (rows.length && (swipingSize?.column === 1 || rows.find((r) => r === row))) {
            const minRow = Math.min(...rows);
            const maxRow = Math.max(...rows);
            // swiping left
            if (swipingStart.row < row && swipingStart.row < minRow) {
              newRow = minRow - 1;
              return [newRow, newColumn];
            }
            // swiping right
            if (swipingStart.row > row && swipingStart.row > maxRow) {
              newRow = minRow + 1;
              return [newRow, newColumn];
            }
          }

          return [newRow, newColumn];
        }
        const newRowTipCount = rowTipCount * (is384 ? 2 : 1);
        const newColumnTipCount = columnTipCount * (is384 ? 2 : 1);

        const actualRowSize = Math.abs(row - swipingStart.row) + (swipingStart.row > row ? 0 : 1);
        const actualColumnSize = Math.abs(column - swipingStart.column) + (swipingStart.column > column ? 0 : 1);

        let rowSize = Math.ceil(actualRowSize / newRowTipCount) * newRowTipCount;
        let columnSize = Math.ceil(actualColumnSize / newColumnTipCount) * newColumnTipCount;

        const startRow = swipingStart.row <= row ? swipingStart.row : swipingStart.row - rowSize;
        const startColumn = swipingStart.column <= column ? swipingStart.column : swipingStart.column - columnSize;

        if (swipingStart.row > row) {
          rowSize += newRowTipCount;
        }

        if (swipingStart.column > column) {
          columnSize += newColumnTipCount;
        }

        const highlightedWellAspirate = getHighlightedWellFromTask([taskAspirate], skipWellMode);
        const highlightedWell = getHighlightedWell(startRow, startColumn, rowSize, columnSize, skipWellMode);

        const isIntersectionRow = highlightedWellAspirate.some((well) =>
          highlightedWell.find((e) => well.split('-')[0] === e.split('-')[0]),
        );
        const isIntersectionColumn = highlightedWellAspirate.some((well) =>
          highlightedWell.find((e) => well.split('-')[1] === e.split('-')[1]),
        );

        const aspirateTaskRow = convertRowToNumeric(taskAspirate.row);
        const minAspirateRow = aspirateTaskRow;
        const maxAspirateRow = aspirateTaskRow + newRowTipCount - (is384 ? 2 : 1);
        const minAspirateColumn = taskAspirate.column;
        const maxAspirateColumn = taskAspirate.column + newColumnTipCount - (is384 ? 2 : 1);

        // swiping left
        if (swipingStart.row < row) {
          const mostLeftRow =
            swipingStart.row - 1 + Math.ceil((row - swipingStart.row + 1) / newRowTipCount) * newRowTipCount;

          if (isIntersectionColumn && swipingStart.row < minAspirateRow && minAspirateRow <= mostLeftRow) {
            newRow = minAspirateRow - newRowTipCount;
            if (newRow < swipingStart.row) {
              newRow = swipingStart.row;
            }
          }
        }

        // swiping right
        if (swipingStart.row > row) {
          const mostRightRow = swipingStart.row - Math.ceil((swipingStart.row - row) / newRowTipCount) * newRowTipCount;

          if (isIntersectionColumn && swipingStart.row > maxAspirateRow && maxAspirateRow >= mostRightRow) {
            newRow = maxAspirateRow + newRowTipCount;
            if (newRow > swipingStart.row) {
              newRow = swipingStart.row;
            }
          }
        }

        // swiping down
        if (swipingStart.column < column) {
          const mostDownColumn =
            swipingStart.column -
            1 +
            Math.ceil((column - swipingStart.column + 1) / newColumnTipCount) * newColumnTipCount;
          if (isIntersectionRow && swipingStart.column < minAspirateColumn && minAspirateColumn <= mostDownColumn) {
            newColumn = minAspirateColumn - newColumnTipCount;
            if (newColumn < swipingStart.column) {
              newColumn = swipingStart.column;
            }
          }
        }

        // swiping up
        if (swipingStart.column > column) {
          const mostUpColumn =
            swipingStart.column - Math.ceil(swipingStart.column - column / newColumnTipCount) * newColumnTipCount;
          if (isIntersectionRow && swipingStart.column > maxAspirateColumn && maxAspirateColumn >= mostUpColumn) {
            newColumn = maxAspirateColumn + newColumnTipCount;
            if (newColumn > swipingStart.column) {
              newColumn = swipingStart.column;
            }
          }
        }
      }
      return [newRow, newColumn];
    };

    const normalizeSwipingDirection = (column, row, swipingDirectionX, swipingDirectionY, tipCount) => {
      let newSwipeDirectionY = swipingDirectionY;
      let newSwipeDirectionX = swipingDirectionX;

      if (tipCount.column === 1 && tipCount.row > 1) {
        if (!newSwipeDirectionY) {
          newSwipeDirectionY =
            column < swipingInfoRef.current.swipingStart.column ? SWIPING_DIRECTION_Y.UP : SWIPING_DIRECTION_Y.DOWN;
        }
        newSwipeDirectionX = null;
      }

      if (tipCount.row === 1 && tipCount.column > 1) {
        if (!newSwipeDirectionX) {
          newSwipeDirectionX =
            row > swipingInfoRef.current.swipingStart.row ? SWIPING_DIRECTION_X.LEFT : SWIPING_DIRECTION_X.RIGHT;
        }
        newSwipeDirectionY = null;
      }

      return [newSwipeDirectionX, newSwipeDirectionY];
    };

    const isBroadcastNotAllowed = (
      labwareId,
      row,
      column,
      normalizedRow,
      normalizedColumn,
      rowTipCount,
      columnTipCount,
      skipWellMode,
    ) => {
      const taskAspirate = getTaskAspirateBroadcastFromRef(labwareId);
      const taskDispenses = getTaskDispensesBroadcastFromRef(labwareId);

      const broadcastTaskEditStep = protocolBroadcastTaskEditStep;

      let highlightedWell = [];

      if (taskAspirate && broadcastTaskEditStep !== 1) {
        const highlightedWellAspirate = getHighlightedWellFromTask([taskAspirate], skipWellMode);
        highlightedWell = _.concat(highlightedWell, highlightedWellAspirate);

        if (highlightedWellAspirate.includes(`${row}-${column}`)) {
          return true;
        }
      }

      if (taskDispenses.length) {
        const highlightedWellDispense = getHighlightedWellFromTask(taskDispenses, skipWellMode);
        highlightedWell = _.concat(highlightedWell, highlightedWellDispense);

        if (highlightedWellDispense.includes(`${row}-${column}`)) {
          if (broadcastTaskEditStep === 1) {
            return true;
          }
          return false;
        }
      }

      const wellFromTask = getHighlightedWell(
        normalizedRow,
        normalizedColumn,
        rowTipCount,
        columnTipCount,
        skipWellMode,
      );

      return wellFromTask.some((well) => highlightedWell.includes(well));
    };

    const getRelatedBroadcastPickTipAndAspirateTask = (
      // eslint-disable-next-line default-param-last
      taskDispenseIds = [],
      isReuseTips,
      isAddNewDispense,
      taskDispenses,
    ) => {
      const taskIds = [];

      taskDispenseIds.forEach((id, index) => {
        if (!isReuseTips) {
          const pickTipsTaskId = id - 2;
          const ejectTipsTaskId = id + 1;
          const aspirateTaskId = id - 1;

          if (isAddNewDispense || (taskDispenses.length && taskDispenseIds.length - index !== taskDispenses.length)) {
            taskIds.push(pickTipsTaskId);
            taskIds.push(aspirateTaskId);
          }

          taskIds.push(ejectTipsTaskId);
        }
      });

      return taskIds;
    };

    const onHoverWellBroadcast = (itemID, row, column, labwareIndex, isCtrl, isShift) => {
      const labware = labwareStateRef.current[itemID];
      const {LabwareID: labwareId} = labware;

      if (isSwipingBroadcast() || !isLabwareAllowedBroadcast(labware)) {
        setSelectedWellStyle({[itemID]: {}});

        return;
      }

      if (broadcastCurrentLabwareRef.current !== labwareId) {
        broadcastCurrentLabwareRef.current = labwareId;
        initializeBroadcastTasksPerLabware(labwareId);
      }

      if (!broadcastTasksRef.current.ASPIRATE) {
        initializeBroadcastTasks();
      }

      const taskAspirate = getTaskAspirateBroadcastFromRef();
      const taskAspirateLabware = find(labwareStateRef.current, {LabwareID: taskAspirate?.labwareID});

      if (!taskAspirateLabware) {
        return;
      }

      if (
        checkIs24Or48WellLabware(labware) &&
        taskAspirate &&
        (taskAspirate?.columnTipCount !== 1 || taskAspirate?.rowTipCount !== 1)
      ) {
        return;
      }

      const isSingleWellAspirate =
        (taskAspirateLabware.rowCount === 1 && taskAspirate.columnTipCount === 1) ||
        (taskAspirateLabware.colCount === 1 && taskAspirate.rowTipCount === 1) ||
        (taskAspirateLabware.rowCount === 1 && taskAspirateLabware.colCount === 1);

      const [rowTipCount, columnTipCount] = getBroadcastTipCount(isSingleWellAspirate && isShift);

      const [skipWellMode] = getSkipWellMode(
        rowTipCount,
        columnTipCount,
        taskAspirate && isShift && protocolBroadcastTaskEditStep !== 1,
        isLabware384(labware),
      );

      const [minPosition, maxPosition] = getMinMaxPositionFromTaskList(
        getBroadcastTasksFromRef(labwareId),
        row,
        column,
        labware,
        skipWellMode,
      );

      const [normalizedRow, normalizedColumn] = normalizeHighlightedWell(
        row,
        column,
        {row: rowTipCount, column: columnTipCount},
        labware,
        labwareIndex,
        false,
        maxPosition,
        minPosition,
        getTaskDispensesBroadcastFromRef(labwareId),
        skipWellMode,
      );

      if (
        isBroadcastNotAllowed(
          labwareId,
          row,
          column,
          normalizedRow,
          normalizedColumn,
          rowTipCount,
          columnTipCount,
          skipWellMode,
        )
      ) {
        setSelectedWellStyle({[itemID]: {}});

        return;
      }

      setSelectedWellStyle({
        [itemID]: labwareBusinessGetWellStyleColor(
          labwareId,
          normalizedRow,
          normalizedColumn,
          hoverWellColorEnum,
          rowTipCount ?? 1,
          columnTipCount ?? 1,
          null,
          false,
          null,
          null,
          null,
          null,
          true,
          true,
          labwareIndex,
        ),
      });

      if (protocolVolumeModalOpen) calculateVolumeModalPos(itemID);
    };

    const onSwipeStartBroadcast = (itemID, row, column, isCtrl, isShift) => {
      const labware = labwareState[itemID];
      const {LabwareID: labwareId, isIFC} = labware;

      if (isIFC) {
        return;
      }

      if (!broadcastTasksRef.current.ASPIRATE) {
        initializeBroadcastTasks();
      }

      const taskAspirate = getTaskAspirateBroadcastFromRef();

      if (taskAspirate) {
        ctrlPressedRef.current = isCtrl;
      }

      const taskAspirateLabware = find(labwareState, {LabwareID: taskAspirate?.labwareID});
      const isSingleWellAspirate =
        (taskAspirateLabware.rowCount === 1 && taskAspirate.columnTipCount === 1) ||
        (taskAspirateLabware.colCount === 1 && taskAspirate.rowTipCount === 1) ||
        (taskAspirateLabware.rowCount === 1 && taskAspirateLabware.colCount === 1);

      const [rowTipCount, columnTipCount] = getBroadcastTipCount(isSingleWellAspirate && isShift);

      const [skipWellMode] = getSkipWellMode(
        rowTipCount,
        columnTipCount,
        taskAspirate && isShift && protocolBroadcastTaskEditStep !== 1,
        isLabware384(labware),
      );

      const [minPosition, maxPosition] = getMinMaxPositionFromTaskList(
        getBroadcastTasksFromRef(labwareId),
        row,
        column,
        labware,
        skipWellMode,
      );

      const [normalizedRow, normalizedColumn] = !taskAspirate
        ? [row, column]
        : normalizeHighlightedWell(
            row,
            column,
            {row: rowTipCount, column: columnTipCount},
            labware,
            0,
            false,
            maxPosition,
            minPosition,
            getTaskDispensesBroadcastFromRef(labwareId),
            skipWellMode,
          );

      if (
        isBroadcastNotAllowed(
          labwareId,
          row,
          column,
          normalizedRow,
          normalizedColumn,
          rowTipCount,
          columnTipCount,
          skipWellMode,
        )
      ) {
        return;
      }

      swipingInfoRef.current = initSwipingInfo(normalizedRow, normalizedColumn, labware);
    };

    const onSwipeMoveBroadcast = (itemID, row, column, swipingDirectionY, swipingDirectionX, isCtrl, isShift) => {
      if (!swipingInfoRef.current) {
        return;
      }

      const labware = labwareStateRef.current[itemID];
      let {LabwareID: labwareId} = labware;

      if (!isSwipingAllowedBroadcast() || !isLabwareAllowedBroadcast(labware)) {
        resetSwipingInfo();
        return;
      }

      const taskAspirate = getTaskAspirateBroadcastFromRef();
      const taskAspirateLabware = find(labwareStateRef.current, {LabwareID: taskAspirate?.labwareID});

      const isSingleWellAspirate =
        (taskAspirateLabware.rowCount === 1 && taskAspirate.columnTipCount === 1) ||
        (taskAspirateLabware.colCount === 1 && taskAspirate.rowTipCount === 1) ||
        (taskAspirateLabware.rowCount === 1 && taskAspirateLabware.colCount === 1);

      if (checkIs24Or48WellLabware(labware)) {
        return;
      }

      const [rowTipCount, columnTipCount] = getBroadcastTipCount(isSingleWellAspirate && isShift);

      const [skipWellMode, noSkip] = getSkipWellMode(
        rowTipCount,
        columnTipCount,
        taskAspirate && isShift && protocolBroadcastTaskEditStep !== 1,
        isLabware384(labware),
      );

      let [normalizedRow, normalizedColumn] = [row, column];
      const broadcastTask =
        taskAspirate && rowTipCount === 1 && columnTipCount === 1
          ? getTaskDispensesBroadcastFromRef(labwareId)
          : getBroadcastTasksFromRef(labwareId);

      let deckID = itemID;
      const startingLabwareId = swipingInfoRef.current?.labware.LabwareID;

      if (labwareId === startingLabwareId || !startingLabwareId) {
        [normalizedRow, normalizedColumn] = restrictBroadcastSwipe(
          normalizedRow,
          normalizedColumn,
          labwareId,
          rowTipCount,
          columnTipCount,
          skipWellMode,
          isLabware384(labware),
        );

        const newSwipingInfo = updateSwipingInfo(
          swipingInfoRef.current,
          {row: rowTipCount, column: columnTipCount},
          swipingInfoRef.current.swipingStart,
          {row: normalizedRow, column: normalizedColumn},
          swipingDirectionY,
          swipingDirectionX,
          broadcastTask,
        );

        if (!newSwipingInfo) {
          resetSwipingInfo();

          return;
        }

        swipingInfoRef.current = newSwipingInfo;
      } else {
        // prevent swiping cross labware
        labwareId = startingLabwareId;
        deckID = Object.keys(labwareState).find((e) => labwareState[e].LabwareID === labwareId);
      }

      const [normalizedSwipingStart, , normalizedSwipingSize, skipWell] = normalizeSwipingInfo(
        swipingInfoRef.current,
        skipWellMode,
        noSkip,
      );

      setSelectedWellStyle({
        [deckID]: labwareBusinessGetWellStyleColor(
          labwareId,
          normalizedSwipingStart.row,
          normalizedSwipingStart.column,
          hoverWellColorEnum,
          normalizedSwipingSize.row,
          normalizedSwipingSize.column,
          null,
          false,
          null,
          null,
          skipWell.row,
          skipWell.column,
          true,
        ),
      });
    };

    const onSwipeEndBroadcast = async (itemID, isCtrl, isShift) => {
      const labware = labwareState[itemID];
      const {LabwareID: labwareId} = labware;

      if (labware.isIFC) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({
            id: 'protocolEditor.broadcast.createNew.disallowIFCLabware',
          }),
        );

        return;
      }

      if (!isLabwareAllowedBroadcast(labware)) {
        appStateActionShowSnackbar(Feedback.ERROR, intl.formatMessage({id: 'protocolEditor.broadcast.disallowWell'}));

        return;
      }

      if (!swipingInfoRef.current || !enableHighlightTaskRef.current) {
        return;
      }

      const {swipingDirectionY, swipingDirectionX, isRestricted} = swipingInfoRef.current;

      if (isRestricted) {
        return;
      }

      setSelectedWellStyle({});
      const taskAspirate = getTaskAspirateBroadcast();
      const taskDispenses = getTaskDispensesBroadcast();

      const taskAspirateLabware = find(labwareState, {LabwareID: taskAspirate?.labwareID});

      if (
        checkIs24Or48WellLabware(labware) &&
        taskAspirate &&
        (taskAspirate.columnTipCount !== 1 || taskAspirate.rowTipCount !== 1)
      ) {
        dispatch(
          showSnackbar(
            Feedback.ERROR,
            intl.formatMessage(
              {
                id: 'protocolEditor.virtualTray.tooltip.incompatiblity.24And48Well',
              },
              {
                labwareLabel: getMicroplateLabel(labware.labwareLabel),
                selectedToolTip: `${taskAspirate.columnTipCount} x ${taskAspirate.rowTipCount}`,
              },
            ),
          ),
        );
        return;
      }

      const isSingleWellAspirate =
        (taskAspirateLabware.rowCount === 1 && taskAspirate.columnTipCount === 1) ||
        (taskAspirateLabware.colCount === 1 && taskAspirate.rowTipCount === 1) ||
        (taskAspirateLabware.rowCount === 1 && taskAspirateLabware.colCount === 1);

      const [rowTipCount, columnTipCount] = getBroadcastTipCount(isSingleWellAspirate && isShift);

      const [normalizedSwipingStart, , normalizedSwipingSize] = normalizeSwipingInfo(
        swipingInfoRef.current,
        SKIP_WELL_MODE.ALL,
        taskAspirate && isShift && protocolBroadcastTaskEditStep !== 1,
      );

      const isToggling = !swipingDirectionY && !swipingDirectionX;

      const newAspirateRowTipCount = isToggling ? 1 : normalizedSwipingSize.row;
      const newAspirateColumnTipCount = isToggling ? 1 : normalizedSwipingSize.column;

      const isRedefine =
        protocolBroadcastTaskEditStep &&
        protocolBroadcastTaskEditStep === 1 &&
        taskAspirate &&
        ((taskAspirate.rowTipCount !== newAspirateRowTipCount && labware.rowCount !== 1) ||
          (taskAspirate.columnTipCount !== newAspirateColumnTipCount && labware.colCount !== 1)) &&
        !(labware.rowCount === 1 && labware.colCount === 1);

      if (!taskAspirate || isRedefine) {
        const broadcastSourceTask = {
          row: normalizedSwipingStart.row,
          column: normalizedSwipingStart.column,
          rowTipCount: newAspirateRowTipCount,
          columnTipCount: newAspirateColumnTipCount,
          labwareId,
          type: TaskType.ASPIRATE,
        };

        if (isRedefine) {
          showResetBroadcastSourceModal(
            selectedCard?.ID,
            labwareId,
            broadcastSourceTask.row,
            broadcastSourceTask.column,
            broadcastSourceTask.rowTipCount,
            broadcastSourceTask.columnTipCount,
          );
          return;
        }

        taskListBroadcastBusinessAddBroadcastTask([broadcastSourceTask]);

        resetAllBroadcastTasksRef();
        undoRedoBusinessActionGlobalAddUndoItem();
        return;
      }

      // editing aspirate task location
      if (protocolBroadcastTaskEditStep && protocolBroadcastTaskEditStep === 1) {
        /* eslint-disable-next-line */

        taskListBroadcastBusinessBatchEditBroadcastAspirateTasks(
          normalizedSwipingStart.row,
          normalizedSwipingStart.column,
          labwareId,
          true,
        );

        const isReuseTips = selectedCard && 'reuseTips' in selectedCard ? selectedCard.reuseTips : false;

        taskListBroadcastBusinessOptimizeBroadcastCard(
          false,
          taskAspirateLabware,
          true,
          taskAspirateLabware.isTrough,
          isReuseTips,
        );
        resetAllBroadcastTasksRef();
        undoRedoBusinessActionGlobalAddUndoItem();
        return;
      }

      const isReuseTips = selectedCard && 'reuseTips' in selectedCard ? selectedCard.reuseTips : false;

      const aspirateSize = {
        row:
          taskAspirate.rowTipCount > taskAspirateLabware.rowCount
            ? taskAspirateLabware.rowCount
            : taskAspirate.rowTipCount,
        column:
          taskAspirate.columnTipCount > taskAspirateLabware.colCount
            ? taskAspirateLabware.colCount
            : taskAspirate.columnTipCount,
      };

      const [skipWellMode, noSkip] = getSkipWellMode(rowTipCount, columnTipCount, isShift, isLabware384(labware));

      let optimizeMode = null;
      if (isShift) {
        if (taskAspirateLabware.rowCount === 1 && taskAspirateLabware.colCount === 1) {
          optimizeMode = OPTIMIZE_MODE.ALL;
        } else if (taskAspirateLabware.rowCount === 1 && taskAspirateLabware.colCount !== 1) {
          optimizeMode = OPTIMIZE_MODE.ROW;
        } else if (taskAspirateLabware.rowCount !== 1 && taskAspirateLabware.colCount === 1) {
          optimizeMode = OPTIMIZE_MODE.COLUMN;
        }
      }

      // define dispense broadcast
      const rowColumnList = generateRowColumnsListFromSwipingInfo(
        swipingInfoRef.current,
        skipWellMode,
        noSkip,
        (isSingleWellAspirate && !optimizeMode) ||
          taskAspirate.rowTipCount * taskAspirate.columnTipCount === 1 ||
          (taskAspirateLabware.rowCount === 1 && taskAspirateLabware.colCount === 1)
          ? {}
          : aspirateSize,
        optimizeMode,
        isSingleWellAspirate && !isLabware384(labware) && !isToggling,
      );

      const [rowColumnListToAdd, taskIdToRemove] = normalizeRowColoumnList({
        rowColumnList,
        taskDispenses: getTaskDispensesBroadcastFromRef(labwareId),
        isNeedOptimize: taskAspirateLabware.isTrough,
        is384: isLabware384(labware),
        skipWellMode,
        labwareState,
      });

      if (rowColumnListToAdd.startingRowColumnList.length) {
        taskListBroadcastBusinessAddBroadcastDispenseTasks(
          labwareId,
          rowColumnListToAdd.startingRowColumnList,
          rowColumnListToAdd.tipCount.row,
          rowColumnListToAdd.tipCount.column,
          true,
        );
      }

      if (taskIdToRemove.length) {
        const relatedPickTipAndAspirateTaskIds = getRelatedBroadcastPickTipAndAspirateTask(
          taskIdToRemove,
          isReuseTips,
          !!rowColumnListToAdd.startingRowColumnList.length,
          taskDispenses,
        );

        cardStateActionRemoveCardTasks(selectedCard?.ID, [...relatedPickTipAndAspirateTaskIds, ...taskIdToRemove]);
        dispatch(restoreTipCountForSingleCard(selectedCard?.ID));

        if (!rowColumnListToAdd.startingRowColumnList.length) {
          taskListBusinessSmarterDefaultDispenseTipPosition([labwareId]);
        }
        if (taskDispenses.length === taskIdToRemove.length && !rowColumnListToAdd.startingRowColumnList.length) {
          volumeModalRef.current.hide();

          protocolEditorStateActionSetVolumeModalOpen(false);
          // eslint-disable-next-line no-unsafe-optional-chaining
          const defaultAspirateVolume = taskAspirate?.volume / taskIdToRemove.length;
          taskListBroadcastBusinessSetBroadcastAspirateVolume(defaultAspirateVolume);
          resetAllBroadcastTasksRef();
          return;
        }
      }

      resetAllBroadcastTasksRef();
      // undoRedoBusinessActionGlobalAddUndoItem();

      if (protocolBroadcastTaskEditStep) {
        // update aspirate task volume
        if (isReuseTips && taskDispenses.length) {
          taskListBroadcastBusinessSetBroadcastAspirateVolume();
        }
        undoRedoBusinessActionGlobalAddUndoItem();
        // eslint-disable-next-line no-useless-return
        return;
      }
      if (!ctrlPressedRef.current || !isCtrl) {
        const labwareDeckNumber = Object.keys(labwareState).find((e) => labwareState[e].LabwareID === labwareId);
        await showBroadcastVolumeModal(labwareDeckNumber);
      } else {
        undoRedoBusinessActionGlobalAddUndoItem();
      }
    };

    const onEditBroadcastTask = (number) => {
      taskListBroadcastBusinessSaveBroadcastStateBeforeEdit();
      protocolEditorStateActionSetBroadcastTaskEditStep(number);

      if (number === 1 || number === 2) {
        setProtocolEditorMode(ProtocolEditorViewMode.BROADCAST);

        return;
      }

      if (number === 3) {
        showBroadcastVolumeModal(null);
      }
    };

    const onDeleteBroadcastCard = () => {
      volumeModalRef.current.hide();

      protocolEditorStateActionSetVolumeModalOpen(false);
      resetAllBroadcastTasksRef();
    };

    const onBroadcastHeaderBack = () => {
      onDeleteBroadcastCard();
    };

    const onBroadcastHeaderCancel = () => {
      onDeleteBroadcastCard();

      if (!protocolBroadcastTaskEditStep) {
        return;
      }

      taskListBroadcastBusinessRestoreBroadcastStateAfterCancelEdit();
    };

    const onBroadcastHeaderCancelEdit = () => {
      if (!protocolBroadcastTaskEditStep) {
        return;
      }

      taskListBroadcastBusinessRestoreBroadcastStateAfterCancelEdit();
      resetAllBroadcastTasksRef();
    };

    const onCtrlKeyReleaseBroadcast = () => {
      ctrlPressedRef.current = false;

      const taskDispenses = getTaskDispensesBroadcast();

      if (taskDispenses.length && !protocolVolumeModalOpen && !protocolBroadcastTaskEditStep) {
        const lastDispenseTask = taskDispenses[taskDispenses.length - 1];

        const {labwareID} = lastDispenseTask;

        const labwareDeckNumber = Object.keys(labwareState).find((e) => labwareState[e].LabwareID === labwareID);
        showBroadcastVolumeModal(labwareDeckNumber, protocolVolumeModalOpen);
      }
    };

    const onShiftKeyReleaseBroadcast = () => {
      if (shiftPressedRef.current === true) {
        const aspirateTask = getTaskAspirateBroadcast();
        if (swipingInfoRef?.current && aspirateTask && protocolBroadcastTaskEditStep !== 1) {
          reInitializeWellStyleOnShiftChange(false);
        }
        shiftPressedRef.current = false;
      }
    };

    const onShiftKeyPressBroadcast = () => {
      if (shiftPressedRef.current === false) {
        const aspirateTask = getTaskAspirateBroadcast();
        if (swipingInfoRef?.current && aspirateTask && protocolBroadcastTaskEditStep !== 1) {
          reInitializeWellStyleOnShiftChange(true);
        }
        shiftPressedRef.current = true;
      }
    };

    // #endregion broadcast

    // #region simple transfer

    function simpleTransferHideVolumeModal() {
      dispatch(hideAspirateDispenseVolumeModal());
      protocolEditorStateActionSetADModalShown(false);
      setSelectedWellStyle({});
      previousSelectedTask.current = null;
      focusedSimpleTransferTaskInfo.current = null;

      dispatch(setFocusedDeckNumber(null));
    }

    function onHoverWellSimpleTransfer(itemID, row, column, labwareIndex) {
      if (simpleTransferEditedType === TaskType.PICK_TIP) {
        return;
      }

      if (hoveredLabwareId !== itemID && focusedDeckNumber) {
        setHoveredLabwareId(itemID);
      }
      let tipChannel = protocolSelectedTipChannel;

      if (!tipChannel) {
        setSelectedWellStyle({[itemID]: {}});

        return;
      }
      const labware = labwareState[itemID];

      let [rowTipCount, columnTipCount] = getTipCount(tipChannel);

      if (
        (protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_CUSTOM ||
          protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_96) &&
        protocolCustomTipCount?.row &&
        protocolCustomTipCount?.column
      ) {
        rowTipCount = protocolCustomTipCount.row;
        columnTipCount = protocolCustomTipCount.column;
        tipChannel = null;
      }

      if (!is24Or48WellLabwareAllowed(rowTipCount, columnTipCount, labware)) {
        return;
      }

      const hoveredWellStyle = {
        [itemID]: {},
      };

      const [normalizedRow, normalizedColumn] = normalizeHighlightedWell(
        row,
        column,
        {row: rowTipCount, column: columnTipCount},
        labware,
        labwareIndex,
      );

      // TODO: check if SpearBio plate is allowed
      if (row && column && (!labwareIndex || isIFCLabwareAllowed(rowTipCount, columnTipCount, labware, labwareIndex))) {
        hoveredWellStyle[itemID] = labwareBusinessGetWellStyleColor(
          labwareState[itemID].LabwareID,
          normalizedRow,
          normalizedColumn,
          hoverWellColorEnum,
          rowTipCount,
          columnTipCount,
          tipChannel,
          null,
          null,
          null,
          null,
          null,
          null,
          true,
          labwareIndex,
        );
      }

      if (!focusedSimpleTransferTaskInfo.current) {
        setSelectedWellStyle(hoveredWellStyle);

        return;
      }

      const {
        itemID: focusedTaskItemID,
        labwareId: focusedTaskLabwareId,
        row: focusedTaskRow,
        column: focusedTaskColumn,
        rowTipCount: focusedTaskRowTipCount,
        columnTipCount: focusedTaskColumnTipCount,
        tipChannel: focusedTaskTipChannel,
        labwareIndex: focusedTaskLabwareIndex,
      } = focusedSimpleTransferTaskInfo.current;

      const focusedWellStyle = labwareBusinessGetWellStyleColor(
        focusedTaskLabwareId,
        focusedTaskRow,
        focusedTaskColumn,
        hoverWellColorEnum,
        focusedTaskRowTipCount,
        focusedTaskColumnTipCount,
        focusedTaskTipChannel,
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        focusedTaskLabwareIndex,
      );

      if (focusedTaskItemID !== itemID) {
        hoveredWellStyle[focusedTaskItemID] = focusedWellStyle;
      } else {
        // merge focused well and hovered well's style
        Object.keys(focusedWellStyle).forEach((e) => {
          if (!(e in hoveredWellStyle)) {
            hoveredWellStyle[itemID][e] = focusedWellStyle[e];
          }
        });
      }

      setSelectedWellStyle(hoveredWellStyle);
    }

    const onApplySDAspirateDispenseModal = (clickPosition) => {
      const deckKeys = Object.keys(deckLabwareRefs);
      let isClickedOnLabware = false;

      if (clickPosition) {
        for (let i = 0; i < deckKeys?.length; i += 1) {
          const k = deckKeys[i];
          if (i !== 1 && deckLabwareRefs[k]?.current && deckLabwareRefs[k].current?.contains(clickPosition)) {
            isClickedOnLabware = true;
            break;
          }
        }
      }

      if (!isClickedOnLabware) {
        unselectCard.current = true;
      }
    };

    const onChangeVolumeADModal = (volume) => {
      simpleTransferVolume.current = parseFloat(volume);
    };

    async function onClickWellSimpleTransfer(itemID, row, column, labwareIndex) {
      if (!protocolSelectedTipChannel || simpleTransferEditedType === TaskType.PICK_TIP) {
        return;
      }

      if (previousSelectedTask.current != null) {
        cardActionSetTaskIsSelected(previousSelectedTask.current, true);
      }

      const editingTask = find(cardStateTasks, {
        isSelected: true,
        type: [TaskType.ASPIRATE, TaskType.DISPENSE, TaskType.MIXING],
      });
      const pickTipTask = find(cardStateTasks, {ID: selectedCard.tasks, type: TaskType.PICK_TIP});
      const isAddingNewTaskByInsertTaskButton = selectedCard.isInsertTask;

      const targetedLabware = labwareState[itemID];

      await dispatch(AspirateDispenseVolumeModalBusiness.apply());

      if (!isAddingNewTaskByInsertTaskButton && (editingTask || previousSelectedTask.current)) {
        const editTask = !editingTask ? cardStateTasks[previousSelectedTask.current] : editingTask;
        previousSelectedTask.current = null;

        const rowTipCount = pickTipTask.rowTipCount ?? editTask.rowTipCount;
        const columnTipCount = pickTipTask.columnTipCount ?? editTask.columnTipCount;

        if (!is24Or48WellLabwareAllowed(rowTipCount, columnTipCount, targetedLabware)) {
          return;
        }

        if (labwareIndex) {
          if (!isIFCLabwareAllowed(rowTipCount, columnTipCount, targetedLabware, labwareIndex)) {
            return;
          }
        }

        const [normalizedRow, normalizedColumn] = normalizeHighlightedWell(
          row,
          column,
          {row: rowTipCount, column: columnTipCount},
          targetedLabware,
          labwareIndex,
        );

        const taskEditResult = taskListBusinessEditWellTargetTask(
          editTask.ID,
          labwareState[itemID].LabwareID,
          protocolSelectedTipChannel,
          normalizedRow,
          normalizedColumn,
          selectedCard.ID,
          protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_96 ||
            protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_CUSTOM
            ? protocolCustomTipCount
            : null,
          targetedLabware?.isSpearBio ? 0 : labwareIndex,
        );

        await dispatch(onEditSimpleTransferHandler(taskEditResult, selectedCard.ID));
        return;
      }

      let temporaryNewTask = {labwareID: targetedLabware.LabwareID};
      const uncompleteMixingTask = dispatch(getUncompleteMixingTask());

      if (selectedCard.isInsertTask) {
        const insertTask = find(cardStateTasks, {
          ID: selectedCard?.tasks,
          type: TaskType.INSERT_TASK,
        });

        temporaryNewTask = {...temporaryNewTask, ...insertTask};
      } else {
        temporaryNewTask = {
          number: Object.keys(cardStateTasks).length + 1,
          type: TaskType.ASPIRATE,
          volume: 0,
          labwareID: targetedLabware.LabwareID,
        };
      }

      if (uncompleteMixingTask) {
        temporaryNewTask = {...temporaryNewTask, ...uncompleteMixingTask};
      }

      let tipChannel = protocolSelectedTipChannel;
      let [rowTipCount, columnTipCount] = getTipCount(tipChannel);

      if (
        (protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_96 ||
          protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_CUSTOM) &&
        protocolCustomTipCount?.row &&
        protocolCustomTipCount?.column
      ) {
        rowTipCount = protocolCustomTipCount.row;
        columnTipCount = protocolCustomTipCount.column;
        tipChannel = null;
      }

      const labware = labwareState[itemID];
      const labwareId = labware.LabwareID;

      if (!is24Or48WellLabwareAllowed(rowTipCount, columnTipCount, labware)) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage(
            {
              id: 'protocolEditor.virtualTray.tooltip.incompatiblity.24And48Well',
            },
            {
              labwareLabel: getMicroplateLabel(labware.labwareLabel),
              selectedToolTip: getTipCountInString(protocolSelectedTipChannel, protocolCustomTipCount),
            },
          ),
        );
        return;
      }

      if (labwareIndex) {
        if (!isIFCLabwareAllowed(rowTipCount, columnTipCount, labware, labwareIndex)) {
          appStateActionShowSnackbar(
            Feedback.ERROR,
            intl.formatMessage(
              {
                id: 'protocolEditor.virtualTray.tooltip.incompatiblity',
              },
              {
                selectedToolTip: getTipCountInString(protocolSelectedTipChannel, protocolCustomTipCount),
              },
            ),
          );
          return;
        }
      }

      const [normalizedRow, normalizedColumn] = normalizeHighlightedWell(
        row,
        column,
        {row: rowTipCount, column: columnTipCount},
        labware,
        labwareIndex,
      );

      focusedSimpleTransferTaskInfo.current = {
        itemID,
        labwareId,
        row: normalizedRow,
        column: normalizedColumn,
        rowTipCount,
        columnTipCount,
        tipChannel,
        labwareIndex,
      };

      dispatch(setFocusedDeckNumber(itemID));

      setSelectedWellStyle({
        [itemID]: labwareBusinessGetWellStyleColor(
          labwareId,
          normalizedRow,
          normalizedColumn,
          hoverWellColorEnum,
          rowTipCount,
          columnTipCount,
          tipChannel,
          null,
          null,
          null,
          null,
          null,
          null,
          true,
          labwareIndex,
        ),
      });

      const onApplyVolumeCallback = async (result) => {
        focusedSimpleTransferTaskInfo.current = null;
        dispatch(setFocusedDeckNumber(null));

        setSelectedWellStyle({});

        if (!result) {
          await dispatch(hideAspirateDispenseVolumeModal());
          return;
        }

        const {taskType, volume} = result;

        if (!volume) {
          await dispatch(hideAspirateDispenseVolumeModal());
          return;
        }

        /*
          save aspirate dispense modal state (volume, etc) right before the new task was added
          this is done so that when user did undo, the task won't instantly disappear and the user will have the chance to edit the volume first because the volume modal will be opened
        */
        const stateToSave = {simpleTransferTaskInfo: focusedSimpleTransferTaskInfo.current};
        undoRedoBusinessActionGlobalAddUndoItem(null, stateToSave);

        taskListBusinessAddTask(
          taskType,
          protocolSelectedTipChannel,
          labwareId,
          normalizedRow,
          normalizedColumn,
          volume,
          selectedCard.ID,
          protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_96 ||
            protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_CUSTOM
            ? protocolCustomTipCount
            : null,
          labwareIndex,
        );

        if (selectedCard.isInsertTask) {
          appStateActionShowSnackbar(
            Feedback.SUCCESS,
            intl.formatMessage({
              id: 'protocolEditor.taskList.insertTask.notification.success',
            }),
          );
        }

        if (selectedCard.isInsertTask || uncompleteMixingTask) {
          const ejectTipTask = !!find(cardStateTasks, {
            ID: selectedCard?.tasks,
            type: TaskType.EJECT_TIP,
          });

          if (ejectTipTask) {
            protocolEditorStateActionSetSelectedTipChannel(null);
            protocolEditorStateActionSetCustomTipCount(null);
          }
        }

        await dispatch(hideAspirateDispenseVolumeModal());
        undoRedoBusinessActionGlobalAddUndoItem();
      };

      showSetAspirateDispenseModal(temporaryNewTask, onApplyVolumeCallback);
    }

    const onTipCaddyClick = useStaticCallback(async (itemID) => {
      if (isOperator) return;
      const editingTask = find(cardStateTasks, {isSelected: true});
      if (editingTask || previousSelectedTask.current) {
        return;
      }

      const hasAlreadyPickTip = find(cardStateTasks, {
        ID: selectedCard?.tasks,
        type: TaskType.PICK_TIP,
      });
      const hasAlreadyEjectTip = find(cardStateTasks, {
        ID: selectedCard?.tasks,
        type: TaskType.EJECT_TIP,
      });
      const hasInsertTask = find(cardStateTasks, {
        ID: selectedCard?.tasks,
        type: TaskType.INSERT_TASK,
      });

      let canPickTips = true;

      if (isEjectToCaddy) {
        canPickTips = itemID !== TipCaddyLocationType.TIP_WASTE_CADDY;
      }

      if (protocolSelectedTipChannel && (!hasAlreadyPickTip || (hasAlreadyEjectTip && !hasInsertTask)) && canPickTips) {
        taskListBusinessAddTask(
          TaskType.PICK_TIP,
          protocolSelectedTipChannel,
          itemID,
          '',
          '',
          0,
          null,
          protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_96 ||
            protocolSelectedTipChannel === TipChannelType.TIP_CHANNEL_CUSTOM
            ? protocolCustomTipCount
            : null,
        );

        if (selectedCard.isInsertTask) {
          appStateActionShowSnackbar(
            Feedback.SUCCESS,
            intl.formatMessage({
              id: 'protocolEditor.taskList.insertTask.notification.success',
            }),
          );
          if (hasAlreadyEjectTip) {
            protocolEditorStateActionSetSelectedTipChannel(null);
            protocolEditorStateActionSetCustomTipCount(null);
          }
        }
        undoRedoBusinessActionGlobalAddUndoItem();
      }

      if (!hasAlreadyPickTip && itemID === TipCaddyLocationType.TIP_WASTE_CADDY && isEjectToCaddy) {
        dispatch(
          showSnackbar(
            Feedback.INFO,
            intl.formatMessage({
              id: 'plateTypeEditorContainer.tipsWasteToCaddy.pickTaskFirst.info',
            }),
          ),
        );
        return;
      }

      if (
        hasAlreadyPickTip &&
        !hasAlreadyEjectTip &&
        hasAlreadyPickTip.labwareID !== itemID &&
        itemID === TipCaddyLocationType.TIP_WASTE_CADDY &&
        isEjectToCaddy
      ) {
        dispatch(addEjectTipTask());
        if (selectedCard.isInsertTask) {
          dispatch(
            showSnackbar(
              Feedback.SUCCESS,
              intl.formatMessage({
                id: 'protocolEditor.taskList.insertTask.notification.success',
              }),
            ),
          );
        }

        await dispatch(setSelectedTipChannel(''));
        await dispatch(setCustomTipCount(null));
        dispatch(globalAddUndoItem());
      }
    });

    // #endregion simple transfer

    // #region pooling

    const isPoolingCtrlPressedRef = useRef(false);
    const isPoolingSwipingRef = useRef(false);
    const poolingLastLabware = useRef(null);
    const poolingAllowedTips = useRef(null);
    const poolingTipsPattern = useRef(null);
    const poolingTasksRef = useRef({
      ASPIRATE: null,
      DISPENSE: null,
    });
    const poolingTasksPerLabwareRef = useRef({
      ASPIRATE: null,
      DISPENSE: null,
    });
    const poolingCurrentLabwareRef = useRef(null);

    const getTaskAspiratePooling = (labwareId) => {
      const currentSelectedCard = selectedCardRef?.current;

      if (!currentSelectedCard) {
        return [];
      }

      const allTasks = cardStateTasksRef?.current ?? [];

      const tasks = labwareId
        ? filterToArray(allTasks, {ID: currentSelectedCard.tasks, labwareID: labwareId, type: TaskType.ASPIRATE})
        : filterToArray(allTasks, {ID: currentSelectedCard.tasks, type: TaskType.ASPIRATE});

      return tasks;
    };

    const getTaskDispensePooling = (labwareId) => {
      const currentSelectedCard = selectedCardRef?.current;

      if (!currentSelectedCard) {
        return [];
      }

      const allTasks = cardStateTasksRef?.current ?? [];

      const tasks = labwareId
        ? filterToArray(allTasks, {ID: currentSelectedCard.tasks, labwareID: labwareId, type: TaskType.DISPENSE})
        : filterToArray(allTasks, {ID: currentSelectedCard.tasks, type: TaskType.DISPENSE});

      return tasks;
    };

    const isSwipingPooling = () => {
      if (protocolEditorMode !== ProtocolEditorViewMode.POOLING) {
        return false;
      }

      return !!swipingInfoRef?.current?.swipingStart;
    };

    const initializePoolingTasksPerLabware = (labwareID) => {
      const aspirateTasks = getTaskAspiratePooling(labwareID);
      const dispenseTasks = getTaskDispensePooling(labwareID);
      poolingTasksPerLabwareRef.current = {
        ASPIRATE: aspirateTasks,
        DISPENSE: dispenseTasks,
      };
    };

    const resetAllPoolingTasksRef = () => {
      poolingTasksPerLabwareRef.current = {
        ASPIRATE: null,
        DISPENSE: null,
      };
      poolingTasksRef.current = {
        ASPIRATE: null,
        DISPENSE: null,
      };
      poolingCurrentLabwareRef.current = null;
    };

    const initializePoolingTasks = () => {
      const aspirateTasks = getTaskAspiratePooling();
      const dispenseTasks = getTaskDispensePooling();
      poolingTasksRef.current = {
        ASPIRATE: aspirateTasks,
        DISPENSE: dispenseTasks,
      };
    };

    const getTaskAspiratePoolingFromRef = (labwareId) => {
      if (!labwareId) {
        if (!poolingTasksRef.current.ASPIRATE) {
          return getTaskAspiratePooling();
        }
        return poolingTasksRef.current.ASPIRATE;
      }

      if (labwareId !== poolingCurrentLabwareRef.current || !poolingTasksPerLabwareRef.current.ASPIRATE) {
        return getTaskAspiratePooling(labwareId);
      }

      return poolingTasksPerLabwareRef.current.ASPIRATE;
    };

    const getTaskDispensePoolingFromRef = (labwareId) => {
      if (!labwareId) {
        if (!poolingTasksRef.current.DISPENSE) {
          return getTaskDispensePooling();
        }
        return poolingTasksRef.current.DISPENSE;
      }

      if (labwareId !== poolingCurrentLabwareRef.current || !poolingTasksPerLabwareRef.current.DISPENSE) {
        return getTaskDispensePooling(labwareId);
      }

      return poolingTasksPerLabwareRef.current.DISPENSE;
    };

    const getPoolingTasksFromRef = (labwareId, editStep = null) => {
      const taskAspirates = getTaskAspiratePoolingFromRef(labwareId);
      const taskDispenses = getTaskDispensePoolingFromRef(labwareId);

      let tasks = [];

      if (taskAspirates?.length && editStep !== 1) {
        tasks = [...tasks, ...taskAspirates];
      }

      if (taskDispenses.length && editStep !== 3) {
        tasks = [...tasks, taskDispenses[0]];
      }

      return tasks;
    };

    const getPoolingTipCount = (labwareID, originTaskDispenses) => {
      const taskAspirates = getTaskAspiratePoolingFromRef();
      const taskDispenses = originTaskDispenses ?? getTaskDispensePoolingFromRef();
      const taskDispense = taskDispenses[0];

      if (!taskAspirates) {
        return [null, null];
      }
      const taskDispenseLabware = find(labwareState, {LabwareID: taskDispense?.labwareID});

      if (taskAspirates.length) {
        let rowTip = 1;
        let columnTip = 1;

        if (protocolPoolingTaskEditStep && taskDispenses.length) {
          if (taskDispenseLabware?.isTrough) {
            if (!taskDispense) {
              return [rowTip, columnTip];
            }

            if (taskDispenseLabware.rowCount > 1) {
              rowTip = taskDispense.rowTipCount;
            } else if (taskDispenseLabware.colCount > 1) {
              columnTip = taskDispense.columnTipCount;
            } else {
              columnTip = null;
              rowTip = null;
            }
            return [rowTip, columnTip];
          }
          return [taskDispense.rowTipCount, taskDispense.columnTipCount];
        }

        return [rowTip, columnTip];
      }

      return [null, null];
    };

    /* eslint-disable arrow-body-style */
    const isLabwareAllowedPooling = () => {
      // allow to select well in different labware when editing task location
      // if (protocolPoolingTaskEditStep) {
      //   return true;
      // }

      // const taskDispenses = getTaskDispensePoolingFromRef();

      // if (taskDispenses.length) {
      //   const task = taskDispenses[0];
      //   const taskDispenseLabwareId = task.labwareID;

      //   return taskDispenseLabwareId === labwareId;
      // }

      return true;
    };

    /* eslint-disable arrow-body-style */
    const isSwipingAllowedPooling = () => {
      // const taskAspirate = getTaskAspiratePooling()[0];
      // if (protocolPoolingTaskEditStep !== 1 && taskAspirate) {
      //   return false;
      // }

      return true;
    };

    const normalizePoolingSwipeMove = (swipingStart, swipingEnd, allowedTipCount, labware) => {
      const newSwipingStart = {
        row: swipingStart.row,
        column: swipingStart.column,
      };

      const newSwipingEnd = {
        row: swipingEnd.row,
        column: swipingEnd.column,
      };

      const is384 = labware.rowCount * labware.colCount === 384 ? 1 : 0;

      // swipe left
      if (newSwipingEnd.row > newSwipingStart.row) {
        newSwipingEnd.row = newSwipingStart.row + (allowedTipCount.row - 1) * (is384 + 1);
        if (newSwipingEnd.row > labware.rowCount) {
          newSwipingEnd.row = is384 && newSwipingEnd.row % 2 !== 0 ? labware.rowCount - 1 : labware.rowCount;
          newSwipingStart.row = newSwipingEnd.row - (allowedTipCount.row - 1) * (is384 + 1);
        }
      }
      // swipe right
      if (newSwipingEnd.row < newSwipingStart.row) {
        newSwipingEnd.row = newSwipingStart.row - (allowedTipCount.row - 1) * (is384 + 1);
        // newSwipingEnd.column = newSwipingStart.column;
        if (newSwipingEnd.row < 1) {
          newSwipingEnd.row = is384 && newSwipingEnd.row % 2 === 0 ? 2 : 1;
          newSwipingStart.row = newSwipingEnd.row + (allowedTipCount.row - 1) * (is384 + 1);
        }
      }
      // swipe down
      if (newSwipingEnd.column > newSwipingStart.column) {
        newSwipingEnd.column = newSwipingStart.column + (allowedTipCount.column - 1) * (is384 + 1);
        if (newSwipingEnd.column > labware.colCount) {
          newSwipingEnd.column = is384 && newSwipingEnd.column % 2 !== 0 ? labware.colCount - 1 : labware.colCount;
          newSwipingStart.column = newSwipingEnd.column - (allowedTipCount.column - 1) * (is384 + 1);
        }
      }
      // swipe up
      if (newSwipingEnd.column < newSwipingStart.column) {
        newSwipingEnd.column = newSwipingStart.column - (allowedTipCount.column - 1) * (is384 + 1);
        if (newSwipingEnd.column < 1) {
          newSwipingEnd.column = is384 && newSwipingEnd.column % 2 === 0 ? 2 : 1;
          newSwipingStart.column = newSwipingEnd.column + (allowedTipCount.column - 1) * (is384 + 1);
        }
      }

      const tipCount = {
        row: Math.abs(newSwipingStart.row - newSwipingEnd.row) / (1 + is384) + 1,
        column: Math.abs(newSwipingStart.column - newSwipingEnd.column) / (1 + is384) + 1,
      };

      return [
        newSwipingStart.row,
        newSwipingStart.column,
        newSwipingEnd.row,
        newSwipingEnd.column,
        tipCount.row,
        tipCount.column,
      ];
    };

    const restrictPoolingSwipe = (
      swipingStart,
      row,
      column,
      labware,
      rowTipCount,
      columnTipCount,
      skipWellMode,
      is384,
    ) => {
      if (protocolPoolingTaskEditStep === 1) {
        const taskDispenses = getTaskDispensePoolingFromRef(labware.LabwareID);
        if (taskDispenses.length) {
          const taskDispense = taskDispenses[0];
          let newRow = row;
          let newColumn = column;

          const newRowTipCount = rowTipCount * (is384 ? 2 : 1);
          const newColumnTipCount = columnTipCount * (is384 ? 2 : 1);

          const actualRowSize = Math.abs(row - swipingStart.row) + (swipingStart.row > row ? 0 : 1);
          const actualColumnSize = Math.abs(column - swipingStart.column) + (swipingStart.column > column ? 0 : 1);

          let rowSize = Math.ceil(actualRowSize / newRowTipCount) * newRowTipCount;
          let columnSize = Math.ceil(actualColumnSize / newColumnTipCount) * newColumnTipCount;

          const startRow = swipingStart.row <= row ? swipingStart.row : swipingStart.row - rowSize;
          const startColumn = swipingStart.column <= column ? swipingStart.column : swipingStart.column - columnSize;

          if (swipingStart.row > row) {
            rowSize += newRowTipCount;
          }

          if (swipingStart.column > column) {
            columnSize += newColumnTipCount;
          }

          const highlightedWellAspirate = getHighlightedWellFromTask([taskDispense], skipWellMode);
          const highlightedWell = getHighlightedWell(startRow, startColumn, rowSize, columnSize, skipWellMode);

          const isIntersectionRow = highlightedWellAspirate.some((well) =>
            highlightedWell.find((e) => well.split('-')[0] === e.split('-')[0]),
          );
          const isIntersectionColumn = highlightedWellAspirate.some((well) =>
            highlightedWell.find((e) => well.split('-')[1] === e.split('-')[1]),
          );

          const aspirateTaskRow = convertRowToNumeric(taskDispense.row);
          const minAspirateRow = aspirateTaskRow;
          const maxAspirateRow = aspirateTaskRow + newRowTipCount - (is384 ? 2 : 1);
          const minAspirateColumn = taskDispense.column;
          const maxAspirateColumn = taskDispense.column + newColumnTipCount - (is384 ? 2 : 1);

          // swiping left
          if (swipingStart.row < row) {
            const mostLeftRow =
              swipingStart.row - 1 + Math.ceil((row - swipingStart.row + 1) / newRowTipCount) * newRowTipCount;

            if (isIntersectionColumn && swipingStart.row < minAspirateRow && minAspirateRow <= mostLeftRow) {
              newRow = minAspirateRow - newRowTipCount;
              if (newRow < swipingStart.row) {
                newRow = swipingStart.row;
              }
            }
          }

          // swiping right
          if (swipingStart.row > row) {
            const mostRightRow =
              swipingStart.row - Math.ceil((swipingStart.row - row) / newRowTipCount) * newRowTipCount;

            if (isIntersectionColumn && swipingStart.row > maxAspirateRow && maxAspirateRow >= mostRightRow) {
              newRow = maxAspirateRow + newRowTipCount;
              if (newRow > swipingStart.row) {
                newRow = swipingStart.row;
              }
            }
          }

          // swiping down
          if (swipingStart.column < column) {
            const mostDownColumn =
              swipingStart.column -
              1 +
              Math.ceil((column - swipingStart.column + 1) / newColumnTipCount) * newColumnTipCount;
            if (isIntersectionRow && swipingStart.column < minAspirateColumn && minAspirateColumn <= mostDownColumn) {
              newColumn = minAspirateColumn - newColumnTipCount;
              if (newColumn < swipingStart.column) {
                newColumn = swipingStart.column;
              }
            }
          }

          // swiping up
          if (swipingStart.column > column) {
            const mostUpColumn =
              swipingStart.column - Math.ceil(swipingStart.column - column / newColumnTipCount) * newColumnTipCount;
            if (isIntersectionRow && swipingStart.column > maxAspirateColumn && maxAspirateColumn >= mostUpColumn) {
              newColumn = maxAspirateColumn + newColumnTipCount;
              if (newColumn > swipingStart.column) {
                newColumn = swipingStart.column;
              }
            }
          }

          return [swipingStart.row, swipingStart.column, newRow, newColumn, rowTipCount, columnTipCount];
        }
      } else if (protocolPoolingTaskEditStep === 3 || protocolPoolingTaskStep === 3) {
        const taskAspirates = getTaskAspiratePoolingFromRef(labware.LabwareID);
        let {row: swipingStartRow, column: swipingStartColumn} = swipingStart;
        let [normalizedRow, normalizedColumn] = [row, column];
        let [newRowTipCount, newColumnTipCount] = [rowTipCount, columnTipCount];
        [swipingStartRow, swipingStartColumn, normalizedRow, normalizedColumn, newRowTipCount, newColumnTipCount] =
          normalizePoolingSwipeMove(swipingStart, {row, column}, poolingAllowedTips.current, labware);

        if (taskAspirates.length) {
          const relatedWells = [];

          taskAspirates.forEach((task) => {
            const taskRow = convertRowToNumeric(task.row);
            const taskColumn = task.column;

            if (taskRow === normalizedRow || taskColumn === normalizedColumn) {
              for (let c = taskColumn; c <= taskColumn + task.columnTipCount - 1; c += 1) {
                for (let r = taskRow; r <= taskRow + task.rowTipCount - 1; r += 1) {
                  relatedWells.push(`${r}-${c}`);
                }
              }
            }
          });
          const highlightedWell = [];
          const startRow = Math.min(swipingStart.row, normalizedRow);
          const startColumn = Math.min(swipingStart.column, normalizedColumn);
          for (let c = startColumn; c < startColumn + newColumnTipCount; c += 1) {
            for (let r = startRow; r < startRow + newRowTipCount; r += 1) {
              highlightedWell.push(`${r}-${c}`);
            }
          }
          const isOverlapping = relatedWells.some((well) => highlightedWell.find((e) => well === e));
          if (isOverlapping) {
            return [swipingStart.row, swipingStart.column, swipingStart.row, swipingStart.column, 1, 1];
          }
        }
        return [
          swipingStartRow,
          swipingStartColumn,
          normalizedRow,
          normalizedColumn,
          newRowTipCount,
          newColumnTipCount,
        ];
      }
      return [swipingStart.row, swipingStart.column, row, column, rowTipCount, columnTipCount];
    };

    const setPoolingAllowedTips = () => {
      const {allowedTips, taskGroups, groupedByColumn} = taskListPoolingBusinessGetPoolingDestinationAllowedTip(
        poolingTipsPattern.current,
      );
      taskListPoolingSetPoolingHelperState({
        allowedTips,
        taskGroups,
        groupedByColumn,
      });
      poolingAllowedTips.current = allowedTips;
    };

    const closePoolingVolumeModal = useStaticCallback(
      // eslint-disable-next-line default-param-last
      (volume, currentVolume, isEdit = false, skipAddUndoItem = false, deckNumber) => {
        const parsedVolume = taskListPoolingBusinessClosePoolingVolumeModal(
          protocolPoolingTaskEditStep,
          protocolPoolingTaskStep,
          volume,
          currentVolume,
          isEdit,
          skipAddUndoItem,
        );

        initialValueVolumeModal.current = 0;
        poolingVolumeModalOpenRef.current = false;
        if (_.isNull(parsedVolume)) {
          if (!isEdit) {
            resetAllPoolingTasksRef();
          }
          return;
        }

        if (!isEdit) {
          setProtocolEditorMode(ProtocolEditorViewMode.POOLING);
          protocolEditorStateActionSetPoolingTaskStep(3);
          resetAllPoolingTasksRef();
          setPoolingAllowedTips();
        }
        undoRedoBusinessActionGlobalAddUndoItem(null, {poolingVolume: parsedVolume, poolingLastLabware: deckNumber});
      },
    );

    const isValidWellCapacity = (taskAspirates, workingCapacity, volume) => {
      if (!taskAspirates) {
        return true;
      }

      const dispenseTotalVolume = taskAspirates.length * volume;
      if (workingCapacity < dispenseTotalVolume) {
        return false;
      }
      return true;
    };

    const showPoolingVolumeModal = async (
      // eslint-disable-next-line default-param-last
      deckNumber = null,
      // eslint-disable-next-line default-param-last
      validateWellCapacity = false,
      // eslint-disable-next-line default-param-last
      skipAddUndoItem = false,
      updatedVolume,
    ) => {
      if (!selectedCard) {
        return;
      }

      const isEdit = !deckNumber;

      let currentDeckNumber = deckNumber;
      let currentVolume = updatedVolume ?? 0;

      if (isEdit || skipAddUndoItem) {
        const taskAspirates = getTaskAspiratePooling();
        const taskAspirate = taskAspirates[0];

        if (taskAspirate) {
          const taskAspirateVolume = taskAspirate?.volume;
          const taskAspirateLabwareId = taskAspirate?.labwareID;

          currentDeckNumber = Object.keys(labwareState).find(
            (e) => labwareState[e].LabwareID === taskAspirateLabwareId,
          );
          currentDeckNumber = parseInt(currentDeckNumber, 10);

          currentVolume = updatedVolume ?? taskAspirateVolume;
        }
      }

      calculateVolumeModalPos(currentDeckNumber);
      setVolumeModalType(VolumeModalType.POOLING);

      setPoolingVolumeModalOpenStatus(true);
      if (!skipAddUndoItem) {
        undoRedoBusinessActionGlobalUndoRedoUpdatePresentState('protocolEditorState', {volumeModalOpen: true});
      }

      const result = await volumeModalRef.current.show(currentVolume);
      const {volume} = result;
      appStateActionShowLoading(intl.formatMessage({id: 'protocolEditor.generalLoading.message'}));
      initiateGlobalWorker(() => {
        if (validateWellCapacity) {
          const taskAspirates = getTaskAspiratePooling();
          const taskDispense = find(cardStateTasks, {
            ID: selectedCard.tasks,
            type: TaskType.DISPENSE,
          });
          const dispenseLabwareID = taskDispense?.labwareID;
          const dispenseLabware = find(labwareState, {LabwareID: dispenseLabwareID});
          if (!dispenseLabware || !taskAspirates) {
            return;
          }
          const {workingCapacity} = dispenseLabware;
          if (!isValidWellCapacity(taskAspirates, workingCapacity, volume)) {
            setTimeout(() => {
              appStateActionShowSnackbar(
                Feedback.WARNING,
                intl.formatMessage({id: 'protocolEditor.pooling.resizeWellOverCapacity'}),
              );
            }, 1500);
          }
        }
        closePoolingVolumeModal(volume, currentVolume, isEdit, skipAddUndoItem, deckNumber);
        appStateActionHideLoading();
      });
    };

    const poolingVolumeModalChange = (volume) => {
      if (initialValueVolumeModal.current === 0) {
        if (volume !== 0) {
          initialValueVolumeModal.current = volume;
          undoRedoBusinessActionGlobalAddUndoItem(null, {
            poolingVolume: volume,
            poolingLastLabware: poolingLastLabware.current,
          });
        }
      } else {
        undoRedoBusinessActionGlobalUndoRedoUpdatePresentState('otherState', {
          poolingVolume: parseFloat(volume),
          poolingLastLabware: poolingLastLabware.current,
        });
      }
    };

    useEffect(
      () => {
        if (selectedCard?.type === CardType.POOLING) {
          const hasAspirateTask = find(cardStateTasks, {
            ID: selectedCard?.tasks,
            type: TaskType.ASPIRATE,
          });

          if (protocolPoolingTaskStep) {
            protocolEditorStateActionSetPoolingTaskEditStep(null);
          }

          if (
            hasAspirateTask &&
            hasAspirateTask?.volume === 0 &&
            !protocolPoolingTaskEditStep &&
            !isPoolingCtrlPressedRef.current &&
            protocolEditorMode === ProtocolEditorViewMode.POOLING &&
            !protocolVolumeModalOpen
          ) {
            const labwareDeckNumber = Object.keys(labwareState).find(
              (e) => labwareState[e].LabwareID === hasAspirateTask.labwareID,
            );
            showPoolingVolumeModal(labwareDeckNumber, false, true);
          }

          poolingAllowedTips.current = selectedCard.poolingHelperState?.allowedTips ?? {
            row: undefined,
            column: undefined,
          };
        } else {
          poolingTipsPattern.current = null;

          if (poolingVolumeModalOpenRef?.current) {
            volumeModalRef.current.hide();
            setPoolingVolumeModalOpenStatus(false);
          }
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [selectedCard, cardStateTasks, protocolPoolingTaskEditStep, isPoolingCtrlPressedRef.current],
    );

    const isPoolingNotAllowed = (
      labwareId,
      row,
      column,
      normalizedRow,
      normalizedColumn,
      rowTipCount,
      columnTipCount,
      skipWellMode,
    ) => {
      const taskAspirates = getTaskAspiratePoolingFromRef(labwareId);
      const taskDispenses = getTaskDispensePoolingFromRef(labwareId);

      let highlightedWell = [];

      // edit / add destination
      if (taskAspirates.length && (protocolPoolingTaskEditStep === 3 || protocolPoolingTaskStep === 3)) {
        const highlightedWellAspirate = getHighlightedWellFromTask(taskAspirates, skipWellMode);
        highlightedWell = _.concat(highlightedWell, highlightedWellAspirate);

        if (highlightedWellAspirate.includes(`${row}-${column}`)) {
          return true;
        }
      }

      // edit source
      if (taskDispenses.length && protocolPoolingTaskEditStep === 1) {
        if (taskAspirates.length) {
          const highlightedWellAspirate = getHighlightedWellFromTask(taskAspirates, skipWellMode);
          highlightedWell = _.concat(highlightedWell, highlightedWellAspirate);

          if (highlightedWellAspirate.includes(`${row}-${column}`)) {
            return false;
          }
        }
        const highlightedWellDispense = getHighlightedWellFromTask([taskDispenses[0], ...taskAspirates], skipWellMode);
        highlightedWell = _.concat(highlightedWell, highlightedWellDispense);

        if (highlightedWellDispense.includes(`${row}-${column}`)) {
          return true;
        }
      }

      const wellFromTask = getHighlightedWell(
        normalizedRow,
        normalizedColumn,
        rowTipCount,
        columnTipCount,
        skipWellMode,
      );

      return wellFromTask.some((well) => highlightedWell.includes(well));
    };

    const onHoverWellPooling = (itemID, row, column, labwareIndex, isCtrl, isShift) => {
      const labware = labwareState[itemID];
      const {
        LabwareID: labwareId,
        workingCapacity,
        rowCount: labwareRowCount,
        colCount: labwareColCount,
        isIFC,
        isSpearBio,
      } = labware;

      if (isIFC || isSpearBio) {
        return;
      }

      if (poolingCurrentLabwareRef.current !== labwareId) {
        poolingCurrentLabwareRef.current = labwareId;
        initializePoolingTasksPerLabware(labwareId);
      }

      if (!poolingTasksRef.current.ASPIRATE) {
        initializePoolingTasks();
      }

      if (!protocolPoolingTaskEditStep && poolingVolumeModalOpenRef.current) {
        setSelectedWellStyle({[itemID]: {}});
        setIsOverCapacityTooltipShow(false);
        previousHoveredLabware.current = null;
        return;
      }

      const taskAspirates = getTaskAspiratePoolingFromRef();
      let taskAspirate = null;
      if (taskAspirates?.length) {
        [taskAspirate] = taskAspirates;
      }

      if (isSwipingPooling() || !isLabwareAllowedPooling(labwareId)) {
        setSelectedWellStyle({[itemID]: {}});
        setIsOverCapacityTooltipShow(false);
        previousHoveredLabware.current = null;
        return;
      }

      const originState = poolingStateBeforeEdit?.originState ?? {};
      const {taskDispenses, labware: originDestLabware} = originState;
      let [rowTipCount, columnTipCount] = getPoolingTipCount(itemID, taskDispenses);
      let destinationLabwareIsTrough = false;

      if (protocolPoolingTaskEditStep === 3) {
        rowTipCount = 1;
        columnTipCount = 1;
      } else if (protocolPoolingTaskEditStep) {
        destinationLabwareIsTrough = originDestLabware?.isTrough;
      }

      const isReuseTips = selectedCard && 'reuseTips' in selectedCard ? selectedCard.reuseTips : false;
      let aspirateTaskLabware = getTaskAspiratePoolingFromRef(labwareId, true);

      if (
        protocolPoolingTaskEditStep === 1 &&
        destinationLabwareIsTrough &&
        !isReuseTips &&
        (columnTipCount > 1 || rowTipCount > 1)
      ) {
        aspirateTaskLabware = getTaskGroups(
          aspirateTaskLabware,
          labwareStateRef.current,
          columnTipCount === 1,
          {row: false, column: false},
          {row: false, column: false},
          {row: rowTipCount, column: columnTipCount},
        );
      }

      const [skipWellMode] = getSkipWellMode(rowTipCount, columnTipCount, isShift, isLabware384(labware));

      const [minPosition, maxPosition] = getMinMaxPositionFromTaskList(
        getPoolingTasksFromRef(labwareId),
        row,
        column,
        labware,
        skipWellMode,
      );

      const [normalizedRow, normalizedColumn] = normalizeHighlightedWell(
        row,
        column,
        {row: rowTipCount, column: columnTipCount},
        labware,
        labwareIndex,
        isShift,
        maxPosition,
        minPosition,
        aspirateTaskLabware,
        null,
        destinationLabwareIsTrough,
      );

      if (
        isPoolingNotAllowed(
          labwareId,
          row,
          column,
          normalizedRow,
          normalizedColumn,
          rowTipCount,
          columnTipCount,
          skipWellMode,
        )
      ) {
        setSelectedWellStyle({[itemID]: {}});
        setIsOverCapacityTooltipShow(false);
        previousHoveredLabware.current = null;
        return;
      }

      const labwareWellCount = labwareRowCount * labwareColCount;
      // eslint-disable-next-line
      const skipWellRowCount = labwareWellCount === WellCount.WELL_384 ? 1 : null;
      // eslint-disable-next-line
      const skipWellColumnCount = labwareWellCount === WellCount.WELL_384 ? 1 : null;

      setSelectedWellStyle({
        [itemID]: labwareBusinessGetWellStyleColor(
          labwareId,
          normalizedRow,
          normalizedColumn,
          hoverWellColorEnum,
          rowTipCount ?? 1,
          columnTipCount ?? 1,
          null,
          false,
          null,
          null,
          skipWellRowCount,
          skipWellColumnCount,
          true,
          true,
          labwareIndex,
        ),
      });

      // cek if well is not overcapacity
      if (
        taskAspirate &&
        protocolEditorMode === ProtocolEditorViewMode.POOLING &&
        (!protocolPoolingTaskEditStep || protocolPoolingTaskEditStep === 3)
      ) {
        if (previousHoveredLabware.current !== labwareId) {
          let dispenseMixingVolume = taskAspirates.length * taskAspirate.volume;
          if (rowTipCount === 1 || (rowTipCount > 1 && labwareRowCount === 1)) {
            dispenseMixingVolume *= taskAspirate.rowTipCount;
          }
          if (columnTipCount === 1 || (columnTipCount > 1 && labwareColCount === 1)) {
            dispenseMixingVolume *= taskAspirate.columnTipCount;
          }

          if (workingCapacity < dispenseMixingVolume) {
            setIsOverCapacityTooltipShow(true);
            if (protocolPoolingTaskEditStep === 3) {
              setOverCapacityMessage('protocolEditor.pooling.moveWellOverCapacity');
            } else {
              setOverCapacityMessage('protocolEditor.pooling.wellOverCapacity');
            }
          } else {
            setIsOverCapacityTooltipShow(false);
          }
          previousHoveredLabware.current = labwareId;
        }
      }
    };

    const onSwipeStartPooling = (itemID, row, column, isCtrl, isShift) => {
      const labware = labwareState[itemID];
      const {LabwareID: labwareId, isIFC, isSpearBio} = labware;

      if (isIFC || isSpearBio) {
        return;
      }

      isPoolingSwipingRef.current = true;

      const taskAspirates = getTaskAspiratePoolingFromRef();
      let taskAspirate = null;
      if (taskAspirates?.length) {
        [taskAspirate] = taskAspirates;
      }

      if (!protocolPoolingTaskEditStep && poolingVolumeModalOpenRef.current) {
        return;
      }

      const originState = poolingStateBeforeEdit?.originState ?? {};
      const {taskDispenses, labware: originDestLabware} = originState;
      const {isTrough: curDestLabwareIsTrough} = originDestLabware ?? {};

      let rowTipCount = null;
      let columnTipCount = null;

      if (protocolPoolingTaskEditStep === 3) {
        rowTipCount = 1;
        columnTipCount = 1;
      } else if (protocolPoolingTaskEditStep) {
        [rowTipCount, columnTipCount] = getPoolingTipCount(itemID, taskDispenses);
      }

      let [normalizedRow, normalizedColumn] = [row, column];

      const [skipWellMode] = getSkipWellMode(
        rowTipCount,
        columnTipCount,
        protocolPoolingTaskEditStep === 1 || protocolPoolingTaskStep === 1 ? isShift : false,
        isLabware384(labware),
      );

      if (taskAspirate) {
        const isReuseTips = selectedCard && 'reuseTips' in selectedCard ? selectedCard.reuseTips : false;
        let aspirateTaskLabware = getTaskAspiratePoolingFromRef(labwareId, true);

        if (
          protocolPoolingTaskEditStep === 1 &&
          curDestLabwareIsTrough &&
          !isReuseTips &&
          (columnTipCount > 1 || rowTipCount > 1)
        ) {
          aspirateTaskLabware = getTaskGroups(
            aspirateTaskLabware,
            labwareStateRef.current,
            columnTipCount === 1,
            {row: false, column: false},
            {row: false, column: false},
            {row: rowTipCount, column: columnTipCount},
          );
        }
        const [minPosition, maxPosition] = getMinMaxPositionFromTaskList(
          getPoolingTasksFromRef(labwareId),
          row,
          column,
          labware,
          skipWellMode,
        );

        [normalizedRow, normalizedColumn] = normalizeHighlightedWell(
          row,
          column,
          {row: rowTipCount, column: columnTipCount},
          labware,
          0,
          protocolPoolingTaskEditStep === 1 || protocolPoolingTaskStep === 1 ? isShift : false,
          maxPosition,
          minPosition,
          aspirateTaskLabware,
          null,
          curDestLabwareIsTrough,
        );
      }

      if (
        isPoolingNotAllowed(
          labwareId,
          row,
          column,
          normalizedRow,
          normalizedColumn,
          rowTipCount,
          columnTipCount,
          skipWellMode,
        )
      ) {
        return;
      }

      swipingInfoRef.current = initSwipingInfo(normalizedRow, normalizedColumn, labware);
      swipingInfoRef.current.originStart = {
        row: normalizedRow,
        column: normalizedColumn,
      };
    };

    const onSwipeMovePooling = (itemID, row, column, swipingDirectionY, swipingDirectionX, isCtrl, isShift) => {
      if (!swipingInfoRef.current) {
        return;
      }

      const labware = labwareState[itemID];
      let {LabwareID: labwareId} = labware;

      if (checkIs24Or48WellLabware(labware)) {
        return;
      }

      if (!isSwipingAllowedPooling() || !isLabwareAllowedPooling(labwareId)) {
        resetSwipingInfo();
        return;
      }

      const {taskDispenses} = poolingStateBeforeEdit?.originState ?? {};
      let [rowTipCount, columnTipCount] = getPoolingTipCount(itemID, taskDispenses);

      let [normalizedRow, normalizedColumn] = [row, column];
      let {row: swipingStartRow, column: swipingStartColumn} = swipingInfoRef.current.swipingStart;

      const [skipWellMode, noSkip] = getSkipWellMode(
        rowTipCount,
        columnTipCount,
        protocolPoolingTaskEditStep === 1 || protocolPoolingTaskStep === 1 ? isShift : false,
        isLabware384(labware),
      );

      [swipingStartRow, swipingStartColumn, normalizedRow, normalizedColumn, rowTipCount, columnTipCount] =
        restrictPoolingSwipe(
          swipingInfoRef.current.originStart,
          normalizedRow,
          normalizedColumn,
          labware,
          rowTipCount,
          columnTipCount,
          skipWellMode,
          isLabware384(labware),
        );

      // prevent swiping cross labware
      let newSwipingInfo;
      let deckID = itemID;
      const startingLabwareId = swipingInfoRef.current?.labware.LabwareID;
      if (labwareId === startingLabwareId || !startingLabwareId) {
        newSwipingInfo = updateSwipingInfo(
          swipingInfoRef.current,
          protocolPoolingTaskEditStep === 1 ? {row: rowTipCount, column: columnTipCount} : {row: null, column: null},
          {row: swipingStartRow, column: swipingStartColumn},
          {row: normalizedRow, column: normalizedColumn},
          swipingDirectionY,
          swipingDirectionX,
          getPoolingTasksFromRef(labwareId, protocolPoolingTaskStep ?? protocolPoolingTaskEditStep),
        );

        if (newSwipingInfo) {
          swipingInfoRef.current = {
            ...swipingInfoRef.current,
            ...newSwipingInfo,
          };
        }

        if (!swipingInfoRef.current) {
          resetSwipingInfo();
          return;
        }
      } else {
        labwareId = startingLabwareId;
        deckID = Object.keys(labwareState).find((e) => labwareState[e].LabwareID === labwareId);
      }

      const [normalizedSwipingStart, , normalizedSwipingSize, skipWell] = normalizeSwipingInfo(
        swipingInfoRef.current,
        skipWellMode,
        noSkip,
      );

      if (normalizedSwipingStart && normalizedSwipingSize) {
        setSelectedWellStyle({
          [deckID]: labwareBusinessGetWellStyleColor(
            labwareId,
            normalizedSwipingStart.row,
            normalizedSwipingStart.column,
            hoverWellColorEnum,
            normalizedSwipingSize.row,
            normalizedSwipingSize.column,
            null,
            false,
            null,
            null,
            skipWell?.row,
            skipWell?.column,
            true,
          ),
        });
      }
    };

    const afterOnSwipeEndPooling = () => {
      enableHighlightTaskRef.current = true;
      swipingInfoRef.current = null;
    };

    const onSwipeEndPooling = async (itemID, isCtrl, isShift) => {
      const labware = labwareState[itemID];
      const {LabwareID: labwareId, isIFC, isSpearBio} = labware;

      const is384 = isLabware384(labware);

      if (isIFC) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({
            id: 'protocolEditor.pooling.createNew.disallowIFCLabware',
          }),
        );

        return;
      }

      if (isSpearBio) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({
            id: 'protocolEditor.pooling.createNew.disallowSpearBioLabware',
          }),
        );

        return;
      }

      isPoolingSwipingRef.current = false;
      const oldCardState = jsonCopy({cards: cardState, tasks: cardStateTasks, groups: cardStateGroups});
      const oldOtherState = jsonCopy({protocolEditorState});

      setSelectedWellStyle({});
      setIsOverCapacityTooltipShow(false);
      previousHoveredLabware.current = null;

      if (!swipingInfoRef.current || !enableHighlightTaskRef.current || !isLabwareAllowedPooling(labwareId)) {
        afterOnSwipeEndPooling();
        return;
      }

      const {swipingDirectionY, swipingDirectionX} = swipingInfoRef.current;
      if (!swipingInfoRef.current.tipCount) {
        swipingInfoRef.current.tipCount = {row: 1, column: 1};
      }
      swipingInfoRef.current.tipCount.row = swipingInfoRef.current.tipCount?.row ?? 1;
      swipingInfoRef.current.tipCount.column = swipingInfoRef.current.tipCount?.column ?? 1;
      swipingInfoRef.current.swipingSize = !swipingInfoRef.current.swipingSize
        ? {row: 1, column: 1}
        : swipingInfoRef.current.swipingSize;
      if (!swipingInfoRef.current.swipingEnd) {
        swipingInfoRef.current.swipingEnd = swipingInfoRef.current.swipingStart;
        swipingInfoRef.current.tipCount = {row: null, column: null};
      }

      const labwareDeckNumber = Object.keys(labwareState).find((e) => labwareState[e].LabwareID === labwareId);

      const dispenseTasks = getTaskDispensePoolingFromRef();

      // define source / edit source
      if (protocolPoolingTaskStep === 1 || protocolPoolingTaskEditStep === 1) {
        const aspirateTasks = getTaskAspiratePoolingFromRef();
        // determine the pattern
        if (
          !aspirateTasks.length &&
          poolingTipsPattern.current === null &&
          swipingInfoRef.current.swipingSize.row !== 1 &&
          swipingInfoRef.current.swipingSize.coulmn !== 1
        ) {
          poolingTipsPattern.current = swipingInfoRef.current.swipingSize;
        }
        // reset the patern if swiping size is different
        if (
          poolingTipsPattern.current &&
          (poolingTipsPattern.current.row !== swipingInfoRef.current.swipingSize.row ||
            poolingTipsPattern.current.column !== swipingInfoRef.current.swipingSize.column)
        ) {
          poolingTipsPattern.current = null;
        }

        // get tip for edit purpose
        if ((!swipingInfoRef.current.tipCount?.row || !swipingInfoRef.current.tipCount?.column) && dispenseTasks[0]) {
          [swipingInfoRef.current.tipCount.row, swipingInfoRef.current.tipCount.column] = getPoolingTipCount(
            itemID,
            dispenseTasks,
          );
        }

        const rowTipCount = swipingInfoRef.current.tipCount.row ?? 1;
        const columnTipCount = swipingInfoRef.current.tipCount.column ?? 1;
        const [skipWellMode] = getSkipWellMode(
          rowTipCount,
          columnTipCount,
          protocolPoolingTaskEditStep === 1 || protocolPoolingTaskStep === 1 ? isShift : false,
          isLabware384(labware),
        );

        const rowColumnList = generateRowColumnsListFromSwipingInfo(
          swipingInfoRef.current,
          skipWellMode,
          protocolPoolingTaskEditStep === 1 || protocolPoolingTaskStep === 1 ? isShift : false,
          {row: rowTipCount, column: columnTipCount},
        );

        // normalize for select/unselect purpose
        const [rowColumnListToAdd, taskIdToRemove] = normalizeRowColoumnList({
          rowColumnList,
          taskDispenses: getTaskAspiratePoolingFromRef(labwareId),
          isNeedOptimize: true,
          skipWellMode,
          labwareState,
          is384,
        });

        if (protocolPoolingTaskEditStep === 1 && dispenseTasks.length) {
          if (taskIdToRemove.length === dispenseTasks.length && rowColumnListToAdd.startingRowColumnList.length <= 0) {
            protocolEditorStateActionSetPoolingTaskStep(1);
          }
          taskListPoolingBusinessBatchEditPoolingAspirateTasks(
            labwareId,
            rowColumnListToAdd.startingRowColumnList,
            taskIdToRemove,
            rowColumnListToAdd.tipCount,
          );
        } else {
          taskListPoolingBusinessAddPoolingAspirateTasks(
            labwareId,
            rowColumnListToAdd.startingRowColumnList,
            rowColumnListToAdd.tipCount.row,
            rowColumnListToAdd.tipCount.column,
            true,
          );

          if (taskIdToRemove.length) {
            cardStateActionRemoveCardTasks(selectedCard?.ID, taskIdToRemove);
          }

          undoRedoBusinessActionGlobalAddUndoItem(oldCardState, {poolingLastLabware: labwareDeckNumber});

          if (!isCtrl) {
            showPoolingVolumeModal(labwareDeckNumber);
            protocolEditorStateActionSetPoolingTaskStep(2);
            poolingLastLabware.current = labwareDeckNumber;
            isPoolingCtrlPressedRef.current = false;
          } else {
            poolingLastLabware.current = labwareDeckNumber;
            isPoolingCtrlPressedRef.current = true;
          }
        }
        resetAllPoolingTasksRef();
        afterOnSwipeEndPooling();
        return;
      }

      // define destination
      if (protocolPoolingTaskStep === 3 && !protocolPoolingTaskEditStep) {
        appStateActionShowLoading(intl.formatMessage({id: 'protocolEditor.generalLoading.message'}));
        initiateGlobalWorker(async () => {
          setSelectedWellStyle({});
          const newSwipingInfo = updateSwipingInfo(
            swipingInfoRef.current,
            swipingInfoRef.current.swipingSize ?? {row: 1, column: 1},
            swipingInfoRef.current.swipingStart,
            swipingInfoRef.current.swipingEnd,
            swipingDirectionY,
            swipingDirectionX,
            getPoolingTasksFromRef(labwareId),
            false,
            false,
            true,
          );

          if (!newSwipingInfo) {
            appStateActionShowSnackbar(
              Feedback.ERROR,
              intl.formatMessage({
                id: 'protocolEditor.pooling.disallowWell',
              }),
            );
            resetAllPoolingTasksRef();
            afterOnSwipeEndPooling();
            appStateActionHideLoading();
            return;
          }

          swipingInfoRef.current = newSwipingInfo;

          // normalize

          if (swipingInfoRef.current.swipingStart.row > swipingInfoRef.current.swipingEnd.row) {
            const r = swipingInfoRef.current.swipingStart.row;
            swipingInfoRef.current.swipingStart.row = swipingInfoRef.current.swipingEnd.row;
            swipingInfoRef.current.swipingEnd.row = r;
          }

          if (swipingInfoRef.current.swipingStart.column > swipingInfoRef.current.swipingEnd.column) {
            const c = swipingInfoRef.current.swipingStart.column;
            swipingInfoRef.current.swipingStart.column = swipingInfoRef.current.swipingEnd.column;
            swipingInfoRef.current.swipingEnd.column = c;
          }

          await taskListPoolingBusinessAddPoolingDispenseTasks(
            swipingInfoRef.current.labware.LabwareID,
            swipingInfoRef.current.swipingStart.row,
            swipingInfoRef.current.swipingStart.column,
            swipingInfoRef.current.swipingSize.row,
            swipingInfoRef.current.swipingSize.column,
          );

          dispatch(onFinishPoolingWizard(selectedCard.ID));
          resetAllPoolingTasksRef();
          undoRedoBusinessActionGlobalAddUndoItem(oldCardState, null, oldOtherState);
          appStateActionHideLoading();
          afterOnSwipeEndPooling();
        });
        return;
      }

      // editing dispense task location
      if (protocolPoolingTaskEditStep && protocolPoolingTaskEditStep === 3) {
        appStateActionShowLoading(intl.formatMessage({id: 'protocolEditor.generalLoading.message'}));
        initiateGlobalWorker(async () => {
          setSelectedWellStyle({});
          const rowColumnList = generateRowColumnsListFromSwipingInfo(swipingInfoRef.current, SKIP_WELL_MODE.ALL);
          const {startingRowColumnList} = rowColumnList;
          const row = Math.min(...startingRowColumnList.map((e) => e.row));
          const column = Math.min(...startingRowColumnList.map((e) => e.column));

          const {originState} = poolingStateBeforeEdit || {};
          const {taskDispenses, labware: originDestLabware, taskAspirates: originTaskAspirates} = originState;

          // const maintainWellCount = (originDestLabware.rowCount === 1 && originDestLabware.colCount !== 1) ||
          //   (originDestLabware.rowCount !== 1 && originDestLabware.colCount === 1);

          // the well count is not maintained to adjust to different labware condition. (OP#60581)
          const maintainWellCount = false;

          taskListPoolingBusinessBatchEditPoolingDispenseTasks(
            row,
            column,
            labwareId,
            swipingInfoRef.current.swipingSize,
            originDestLabware,
            taskDispenses,
            originTaskAspirates,
            maintainWellCount,
          );
          volumeModalRef.current.hide();
          resetAllPoolingTasksRef();
          undoRedoBusinessActionGlobalAddUndoItem(oldCardState, null, oldOtherState);
          appStateActionHideLoading();
          afterOnSwipeEndPooling();
        });
        return;
      }
      resetAllPoolingTasksRef();
      undoRedoBusinessActionGlobalAddUndoItem(oldCardState, null, oldOtherState);
      afterOnSwipeEndPooling();
      poolingLastLabware.current = null;
    };

    const onEditPoolingTask = (number) => {
      const taskDispenses = jsonCopy(getTaskDispensePooling());
      const taskAspirates = jsonCopy(getTaskAspiratePooling());
      const originLabware = find(labwareState, {LabwareID: taskDispenses[0].labwareID});
      taskListPoolingBusinessSavePoolingStateBeforeEdit({taskDispenses, labware: originLabware, taskAspirates});
      protocolEditorStateActionSetPoolingTaskEditStep(number);

      if (number === 1 || number === 3) {
        setProtocolEditorMode(ProtocolEditorViewMode.POOLING);
        volumeModalRef.current.hide();

        return;
      }

      if (number === 2) {
        showPoolingVolumeModal(null, true, true);
      }
    };

    const onDeletePoolingCard = () => {
      volumeModalRef.current.hide();

      setPoolingVolumeModalOpenStatus(false);
      resetAllPoolingTasksRef();
    };

    const onPoolingHeaderBack = () => {
      const hasAspirateTask = find(cardStateTasks, {
        ID: selectedCard?.tasks,
        type: TaskType.ASPIRATE,
      });

      if (hasAspirateTask && hasAspirateTask?.volume !== 0 && !protocolVolumeModalOpen) {
        const labwareDeckNumber = Object.keys(labwareState).find(
          (e) => labwareState[e].LabwareID === hasAspirateTask.labwareID,
        );
        showPoolingVolumeModal(labwareDeckNumber, true, false, hasAspirateTask.volume);
      } else {
        taskListPoolingBusinessBackHandler(protocolPoolingTaskStep ?? protocolPoolingTaskEditStep, true);
        onDeletePoolingCard();
      }
      if (protocolPoolingTaskStep === 1 && !isPoolingCtrlPressedRef.current) {
        protocolEditorStateActionSetPoolingTaskStep(null);
      } else if (protocolPoolingTaskStep !== 1) {
        protocolEditorStateActionSetPoolingTaskStep(protocolPoolingTaskStep - 1);
      }
      resetAllPoolingTasksRef();
    };

    const onPoolingHeaderCancel = () => {
      onDeletePoolingCard();

      const stateBeforeEdit = taskListPoolingBusinessGetPoolingStateBeforeEdit();

      if (!protocolPoolingTaskEditStep && !stateBeforeEdit) {
        return;
      }

      taskListPoolingBusinessRestorePoolingStateAfterCancelEdit();
      resetAllPoolingTasksRef();
    };

    const onPoolingHeaderCancelEdit = () => {
      setPoolingVolumeModalOpenStatus(false);
      volumeModalRef.current.hide();

      const stateBeforeEdit = taskListPoolingBusinessGetPoolingStateBeforeEdit();

      if (!protocolPoolingTaskEditStep && !stateBeforeEdit) {
        return;
      }

      taskListPoolingBusinessRestorePoolingStateAfterCancelEdit();
      resetAllPoolingTasksRef();
    };

    const onCtrlKeyReleasePooling = () => {
      const taskAspirate = getTaskAspiratePooling();
      if (
        !protocolVolumeModalOpen &&
        !isPoolingSwipingRef.current &&
        protocolPoolingTaskStep === 1 &&
        taskAspirate.length
      ) {
        showPoolingVolumeModal(poolingLastLabware.current);
        protocolEditorStateActionSetPoolingTaskStep(2);
      }
    };

    const onShiftKeyReleasePooling = () => {
      if (shiftPressedRef.current === true) {
        if (swipingInfoRef?.current && (protocolPoolingTaskEditStep === 1 || protocolPoolingTaskStep === 1)) {
          reInitializeWellStyleOnShiftChange(false);
        }
        shiftPressedRef.current = false;
      }
    };

    const onShiftKeyPressPooling = () => {
      if (shiftPressedRef.current === false) {
        if (swipingInfoRef?.current && (protocolPoolingTaskEditStep === 1 || protocolPoolingTaskStep === 1)) {
          reInitializeWellStyleOnShiftChange(true);
        }
        shiftPressedRef.current = true;
      }
    };

    // #endregion pooling

    // #region mixing

    const isSwipingMixing = () => {
      if (protocolEditorMode !== ProtocolEditorViewMode.MIXING) {
        return false;
      }

      return !!swipingInfoRef?.current?.swipingStart;
    };

    const onHoverWellMixing = (itemID, row, column, labwareIndex) => {
      const labware = labwareState[itemID];
      const {LabwareID: labwareId, isIFC} = labware;

      if (isSwipingMixing() || isIFC) {
        setSelectedWellStyle({[itemID]: {}});

        return;
      }

      const [rowTipCount, columnTipCount] = [null, null];
      const [normalizedRow, normalizedColumn] = normalizeHighlightedWell(
        row,
        column,
        {row: rowTipCount, column: columnTipCount},
        labware,
        labwareIndex,
      );

      const hoveredWellStyle = {
        [itemID]: labwareBusinessGetWellStyleColor(
          labwareId,
          normalizedRow,
          normalizedColumn,
          hoverWellColorEnum,
          rowTipCount ?? 1,
          columnTipCount ?? 1,
          null,
          false,
          null,
          null,
          null,
          null,
          true,
          true,
          labwareIndex,
        ),
      };

      const selectedWells = groupedWellStylesRef.current[0];
      const wellStyleToSet = selectedWells ? mergeWellStyleByNest(hoveredWellStyle, selectedWells) : hoveredWellStyle;

      setSelectedWellStyle(wellStyleToSet);
    };

    const onSwipeStartMixing = (itemID, row, column) => {
      const labware = labwareState[itemID];

      if (labware.isIFC) {
        return;
      }

      const [normalizedRow, normalizedColumn] = normalizeHighlightedWell(
        row,
        column,
        {row: null, column: null},
        labware,
      );

      swipingInfoRef.current = initSwipingInfo(normalizedRow, normalizedColumn, labware);
    };

    const onSwipeMoveMixing = (itemID, row, column, swipingDirectionY, swipingDirectionX) => {
      if (!swipingInfoRef.current) {
        return;
      }

      const labware = labwareState[itemID];
      if (checkIs24Or48WellLabware(labware)) {
        return;
      }

      const {LabwareID: labwareId} = labware;

      const [rowTipCount, columnTipCount] = [null, null];

      const [normalizedRow, normalizedColumn] = [row, column];

      const [newSwipeDirectionX, newSwipeDirectionY] = normalizeSwipingDirection(
        normalizedColumn,
        normalizedRow,
        swipingDirectionX,
        swipingDirectionY,
        {row: rowTipCount, column: columnTipCount},
      );
      const newSwipingInfo = updateSwipingInfo(
        swipingInfoRef.current,
        {row: rowTipCount, column: columnTipCount},
        swipingInfoRef.current.swipingStart,
        {row: normalizedRow, column: normalizedColumn},
        newSwipeDirectionY,
        newSwipeDirectionX,
      );

      if (!newSwipingInfo) {
        resetSwipingInfo();

        return;
      }

      swipingInfoRef.current = newSwipingInfo;

      const [normalizedSwipingStart, , normalizedSwipingSize, skipWell] = normalizeSwipingInfo(
        swipingInfoRef.current,
        SKIP_WELL_MODE.ALL,
      );

      setSelectedWellStyle({
        [itemID]: labwareBusinessGetWellStyleColor(
          labwareId,
          normalizedSwipingStart.row,
          normalizedSwipingStart.column,
          hoverWellColorEnum,
          normalizedSwipingSize.row,
          normalizedSwipingSize.column,
          null,
          false,
          null,
          null,
          skipWell.row,
          skipWell.column,
          true,
        ),
      });
    };

    const onSwipeEndMixing = async (itemID) => {
      const labware = labwareState[itemID];
      const {LabwareID: labwareId} = labware;

      if (labware.isIFC) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({
            id: 'protocolEditor.mixing.createNew.disallowIFCLabware',
          }),
        );

        return;
      }

      if (!swipingInfoRef.current || !enableHighlightTaskRef.current) {
        return;
      }

      const {swipingDirectionY, swipingDirectionX} = swipingInfoRef.current;

      const [normalizedSwipingStart, , normalizedSwipingSize, skipWell] = normalizeSwipingInfo(swipingInfoRef.current);

      const isToggling = !swipingDirectionY && !swipingDirectionX;

      const task = filterToArray(cardStateTasks, {ID: selectedCard.tasks})[0];

      const temporaryNewTask = {labwareID: labwareId, type: TaskType.MIXING, volume: task?.volume ?? 0};

      const selectedWellStyle = {
        [itemID]: labwareBusinessGetWellStyleColor(
          labwareId,
          normalizedSwipingStart.row,
          normalizedSwipingStart.column,
          hoverWellColorEnum,
          normalizedSwipingSize?.row ?? 1,
          normalizedSwipingSize?.column ?? 1,
          null,
          false,
          null,
          null,
          skipWell?.row,
          skipWell?.column,
          true,
        ),
      };

      setSelectedWellStyle(selectedWellStyle);
      groupedWellStylesRef.current = [{...selectedWellStyle}];

      const uncompleteMixingTask = dispatch(getUncompleteMixingTask());

      // get mixing volume
      const onApplyVolumeCallback = async (result) => {
        dispatch(setFocusedDeckNumber(null));
        groupedWellStylesRef.current = [];

        if (!result) {
          await dispatch(hideAspirateDispenseVolumeModal());
          return;
        }

        const {volume} = result;

        if (!volume) {
          await dispatch(hideAspirateDispenseVolumeModal());
          return;
        }

        /*
          save aspirate dispense modal state (volume, etc) right before the new task was added
          this is done so that when user did undo, the task won't instantly disappear and the user will have the chance to edit the volume first because the volume modal will be opened
        */
        const stateToSave = {simpleTransferTaskInfo: focusedSimpleTransferTaskInfo.current};
        undoRedoBusinessActionGlobalAddUndoItem(null, stateToSave);

        if (protocolIsEditMixing) {
          taskListMixingBusinessEditMixingTask(
            labwareId,
            normalizedSwipingStart.row,
            normalizedSwipingStart.column,
            isToggling ? 1 : normalizedSwipingSize.row,
            isToggling ? 1 : normalizedSwipingSize.column,
            volume,
          );
        } else {
          taskListMixingBusinessAddMixingTask(
            labwareId,
            normalizedSwipingStart.row,
            normalizedSwipingStart.column,
            isToggling ? 1 : normalizedSwipingSize.row,
            isToggling ? 1 : normalizedSwipingSize.column,
            uncompleteMixingTask,
            volume,
            true,
          );
        }
        await dispatch(hideAspirateDispenseVolumeModal());
        setSelectedWellStyle({[itemID]: {}});
        await setProtocolEditorMode(ProtocolEditorViewMode.SIMPLE_TRANSFER);
        undoRedoBusinessActionGlobalAddUndoItem();
      };

      showSetAspirateDispenseModal(temporaryNewTask, onApplyVolumeCallback);
    };

    // #endregion mixing

    // #region transformSelection
    const InvalidMove = {IS_OVERLAPPED: 'isOverlapped'};

    // generate layout for transform selection
    const highlightedWellRef = useRef({
      ASPIRATE: null,
      DISPENSE: null,
    });

    const generateTSTasks = () => {
      let layouts = {};

      if ((selectedCard?.type !== CardType.BROADCAST && selectedCard?.type !== CardType.POOLING) || isOperator) {
        return;
      }

      Object.keys(labwareState).forEach((key) => {
        const taskList = [];
        const labware = labwareState[key];
        const wellCount = labware.colCount * labware.rowCount;

        if (key !== '2') {
          const tasks = filter(cardStateTasks, {
            labwareID: labware.LabwareID,
            ID: selectedCard.tasks,
          });

          if (selectedCard?.type === CardType.BROADCAST) {
            const broadcastSource = filterToArray(tasks, {
              type: TaskType.ASPIRATE,
            });

            if (broadcastSource.length) {
              taskList.push(broadcastSource);
            }

            const broadcastDestination = filterToArray(tasks, {
              type: TaskType.DISPENSE,
            });

            if (broadcastDestination.length) {
              taskList.push(broadcastDestination);
            }
          }

          if (selectedCard?.type === CardType.POOLING) {
            const poolingSource = filterToArray(tasks, {
              type: TaskType.ASPIRATE,
            });

            if (poolingSource.length) {
              taskList.push(poolingSource);
            }

            const poolingDestination = find(tasks, {
              type: TaskType.DISPENSE,
            });

            if (poolingDestination) {
              taskList.push([poolingDestination]);
            }
          }
        }

        if (taskList.length) {
          taskList.forEach((tasks) => {
            const columns = tasks.map((task) => task.column);
            const rows = tasks.map((task) => task.row.charCodeAt(0) - 64);
            const {rowTipCount} = tasks[0];
            const {columnTipCount} = tasks[0];
            const {type: taskType} = tasks[0];

            let type;

            if (
              (selectedCard?.type === CardType.BROADCAST && taskType === TaskType.ASPIRATE) ||
              (selectedCard?.type === CardType.POOLING && taskType === TaskType.DISPENSE)
            ) {
              type = TransformSelectionType.ONE_DIMENSION;
            } else {
              type = TransformSelectionType.TWO_DIMENSION;
            }

            const is384 = wellCount === LabwareWellCount.LABWARE_384 ? 1 : 0;

            const newID = Object.keys(layouts).length;
            const leftMostRows = tasks.map(
              (task) => task.row.charCodeAt(0) - 64 + (task.rowTipCount - 1) * (1 + is384),
            );
            const bottomMostColumns = tasks.map((task) => task.column + (task.columnTipCount - 1) * (1 + is384));
            let rowSize = Math.max(...leftMostRows) - Math.min(...rows) + 1;
            rowSize = rowSize > labware.rowCount ? labware.rowCount : rowSize;
            let columnSize = Math.max(...bottomMostColumns) - Math.min(...columns) + 1;
            columnSize = columnSize > labware.colCount ? labware.colCount : columnSize;

            layouts = {
              ...layouts,
              [newID]: {
                type,
                cardID: selectedCard?.ID,
                start: {row: Math.min(...rows), column: Math.min(...columns)},
                size: {row: rowSize, column: columnSize},
                tipCount: {row: rowTipCount, column: columnTipCount},
                labware,
                labwareID: parseInt(key, 10),
              },
            };
          });
        }
      });
      setTSLayout(layouts);
    };

    const resetHighlightedWell = () => {
      highlightedWellRef.current = {
        ASPIRATE: null,
        DISPENSE: null,
      };
    };

    const initiateHighlightedWell = () => {
      let highlightedWellAspirate = {};
      let highlightedWellDispense = {};

      Object.values(labwareState).forEach((labware) => {
        if (labware.LabwareID) {
          const {LabwareID: labwareId} = labware;
          const is384 = labware.rowCount * labware.colCount === LabwareWellCount.LABWARE_384;
          let taskAspirate = [];
          let taskDispense = [];

          if (selectedCard?.type === CardType.BROADCAST) {
            const taskAspirateBroadcast = getTaskAspirateBroadcastFromRef(labwareId);
            taskAspirate = taskAspirateBroadcast ? [taskAspirateBroadcast] : [];
            taskDispense = getTaskDispensesBroadcastFromRef(labwareId);
          } else if (selectedCard?.type === CardType.POOLING) {
            const taskDispensePooling = getTaskDispensePoolingFromRef(labwareId)[0];
            taskAspirate = getTaskAspiratePoolingFromRef(labwareId);
            taskDispense = taskDispensePooling ? [taskDispensePooling] : [];
          }

          if (taskAspirate.length) {
            const [skipWellMode] = getSkipWellMode(
              taskAspirate[0].rowTipCount,
              taskAspirate[0].columnTipCount,
              false,
              is384,
            );
            highlightedWellAspirate = {
              ...highlightedWellAspirate,
              [labwareId]: getHighlightedWellFromTask(taskAspirate, skipWellMode),
            };
          }

          if (taskDispense.length) {
            const [skipWellMode] = getSkipWellMode(
              taskDispense[0].rowTipCount,
              taskDispense[0].columnTipCount,
              false,
              is384,
            );
            highlightedWellDispense = {
              ...highlightedWellDispense,
              [labwareId]: getHighlightedWellFromTask(taskDispense, skipWellMode),
            };
          }
        }
      });

      highlightedWellRef.current = {
        ASPIRATE: highlightedWellAspirate,
        DISPENSE: highlightedWellDispense,
      };
    };

    useEffect(() => {
      if (!runtimeMode) {
        generateTSTasks();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cardStateTasks, selectedCard, labwareState]);

    useEffect(() => {
      if (!runtimeMode && (selectedCard?.type === CardType.BROADCAST || selectedCard?.type === CardType.POOLING)) {
        setShowTS(
          !highlightedTask &&
            !(
              protocolEditorMode === ProtocolEditorViewMode.BROADCAST ||
              protocolEditorMode === ProtocolEditorViewMode.POOLING ||
              protocolEditorMode === ProtocolEditorViewMode.MIXING
            ),
        );
      } else {
        setShowTS(false);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCard, protocolEditorMode, highlightedTask, TSLayout]);

    useEffect(() => {
      if (!runtimeMode) {
        if (showTS) {
          if (selectedCard?.type === CardType.BROADCAST) {
            initializeBroadcastTasks();
          }
          if (selectedCard?.type === CardType.POOLING) {
            initializePoolingTasks();
          }
        } else {
          resetAllBroadcastTasksRef();
          resetAllPoolingTasksRef();
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cardStateTasks, selectedCard, showTS]);

    useEffect(() => {
      if (!runtimeMode) {
        if (showTS) {
          initiateHighlightedWell();
        } else {
          resetHighlightedWell();
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [broadcastTasksRef.current, poolingTasksRef.current, showTS]);

    const isBroadcastDropNotAllowed = (dragLayout, rowStart, columnStart, targetLabware) => {
      const {type, start, labware, tipCount} = dragLayout;
      const {LabwareID: labwareId} = labware;
      const {LabwareID: targetLabwareId, labwareIndexes} = targetLabware;
      const usedTipCount = tipCount.row * tipCount.column;

      if (labwareIndexes) {
        return true;
      }

      if (checkIs24Or48WellLabware(targetLabware) && usedTipCount !== 1) {
        return true;
      }

      const isTargetLabware384 = targetLabware.rowCount * targetLabware.colCount === LabwareWellCount.LABWARE_384;

      if (
        !isSameQuadrant.current &&
        labware.rowCount > targetLabware.rowCount &&
        labware.colCount > targetLabware.colCount
      ) {
        return true;
      }

      const rowDiff = start.row - rowStart;
      const columnDiff = start.column - columnStart;

      let highlightedWell = [];
      let draggedHighlightedWell = [];

      if (type === TransformSelectionType.ONE_DIMENSION) {
        highlightedWell = highlightedWellRef.current.DISPENSE[targetLabwareId] ?? [];
      } else if (type === TransformSelectionType.TWO_DIMENSION) {
        const highlightedWellDispense =
          targetLabwareId !== labwareId ? highlightedWellRef.current.DISPENSE[targetLabwareId] : [];
        const highlightedWellAspirate = highlightedWellRef.current.ASPIRATE[targetLabwareId] ?? [];
        highlightedWell = _.concat(highlightedWellAspirate, highlightedWellDispense);
      }

      if (!highlightedWell.length) {
        return false;
      }

      const startList = getNewStartFromTaskList(
        {row: rowDiff, column: columnDiff},
        draggedTasksRef.current,
        targetLabware,
        labware,
        start,
        type === TransformSelectionType.ONE_DIMENSION,
      );

      startList.forEach((newStart) => {
        const [skipWellMode] = getSkipWellMode(
          newStart.tipCount.row,
          newStart.tipCount.column,
          false,
          isTargetLabware384,
        );
        const wellFromTask = getHighlightedWell(
          newStart.row,
          newStart.column,
          newStart.tipCount.row,
          newStart.tipCount.column,
          skipWellMode,
        );
        draggedHighlightedWell = _.concat(draggedHighlightedWell, wellFromTask);
      });

      if (targetLabware.rowCount > 1 && targetLabware.colCount === 1) {
        // labware 8 well
        const rowCounter = {};
        draggedHighlightedWell.forEach((well) => {
          const row = well.split('-')[0];
          const counter = rowCounter[row] ?? 0;
          rowCounter[row] = counter + 1;
        });

        const rowCounterValue = [...new Set(Object.values(rowCounter))];

        const isOverlap = rowCounterValue.length > 1 && rowCounterValue.find((e) => e > tipCount.column);

        if (isOverlap) return InvalidMove.IS_OVERLAPPED;
      } else if (targetLabware.rowCount === 1 && targetLabware.colCount > 1) {
        // labware 12 well
        const columnCounter = {};
        draggedHighlightedWell.forEach((well) => {
          const column = well.split('-')[1];
          const counter = columnCounter[column] ?? 0;
          columnCounter[column] = counter + 1;
        });

        const columnCounterValue = [...new Set(Object.values(columnCounter))];

        const isOverlap = columnCounterValue.length > 1 && columnCounterValue.find((e) => e > tipCount.row);

        if (isOverlap) {
          return InvalidMove.IS_OVERLAPPED;
        }
      }

      return draggedHighlightedWell.some((well) => highlightedWell.includes(well));
    };

    const isPoolingDropNotAllowed = (dragLayout, rowStart, columnStart, targetLabware) => {
      const {type, start, labware, tipCount} = dragLayout;
      const {LabwareID: labwareId} = labware;
      const {LabwareID: targetLabwareId, labwareIndexes} = targetLabware;
      const usedTipCount = tipCount.row * tipCount.column;

      if (labwareIndexes) {
        return true;
      }

      if (checkIs24Or48WellLabware(targetLabware) && usedTipCount !== 1) {
        return true;
      }

      const isTargetLabware384 = targetLabware.rowCount * targetLabware.colCount === LabwareWellCount.LABWARE_384;

      if (
        !isSameQuadrant.current &&
        labware.rowCount > targetLabware.rowCount &&
        labware.colCount > targetLabware.colCount
      ) {
        return true;
      }

      const rowDiff = start.row - rowStart;
      const columnDiff = start.column - columnStart;

      let highlightedWell = [];
      let draggedHighlightedWell = [];

      if (type === TransformSelectionType.ONE_DIMENSION) {
        highlightedWell = highlightedWellRef.current.ASPIRATE[targetLabwareId] ?? [];
      } else if (type === TransformSelectionType.TWO_DIMENSION) {
        const highlightedWellAspirate =
          targetLabwareId !== labwareId ? highlightedWellRef.current.ASPIRATE[targetLabwareId] : [];
        const highlightedWellDispense = highlightedWellRef.current.DISPENSE[targetLabwareId] ?? [];

        highlightedWell = _.concat(highlightedWellAspirate, highlightedWellDispense);
      }

      if (!highlightedWell.length) {
        return false;
      }

      const startList = getNewStartFromTaskList(
        {row: rowDiff, column: columnDiff},
        draggedTasksRef.current,
        targetLabware,
        labware,
        start,
        type === TransformSelectionType.ONE_DIMENSION,
      );

      startList.forEach((newStart) => {
        const [skipWellMode] = getSkipWellMode(
          newStart.tipCount.row,
          newStart.tipCount.column,
          false,
          isTargetLabware384,
        );
        const wellFromTask = getHighlightedWell(
          newStart.row,
          newStart.column,
          newStart.tipCount.row,
          newStart.tipCount.column,
          skipWellMode,
        );
        draggedHighlightedWell = _.concat(draggedHighlightedWell, wellFromTask);
      });

      if (targetLabware.rowCount > 1 && targetLabware.colCount === 1) {
        // labware 8 well
        const startRows = _.uniq(startList.map((e) => e.row));
        if (startRows.length > 1) {
          const rowCounter = {};
          draggedHighlightedWell.forEach((well) => {
            const row = well.split('-')[0];
            const counter = rowCounter[row] ?? 0;
            rowCounter[row] = counter + 1;
          });

          const isOverlap = Object.values(rowCounter).find((e) => e > tipCount.column);

          if (isOverlap) return InvalidMove.IS_OVERLAPPED;
        }
      } else if (targetLabware.rowCount === 1 && targetLabware.colCount > 1) {
        // labware 12 well
        const startColumns = _.uniq(startList.map((e) => e.column));
        if (startColumns.length > 1) {
          const columnCounter = {};
          draggedHighlightedWell.forEach((well) => {
            const column = well.split('-')[1];
            const counter = columnCounter[column] ?? 0;
            columnCounter[column] = counter + 1;
          });

          const isOverlap = Object.values(columnCounter).find((e) => e > tipCount.row);

          if (isOverlap) return InvalidMove.IS_OVERLAPPED;
        }
      }

      return draggedHighlightedWell.some((well) => highlightedWell.includes(well));
    };

    const onDragTransformSelection = useStaticCallback((itemID) => {
      setHoveredLabwareId(itemID);
      let draggedTasks = [];

      if (selectedCardRef?.current?.type === CardType.POOLING) {
        if (draggedLayout?.type === TransformSelectionType.ONE_DIMENSION) {
          const dispenseTaskPooling = getTaskDispensePooling(draggedLayout?.labware?.LabwareID);
          draggedTasks = [dispenseTaskPooling[0]];
        } else {
          draggedTasks = getTaskAspiratePooling(draggedLayout?.labware?.LabwareID);
        }
      } else if (selectedCardRef?.current?.type === CardType.BROADCAST) {
        if (draggedLayout?.type === TransformSelectionType.ONE_DIMENSION) {
          draggedTasks = [getTaskAspirateBroadcastFromRef(draggedLayout?.labware?.LabwareID)];
        } else {
          draggedTasks = getTaskDispensesBroadcastFromRef(draggedLayout?.labware?.LabwareID);
        }
      }

      draggedTasksRef.current = getTaskGroups(draggedTasks, labwareState);

      const taskRows = selectDistinct(draggedTasksRef.current.map((e) => e.row)).sort();
      const taskColumns = selectDistinct(draggedTasksRef.current.map((e) => e.column)).sort((a, b) => a - b);

      draggedCornerRef.current = {row: taskRows[0], column: taskColumns[0]};

      const {labware} = draggedLayout;
      const is384 = labware.rowCount * labware.colCount === LabwareWellCount.LABWARE_384;

      const [sameQuadrant, quadrantList] = isTasksSameQuadrant(draggedTasksRef.current, is384, true);

      isSameQuadrant.current = sameQuadrant;

      const sameRowQuadrant =
        sameQuadrant ||
        (quadrantList.length === 2 &&
          (_.isEqual(quadrantList.sort(), [1, 2]) || _.isEqual(quadrantList.sort(), [3, 4])));
      isSameRowQuadrantRef.current = sameRowQuadrant;

      const sameColumnQuadrant =
        sameQuadrant ||
        (quadrantList.length === 2 &&
          (_.isEqual(quadrantList.sort(), [1, 4]) || _.isEqual(quadrantList.sort(), [2, 3])));
      isSameColumnQuadrantRef.current = sameColumnQuadrant;
    });

    const onHoverTransformSelection = useStaticCallback(
      (hoveredItemId, clientOffset, itemID, targetRow, targetColumn) => {
        if (hoveredLabwareId !== hoveredItemId) {
          setHoveredWellState({
            ...hoveredWellState,
            [hoveredLabwareId]: {row: null, column: null},
          });
          setHoveredLabwareId(hoveredItemId);
        }

        const hoveredWellStyle = {
          [itemID]: {},
        };

        const targetedWell = targetedWellRef.current;
        if (!targetedWell || targetedWell?.row !== targetRow || targetedWell?.column !== targetColumn) {
          targetedWellRef.current = {row: targetRow, column: targetColumn};
        }

        if (targetedWell?.row === targetRow && targetedWell?.column === targetColumn) {
          hoveredWellRef.current = null;
          return;
        }

        const targetLabware = labwareState[hoveredItemId];
        const sourceLabware = labwareState[draggedLayout.labwareID];
        const isTarget384 = targetLabware.rowCount * targetLabware.colCount === LabwareWellCount.LABWARE_384;
        const isOrigin384 =
          draggedLayout.labware.rowCount * draggedLayout.labware.colCount === LabwareWellCount.LABWARE_384;

        const [rightItem, leftItem, topItem, bottomItem] = getDragHandlePosition(
          targetLabware,
          draggedLayout,
          draggedHandle,
        );

        const [rowStart, columnStart, rowSize, columnSize] = getDragDropRowCol(
          targetRow,
          targetColumn,
          rightItem,
          leftItem,
          topItem,
          bottomItem,
          !isSameRowQuadrantRef.current,
          !isSameColumnQuadrantRef.current,
          draggedLayout,
          targetLabware,
          sourceLabware,
        );

        const [normalizeRow, normalizeColumn] = normalizeHighlightedWell(
          rowStart,
          columnStart,
          {row: rowSize, column: columnSize},
          targetLabware,
        );

        let isDropAllowed = true;
        if (selectedCard.type === CardType.BROADCAST) {
          isDropAllowed = !isBroadcastDropNotAllowed(draggedLayout, normalizeRow, normalizeColumn, targetLabware);
        } else if (selectedCard.type === CardType.POOLING) {
          isDropAllowed = !isPoolingDropNotAllowed(draggedLayout, normalizeRow, normalizeColumn, targetLabware);
        }

        if (!isDropAllowed) {
          if (targetedWell) {
            setSelectedWellStyle(hoveredWellStyle);
            targetedWellRef.current = null;
          }
          hoveredWellRef.current = null;
          return;
        }

        const hoveredWell = hoveredWellRef.current;
        if (!hoveredWell || hoveredWell.row !== normalizeRow || hoveredWell.column !== normalizeColumn) {
          hoveredWellRef.current = {row: normalizeRow, column: normalizeColumn};
        }

        if (
          hoveredLabwareId === hoveredItemId &&
          hoveredWell?.row === normalizeRow &&
          hoveredWell?.column === normalizeColumn
        ) {
          return;
        }

        const wellColor = '#C0D6FB';

        if (normalizeRow && normalizeColumn) {
          const rowDiff = draggedCornerRef.current.row
            ? normalizeRow - convertRowToNumeric(draggedCornerRef.current.row)
            : undefined;
          const colDiff = draggedCornerRef.current.column
            ? normalizeColumn - draggedCornerRef.current.column
            : undefined;

          if (
            draggedLayout.type === TransformSelectionType.TWO_DIMENSION &&
            draggedCornerRef.current.row &&
            draggedCornerRef.current.column
          ) {
            hoveredWellStyle[itemID] = {};

            let rowIncrementer = 0;
            let columnIncrementer = 0;

            draggedTasksRef.current.forEach((task) => {
              const rowNumber = convertRowToNumeric(task.row);

              let draggedCornerRowDiff = Math.abs(convertRowToNumeric(draggedCornerRef.current.row) - rowNumber);
              let draggedCornerColDiff = Math.abs(draggedCornerRef.current.column - task.column);

              if (isOrigin384 && !isTarget384) {
                draggedCornerRowDiff /= 2;
                draggedCornerColDiff /= 2;
              }

              rowIncrementer =
                // eslint-disable-next-line no-nested-ternary
                (isTarget384 && !isOrigin384 ? 1 : isOrigin384 && !isTarget384 ? -1 : 0) * draggedCornerRowDiff;
              columnIncrementer =
                // eslint-disable-next-line no-nested-ternary
                (isTarget384 && !isOrigin384 ? 1 : isOrigin384 && !isTarget384 ? -1 : 0) * draggedCornerColDiff;

              let newRow = convertRowToNumeric(task.row) + rowDiff + rowIncrementer;
              let newCol = task.column + colDiff + columnIncrementer;

              if (targetLabware.colCount === 1) {
                newCol = 1;
              }
              if (targetLabware.rowCount === 1) {
                newRow = 1;
              }

              const newRowTipCount = Math.min(rowSize, task.rowTipCount);
              const newColumnTipCount = Math.min(columnSize, task.columnTipCount);

              const newHoveredWell = labwareBusinessGetWellStyleColor(
                targetLabware.LabwareID,
                newRow,
                newCol,
                wellColor,
                newRowTipCount,
                newColumnTipCount,
                null,
                null,
                null,
                null,
                null,
                null,
                true,
              );

              hoveredWellStyle[itemID] = {
                ...hoveredWellStyle[itemID],
                ...newHoveredWell,
              };
            });
          } else {
            hoveredWellStyle[itemID] = labwareBusinessGetWellStyleColor(
              targetLabware.LabwareID,
              normalizeRow,
              normalizeColumn,
              wellColor,
              rowSize,
              columnSize,
              null,
              null,
              null,
              null,
              null,
              null,
              true,
            );
          }
        }

        setSelectedWellStyle(hoveredWellStyle);

        // check is well over capacity on pooling
        if (selectedCardRef?.current?.type !== CardType.POOLING) {
          return;
        }

        if (isOverCapacityTooltipShow) {
          setTooltipPosition({x: clientOffset.x, y: clientOffset.y});
        }
        if (previousHoveredLabware.current !== hoveredLabwareId) {
          const taskAspirates = getTaskAspiratePooling();
          if (!taskAspirates?.length) {
            return;
          }
          const taskAspirate = taskAspirates[0];

          const labware = labwareState[hoveredLabwareId];
          if (!labware) {
            return;
          }
          const {workingCapacity} = labware;

          const dispenseMixingVolume = taskAspirates.length * taskAspirate.volume;
          if (workingCapacity < dispenseMixingVolume) {
            setIsOverCapacityTooltipShow(true);
            setOverCapacityMessage('protocolEditor.pooling.moveWellOverCapacity');
            setTooltipPosition({x: clientOffset.x, y: clientOffset.y});
          } else {
            setIsOverCapacityTooltipShow(false);
            setOverCapacityMessage('protocolEditor.pooling.wellOverCapacity');
          }
          previousHoveredLabware.current = hoveredLabwareId;
        }
      },
    );

    const onDropBroadcast = (destItemID, clientOffset, dropZoneContainer, itemID, col, row) => {
      const {height, width, left, top} = dropZoneContainer;
      const wellSize = {height: height / col, width: width / row};

      const {start: oldStart, labware: originLabware} = draggedLayout;

      const droppedRow = Math.ceil((width + left - clientOffset.x) / wellSize.width);
      const droppedCol = Math.ceil((clientOffset.y - top) / wellSize.height);

      const targetLabware = labwareState[destItemID];
      const {LabwareID} = targetLabware;
      const sourceLabware = labwareState[draggedLayout.labwareID];

      const [rightItem, leftItem, topItem, bottomItem] = getDragHandlePosition(
        targetLabware,
        draggedLayout,
        draggedHandle,
      );

      const [newRowStart, newColumnStart, newRowSize, newColumnSize] = getDragDropRowCol(
        droppedRow,
        droppedCol,
        rightItem,
        leftItem,
        topItem,
        bottomItem,
        !isSameRowQuadrantRef.current,
        !isSameColumnQuadrantRef.current,
        draggedLayout,
        targetLabware,
        sourceLabware,
      );

      const [normalizeRowStart, normalizeColumnStart] = normalizeHighlightedWell(
        newRowStart,
        newColumnStart,
        {row: newRowSize, column: newColumnSize},
        targetLabware,
      );

      const isDropNotAllowed = isBroadcastDropNotAllowed(
        draggedLayout,
        normalizeRowStart,
        normalizeColumnStart,
        targetLabware,
      );

      if (isDropNotAllowed === InvalidMove.IS_OVERLAPPED) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage(
            {id: 'protocolEditor.broadcast.disallowToMove'},
            {
              origin: sourceLabware.rowCount * sourceLabware.colCount,
              target: targetLabware.rowCount * targetLabware.colCount,
            },
          ),
        );
        return;
      }
      if (isDropNotAllowed) {
        appStateActionShowSnackbar(Feedback.ERROR, intl.formatMessage({id: 'protocolEditor.broadcast.disallowWell'}));
        return;
      }

      if (
        oldStart.row === normalizeRowStart &&
        oldStart.column === normalizeColumnStart &&
        originLabware.LabwareID === LabwareID
      ) {
        return;
      }

      const oldCard = {
        tasks: jsonCopy(cardStateTasks),
        cards: jsonCopy(cardState),
        groups: jsonCopy(cardStateGroups),
      };
      const oldLabware = jsonCopy(labwareState);
      const oldTemporaryState = jsonCopy(temporaryState);

      switch (draggedLayout.type) {
        case TransformSelectionType.ONE_DIMENSION: {
          taskListBroadcastBusinessBatchEditBroadcastAspirateTasks(
            normalizeRowStart,
            normalizeColumnStart,
            LabwareID,
            true,
          );
          break;
        }
        case TransformSelectionType.TWO_DIMENSION: {
          taskListBroadcastBusinessBatchEditBroadcastDispenseTasks(
            normalizeRowStart,
            normalizeColumnStart,
            LabwareID,
            originLabware,
            true,
          );
          break;
        }
        default:
          break;
      }

      appStateActionShowSnackbar(
        Feedback.SUCCESS,
        intl.formatMessage({id: 'protocolEditor.broadcast.editTask.successMessage'}),
      );

      const hoveredWellStyle = {
        [itemID]: {},
      };

      setSelectedWellStyle(hoveredWellStyle);

      const isNeedOptimize =
        draggedLayout.type === TransformSelectionType.ONE_DIMENSION &&
        (originLabware.isTrough || targetLabware.isTrough);

      const isReuseTips = selectedCard && 'reuseTips' in selectedCard ? selectedCard.reuseTips : false;

      taskListBroadcastBusinessOptimizeBroadcastCard(false, originLabware, false, isNeedOptimize, isReuseTips);
      undoRedoBusinessActionGlobalAddUndoItem(
        oldCard,
        {},
        {labwareState: oldLabware, temporaryState: oldTemporaryState},
      );
      isSameQuadrant.current = true;
    };

    const onDropPooling = (destItemID, clientOffset, dropZoneContainer, itemID, col, row) => {
      const {height, width, left, top} = dropZoneContainer;
      const wellSize = {height: height / col, width: width / row};

      const {start: originStart, labware: originLabware} = draggedLayout;

      const droppedRow = Math.ceil((width + left - clientOffset.x) / wellSize.width);
      const droppedCol = Math.ceil((clientOffset.y - top) / wellSize.height);

      const destinationLayout = find(TSLayout, {type: TransformSelectionType.ONE_DIMENSION});
      const {tipCount} = destinationLayout;

      const targetLabware = labwareState[destItemID];
      const {LabwareID} = targetLabware;
      const sourceLabware = labwareState[draggedLayout.labwareID];

      const [rightItem, leftItem, topItem, bottomItem] = getDragHandlePosition(
        targetLabware,
        draggedLayout,
        draggedHandle,
      );

      setIsOverCapacityTooltipShow(false);
      setOverCapacityMessage('protocolEditor.pooling.wellOverCapacity');
      previousHoveredLabware.current = null;

      const [newRowStart, newColumnStart, newRowSize, newColumnSize] = getDragDropRowCol(
        droppedRow,
        droppedCol,
        rightItem,
        leftItem,
        topItem,
        bottomItem,
        !isSameRowQuadrantRef.current,
        !isSameColumnQuadrantRef.current,
        draggedLayout,
        targetLabware,
        sourceLabware,
      );

      const [normalizeRowStart, normalizeColumnStart] = normalizeHighlightedWell(
        newRowStart,
        newColumnStart,
        {row: newRowSize, column: newColumnSize},
        targetLabware,
      );

      const isDropNotAllowed = isPoolingDropNotAllowed(
        draggedLayout,
        normalizeRowStart,
        normalizeColumnStart,
        targetLabware,
      );

      if (isDropNotAllowed === InvalidMove.IS_OVERLAPPED) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage(
            {id: 'protocolEditor.pooling.disallowToMove'},
            {
              origin: sourceLabware.rowCount * sourceLabware.colCount,
              target: targetLabware.rowCount * targetLabware.colCount,
            },
          ),
        );
        return;
      }
      if (isDropNotAllowed) {
        appStateActionShowSnackbar(Feedback.ERROR, intl.formatMessage({id: 'protocolEditor.pooling.disallowResize'}));
        return;
      }

      const hoveredWellStyle = {
        [itemID]: {},
      };

      const targetedWell = targetedWellRef.current;

      if (
        originStart.row === normalizeRowStart &&
        originStart.column === normalizeColumnStart &&
        originLabware.LabwareID === LabwareID
      ) {
        if (targetedWell) {
          setSelectedWellStyle(hoveredWellStyle);
          targetedWellRef.current = null;
        }
        hoveredWellRef.current = null;
        return;
      }

      const oldCard = {
        tasks: jsonCopy(cardStateTasks),
        cards: jsonCopy(cardState),
        groups: jsonCopy(cardStateGroups),
      };
      const oldLabware = jsonCopy(labwareState);
      const oldTemporaryState = jsonCopy(temporaryState);

      switch (draggedLayout.type) {
        // pooling source
        case TransformSelectionType.TWO_DIMENSION: {
          taskListPoolingBusinessBatchMovePoolingAspirateTasks(
            normalizeRowStart,
            normalizeColumnStart,
            LabwareID,
            originLabware.LabwareID,
          );

          setPoolingAllowedTips();
          break;
        }
        // pooling destination
        case TransformSelectionType.ONE_DIMENSION: {
          const destinationLabware = originLabware;

          const poolingSourceTask = filterToArray(cardStateTasksRef.current, {
            ID: selectedCard.tasks,
            type: TaskType.ASPIRATE,
          });

          const poolingDestinationTasks = filterToArray(cardStateTasksRef.current, {
            ID: selectedCard.tasks,
            type: TaskType.DISPENSE,
          });

          const {rowCount, colCount} = destinationLabware;

          const normalizeTipCount = {
            row: rowCount === 1 ? 1 : tipCount.row,
            column: colCount === 1 ? 1 : tipCount.column,
          };

          taskListPoolingBusinessBatchEditPoolingDispenseTasks(
            normalizeRowStart,
            normalizeColumnStart,
            LabwareID,
            normalizeTipCount,
            destinationLabware,
            poolingDestinationTasks,
            poolingSourceTask,
          );

          break;
        }
        default:
          break;
      }

      appStateActionShowSnackbar(
        Feedback.SUCCESS,
        intl.formatMessage({id: 'protocolEditor.pooling.editTask.successMessage'}),
      );

      setSelectedWellStyle(hoveredWellStyle);
      undoRedoBusinessActionGlobalAddUndoItem(
        oldCard,
        {},
        {labwareState: oldLabware, temporaryState: oldTemporaryState},
      );
    };

    const onDropTransformSelection = useStaticCallback(
      (destItemID, clientOffset, dropZoneContainer, itemID, col, row) => {
        switch (selectedCard.type) {
          case CardType.BROADCAST:
            onDropBroadcast(destItemID, clientOffset, dropZoneContainer, itemID, col, row);
            break;
          case CardType.POOLING:
            onDropPooling(destItemID, clientOffset, dropZoneContainer, itemID, col, row);
            break;
          default:
            break;
        }
      },
    );

    // #endregion transformSelection

    // #region global undo redo

    const restoreStateonUndoRedo = (response) => {
      if (!response) {
        return;
      }

      const {
        protocolEditorState: protocolEditorResp,
        normalizationState: normalizationStateUndoRedo,
        virtualTrayState,
        otherState,
      } = response;
      const {
        selectedMenu,
        selectedTipChannel: tipChannel,
        customTipCount,
        ADModalShown,
        isEditMixing: editMixing,
        volumeModalOpen: isVolumeModalOpen,
        broadcastTaskEditStep: broadcastTaskEditStepResp,
        poolingTaskStep: poolingTaskStepResp,
        poolingTaskEditStep: poolingTaskEditStepResp,
        serialDilutionStep,
        serialDilutionEditStep,
        serialDilutionPrevStep,
        normalizationTaskEditStep: normalizationTaskEditStepResp,
      } = protocolEditorResp;
      const {currentWizardView, selectedLabware, currentVolume} = normalizationStateUndoRedo;

      const {aspirateDispenseVolumeModal} = virtualTrayState;

      // update value in volume modal
      if (
        selectedMenu === ProtocolEditorViewMode.NORMALIZATION &&
        currentVolume !== normalizationState.currentVolume &&
        currentWizardView === NormalizationStep.SET_DILUENT_LABWARE
      ) {
        const labwareIndex = Object.values(labwareState).findIndex((el) => el.LabwareID === selectedLabware.LabwareID);
        const selectedDeck = labwareIndex + 1;
        initialValueVolumeModal.current = currentVolume;
        showNormalizationVolumeModal(selectedDeck, currentVolume, true);
      }
      // show/hide volume modal
      if (
        (isVolumeModalOpen && !protocolVolumeModalOpen) ||
        poolingTaskEditStepResp === 2 ||
        broadcastTaskEditStepResp === 3
      ) {
        if (selectedMenu === ProtocolEditorViewMode.BROADCAST || broadcastTaskEditStepResp === 3) {
          const {broadcastVolume} = otherState;
          initialValueVolumeModal.current = broadcastVolume;
          showBroadcastVolumeModal(null, true, broadcastVolume);
          protocolEditorStateActionSetVolumeModalOpen(isVolumeModalOpen);
        } else if (selectedMenu === ProtocolEditorViewMode.POOLING || poolingTaskEditStepResp === 2) {
          const {poolingVolume, poolingLastLabware: lastLabware} = otherState;
          showPoolingVolumeModal(lastLabware, false, true, poolingVolume);
          setPoolingVolumeModalOpenStatus(isVolumeModalOpen);
        } else if (
          selectedMenu === ProtocolEditorViewMode.NORMALIZATION &&
          currentWizardView === NormalizationStep.SET_DILUENT_LABWARE
        ) {
          const labwareIndex = Object.values(labwareState).findIndex(
            (el) => el.LabwareID === selectedLabware.LabwareID,
          );
          const selectedDeck = labwareIndex + 1;
          initialValueVolumeModal.current = currentVolume;
          showNormalizationVolumeModal(selectedDeck, currentVolume, true);
        }
      } else if (!isVolumeModalOpen && protocolVolumeModalOpen) {
        initialValueVolumeModal.current = 0;
        if (selectedMenu === ProtocolEditorViewMode.POOLING) {
          volumeModalRef.current.hide();
          setPoolingVolumeModalOpenStatus(isVolumeModalOpen);
        } else if (selectedMenu === ProtocolEditorViewMode.NORMALIZATION) {
          volumeModalRef.current.hide();
          protocolEditorStateActionSetVolumeModalOpen(isVolumeModalOpen);
        } else {
          volumeModalRef.current.hide();
          protocolEditorStateActionSetVolumeModalOpen(isVolumeModalOpen);
        }
      }

      if (isVolumeModalOpen && protocolVolumeModalOpen) {
        if (selectedMenu === ProtocolEditorViewMode.BROADCAST) {
          const {broadcastVolume} = otherState;
          initialValueVolumeModal.current = broadcastVolume;
          showBroadcastVolumeModal(null, true, broadcastVolume);
        } else if (selectedMenu === ProtocolEditorViewMode.POOLING) {
          const {poolingVolume, poolingLastLabware: lastLabware} = otherState;
          initialValueVolumeModal.current = poolingVolume;
          showPoolingVolumeModal(lastLabware, false, true, poolingVolume);
        }
      }

      // show/hide aspirate dispense modal
      if (ADModalShown || aspirateDispenseVolumeModal.isShown) {
        const {simpleTransferTaskInfo} = otherState;

        if (simpleTransferTaskInfo) {
          // well info
          const {row, column, rowTipCount, columnTipCount} = simpleTransferTaskInfo;
          // labware info
          const {itemID: deckNumber, labwareId, labwareIndex} = simpleTransferTaskInfo;

          if (!aspirateDispenseVolumeModal.volume) {
            simpleTransferHideVolumeModal();
          } else {
            focusedSimpleTransferTaskInfo.current = simpleTransferTaskInfo;

            setSelectedWellStyle({
              [deckNumber]: labwareBusinessGetWellStyleColor(
                labwareId,
                row,
                column,
                hoverWellColorEnum,
                rowTipCount,
                columnTipCount,
                tipChannel,
                null,
                null,
                null,
                null,
                null,
                null,
                true,
                labwareIndex,
              ),
            });
          }
        } else {
          dispatch(setAspirateDispenseVolumeModal(aspirateDispenseVolumeModal));
        }
      } else if (!ADModalShown || !aspirateDispenseVolumeModal.isShown) {
        prevSimpleTransferVolume.current = simpleTransferVolume.current;
        simpleTransferHideVolumeModal();
      }

      if (selectedMenu === ProtocolEditorViewMode.SERIAL_DILUTION) {
        const {sdProperty} = otherState;

        if (sdProperty) {
          setSdProperty(sdProperty);
        } else {
          setSdProperty({
            sampleVolume: 0,
            ratio: 1,
            diluentVolume: 0,
            step: 1,
            reuseTips: true,
          });
        }
      }

      if (selectedMenu === ProtocolEditorViewMode.POOLING) {
        const {poolingLastLabware: lastLabware} = otherState;

        if (lastLabware) {
          poolingLastLabware.current = lastLabware;
        }
      }

      setProtocolEditorMode(selectedMenu);
      protocolEditorStateActionSetSelectedTipChannel(tipChannel);
      protocolEditorStateActionSetCustomTipCount(customTipCount);

      protocolEditorStateActionSetBroadcastTaskEditStep(broadcastTaskEditStepResp);
      resetAllBroadcastTasksRef();

      protocolEditorStateActionSetPoolingTaskStep(poolingTaskStepResp);
      protocolEditorStateActionSetPoolingTaskEditStep(poolingTaskEditStepResp);

      protocolEditorStateActionSetSerialDilutionStep(serialDilutionStep);
      protocolEditorStateActionSetSerialDilutionEditStep(serialDilutionEditStep);
      protocolEditorStateActionSetSerialDilutionPrevStep(serialDilutionPrevStep);

      protocolEditorStateActionSetNormalizationTaskEditStep(normalizationTaskEditStepResp);
      setNormalizationStep(currentWizardView);

      protocolEditorStateActionSetIsEditMixing(editMixing);
      stateBusinessSaveState(false);
    };

    function onGlobalUndo() {
      const response = undoRedoBusinessActionGlobalUndo();

      restoreStateonUndoRedo(response);
    }

    function onGlobalRedo() {
      const response = undoRedoBusinessActionGlobalRedo();

      restoreStateonUndoRedo(response, true);
    }

    function onUndoRedoKeyPress(evt) {
      const {keyCode} = evt;
      if (runtimeMode || isModalShowing || isLoadingShowing) {
        return;
      }

      if (
        keyCode !== KeyboardKey.CTRL &&
        keyCode !== KeyboardKey.SHIFT &&
        keyCode !== KeyboardKey.Y &&
        keyCode !== KeyboardKey.Z
      ) {
        return;
      }

      const keyCodeList = keyCodePressdList.current;

      if (!keyCodeList.includes(keyCode)) {
        keyCodeList.push(keyCode);
      }

      const isCtrlKeyPressed = keyCodeList.includes(KeyboardKey.CTRL);
      const isShiftKeyPressed = keyCodeList.includes(KeyboardKey.SHIFT);
      const isZKeyPressed = keyCodeList.includes(KeyboardKey.Z);
      const isYKeyPressed = keyCodeList.includes(KeyboardKey.Y);

      if (keyCodeList.length === 2) {
        if (isCtrlKeyPressed && isZKeyPressed) {
          evt.preventDefault();
          onGlobalUndo();
          return;
        }
        if (isCtrlKeyPressed && isYKeyPressed) {
          evt.preventDefault();
          onGlobalRedo();
          return;
        }
      }

      if (keyCodeList.length === 3) {
        if (isCtrlKeyPressed && isShiftKeyPressed && isZKeyPressed) {
          evt.preventDefault();
          onGlobalRedo();
        }
      }
    }

    function onUndoRedoKeyRelease(keyCode) {
      if (
        keyCode !== KeyboardKey.CTRL &&
        keyCode !== KeyboardKey.SHIFT &&
        keyCode !== KeyboardKey.Y &&
        keyCode !== KeyboardKey.Z
      ) {
        return;
      }

      keyCodePressdList.current = keyCodePressdList.current.filter((key) => key !== keyCode);
    }
    // #endregion global undo redo

    // #region picklist

    const [picklistHoveredLabware, setPicklistHoveredLabware] = useState(InitialPicklistHoverState);

    const onDeckInsertHoverPicklist = (itemID, status) => {
      setPicklistHoveredLabware({
        ...InitialPicklistHoverState,
        [itemID]: status,
      });
    };

    const onClickWellPicklist = async (itemID) => {
      // check if allowed
      const currentLabware = labwareState[itemID];
      if (!currentLabware) {
        return;
      }
      const {labwareLabel: selectedLabwareLabel} = currentLabware;
      const labwareType = PicklistPlateType[selectedLabwareLabel];
      const allowedLabwareType = picklistDefinition.labwareMap[picklistDefinition.currentStep]?.type;

      if (currentLabware.isSpearBio) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({id: 'protocolEditor.picklist.createNew.disallowSpearBioLabware'}),
        );
        return;
      }

      if (currentLabware.isIFC || !allowedLabwareType.includes(labwareType)) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({id: 'protocolEditor.picklist.labwareTypeNotAllowed'}),
        );
        return;
      }

      const picklistLabwareIDs = tasklistPicklistBusinessGetPicklistLabwareIDs();
      const usedLabware = picklistLabwareIDs.includes(currentLabware.LabwareID);

      const existDeckId = picklistDefinition.labwareMap[picklistDefinition.currentStep]?.deckId;
      const deckIsUsed = find(picklistDefinition.labwareMap, {deckId: itemID});
      if ((!existDeckId && deckIsUsed) || usedLabware) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({
            id: 'protocolEditor.picklist.alreadyUsedDeck',
          }),
        );
        setDraggedLabwareId(null);
        setDraggedLabwareType(null);
        return;
      }

      taskListPicklistBusinessSetPicklistDeckId(picklistDefinition.currentStep, itemID);

      const currentLabwareMap = picklistDefinition.labwareMap[picklistDefinition.currentStep];
      labwareBusinessRenameLabware(itemID, currentLabwareMap.name, false);

      if (picklistDefinition.platePreference === CSVImportPlateColumnPreference.PLATE_BARCODE) {
        labwareStateActionSetLabwareBarcode(itemID, currentLabwareMap.barcode);
      }

      const totalLabware = Object.values(picklistDefinition.labwareMap).filter(
        (l) => l.deckId === undefined || l.deckId === null,
      );

      if (totalLabware.length <= 1) {
        await setProtocolEditorMode(ProtocolEditorViewMode.SIMPLE_TRANSFER);
        await taskListPicklistBusinessFinalizePicklist(false, taskListBusinessAddCardGroup);
        setPicklistHoveredLabware(InitialPicklistHoverState);
        undoRedoBusinessActionGlobalAddUndoItem();
        return;
      }
      taskListPicklistBusinessIncrementCurrentStep();
      undoRedoBusinessActionGlobalAddUndoItem();
    };
    // #endregion picklist

    const onKeyRelease = useStaticCallback((evt) => {
      onUndoRedoKeyRelease(evt.keyCode);
      switch (protocolEditorMode) {
        case ProtocolEditorViewMode.SERIAL_DILUTION:
          if (evt.keyCode === KeyboardKey.SHIFT) {
            onShiftKeyReleaseSerialDilution();
          }
          break;
        case ProtocolEditorViewMode.BROADCAST:
          if (evt.keyCode === KeyboardKey.CTRL) {
            onCtrlKeyReleaseBroadcast();
          } else if (evt.keyCode === KeyboardKey.SHIFT) {
            onShiftKeyReleaseBroadcast();
          }
          break;
        case ProtocolEditorViewMode.POOLING:
          if (evt.keyCode === KeyboardKey.CTRL) {
            onCtrlKeyReleasePooling();
          } else if (evt.keyCode === KeyboardKey.SHIFT) {
            onShiftKeyReleasePooling();
          }
          break;
        default:
          break;
      }
    });

    const onKeyPress = useStaticCallback((evt) => {
      onUndoRedoKeyPress(evt);

      switch (protocolEditorMode) {
        case ProtocolEditorViewMode.SERIAL_DILUTION:
          if (evt.keyCode === KeyboardKey.SHIFT) {
            onShiftKeyPressSerialDilution();
          }
          break;
        case ProtocolEditorViewMode.BROADCAST:
          if (evt.keyCode === KeyboardKey.SHIFT) {
            onShiftKeyPressBroadcast();
          }
          break;
        case ProtocolEditorViewMode.POOLING:
          if (evt.keyCode === KeyboardKey.SHIFT) {
            onShiftKeyPressPooling();
          }
          break;
        default:
          break;
      }
    });

    useEffect(() => {
      document.addEventListener('keyup', onKeyRelease);
      return () => {
        document.removeEventListener('keyup', onKeyRelease);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [protocolVolumeModalOpen]);

    useEffect(() => {
      document.addEventListener('keydown', onKeyPress);
      return () => {
        document.removeEventListener('keydown', onKeyPress);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [protocolVolumeModalOpen, protocolEditorState.ADModalShown, simpleTransferVolume.current]);

    const onHoverWell = useStaticCallback((itemID, row, column, labwareIndex, isCtrl, isShift) => {
      switch (protocolEditorMode) {
        case ProtocolEditorViewMode.SIMPLE_TRANSFER:
          onHoverWellSimpleTransfer(itemID, row, column, labwareIndex);
          break;
        case ProtocolEditorViewMode.SERIAL_DILUTION:
          onHoverWellSerialDilution(itemID, row, column, labwareIndex, isCtrl, isShift);
          break;
        case ProtocolEditorViewMode.NORMALIZATION:
          onHoverWellNormalization(itemID, row, column, labwareIndex);
          break;
        case ProtocolEditorViewMode.BROADCAST:
          onHoverWellBroadcast(itemID, row, column, labwareIndex, isCtrl, isShift);
          break;
        case ProtocolEditorViewMode.POOLING:
          onHoverWellPooling(itemID, row, column, labwareIndex, isCtrl, isShift);
          break;
        case ProtocolEditorViewMode.MIXING:
          onHoverWellMixing(itemID, row, column, labwareIndex);
          break;
        default:
          break;
      }
    });

    function onSwipeStart(itemID, row, column, labwareIndex, isCtrl, isShift) {
      switch (protocolEditorMode) {
        case ProtocolEditorViewMode.SERIAL_DILUTION:
          onSwipeStartSerialDilution(itemID, row, column, isCtrl, isShift);
          break;
        case ProtocolEditorViewMode.BROADCAST:
          onSwipeStartBroadcast(itemID, row, column, isCtrl, isShift);
          break;
        case ProtocolEditorViewMode.POOLING:
          onSwipeStartPooling(itemID, row, column, isCtrl, isShift);
          break;
        case ProtocolEditorViewMode.MIXING:
          onSwipeStartMixing(itemID, row, column);
          break;
        default:
          break;
      }
    }

    const onSwipeMove = useStaticCallback(
      (itemID, row, column, labwareIndex, swipingDirectionY, swipingDirectionX, isCtrl, isShift) => {
        switch (protocolEditorMode) {
          case ProtocolEditorViewMode.SERIAL_DILUTION:
            onSwipeMoveSerialDilution(itemID, row, column, swipingDirectionY, swipingDirectionX, isCtrl, isShift);
            break;
          case ProtocolEditorViewMode.BROADCAST:
            onSwipeMoveBroadcast(itemID, row, column, swipingDirectionY, swipingDirectionX, isCtrl, isShift);
            break;
          case ProtocolEditorViewMode.POOLING:
            onSwipeMovePooling(itemID, row, column, swipingDirectionY, swipingDirectionX, isCtrl, isShift);
            break;
          case ProtocolEditorViewMode.MIXING:
            onSwipeMoveMixing(itemID, row, column, swipingDirectionY, swipingDirectionX);
            break;
          default:
            break;
        }
      },
    );

    const onSwipeEnd = useStaticCallback(
      (itemID, row, column, startRow, startColumn, labwareIndex, isCtrl, isShift) => {
        switch (protocolEditorMode) {
          case ProtocolEditorViewMode.SERIAL_DILUTION:
            onSwipeEndSerialDilution(itemID, row, column, labwareIndex, isCtrl, isShift);

            enableHighlightTaskRef.current = true;
            swipingInfoRef.current = null;

            onHoverWellSerialDilution(itemID, row, column, labwareIndex);

            break;
          case ProtocolEditorViewMode.BROADCAST:
            onSwipeEndBroadcast(itemID, isCtrl, isShift);

            enableHighlightTaskRef.current = true;
            swipingInfoRef.current = null;

            onHoverWellBroadcast(itemID, row, column, labwareIndex);

            break;
          case ProtocolEditorViewMode.POOLING:
            onSwipeEndPooling(itemID, isCtrl, isShift);
            break;
          case ProtocolEditorViewMode.MIXING:
            onSwipeEndMixing(itemID, row, column);

            enableHighlightTaskRef.current = true;
            swipingInfoRef.current = null;

            break;
          default:
            break;
        }
      },
    );

    const onClickWell = useStaticCallback((itemID, row, column, labwareIndex) => {
      switch (protocolEditorMode) {
        case ProtocolEditorViewMode.SIMPLE_TRANSFER:
          onClickWellSimpleTransfer(itemID, row, column, labwareIndex);
          break;
        case ProtocolEditorViewMode.NORMALIZATION:
          onClickWellNormalization(itemID, row, column);
          break;
        case ProtocolEditorViewMode.PICKLIST:
          onClickWellPicklist(itemID, row, column);
          break;
        default:
          break;
      }
    });

    async function onLabwareClick(itemID) {
      switch (protocolEditorMode) {
        case ProtocolEditorViewMode.NORMALIZATION: {
          const {toastMessage, toastParams} = dispatch(isLabwareAllowedForNormalization(itemID));
          if (toastMessage) {
            appStateActionShowSnackbar(Feedback.ERROR, intl.formatMessage({id: toastMessage}, toastParams));
            return;
          }
          if (normalizationStateNormalizationStep === NormalizationStep.SET_SAMPLE_LABWARE) {
            const labware = labwareState[itemID];

            if (protocolNormalizationTaskEditStep === NormalizationStep.SET_SAMPLE_LABWARE) {
              dispatch(editNormalizationSamplePlate(labware));
            } else if (normalizationStateNormalizationStep === NormalizationStep.SET_SAMPLE_LABWARE) {
              await taskListNormalizationSelectNormalizationSamplePlate(labware);
              await normalizationStateActionSetNormalizationCurrentVolume(0);
              undoRedoBusinessActionGlobalAddUndoItem();
            }
          }
          break;
        }
        default:
          break;
      }
    }

    function onEditCardTask(taskId, cardId, cardType) {
      switch (cardType) {
        // case CardType.SIMPLE_TRANSFER:
        //   previousSelectedTask.current = taskId;
        //   unselectCard.current = false;
        //   onEditSimpleTransfer(cardId, taskId, null, true, false, isNewAirGapTask);
        //   break;
        case CardType.SERIAL_DILUTION:
          break;
        case CardType.NORMALIZATION:
          onEditNormalization(taskId);
          break;
        case CardType.BROADCAST:
          onEditBroadcastTask(taskId);
          break;
        case CardType.POOLING:
          onEditPoolingTask(taskId);
          break;
        default:
          break;
      }
    }

    function onDeleteCard(cardType) {
      switch (cardType) {
        case CardType.BROADCAST:
          onDeleteBroadcastCard();
          break;
        case CardType.POOLING:
          onDeletePoolingCard();
          break;
        default:
          break;
      }
    }

    function onDeleteTask(taskId, cardId, cardType) {
      switch (cardType) {
        case CardType.BROADCAST:
          onDeleteBroadcastCard();
          break;
        default:
          break;
      }
    }

    function notifyVolumeChange(volume) {
      switch (protocolEditorMode) {
        case ProtocolEditorViewMode.BROADCAST:
          broadcastVolumeModalChange(volume);
          break;
        case ProtocolEditorViewMode.POOLING:
          poolingVolumeModalChange(volume);
          break;
        case ProtocolEditorViewMode.NORMALIZATION:
          normalizationVolumeModalChange(volume);
          break;
        default:
          break;
      }
    }

    function notifyModalClose() {
      switch (protocolEditorMode) {
        case ProtocolEditorViewMode.NORMALIZATION:
          closeNormalizationVolumeModal();
          break;
        default:
          break;
      }
    }

    const onDeckInsertHover = useStaticCallback((itemID, status) => {
      switch (protocolEditorMode) {
        case ProtocolEditorViewMode.PICKLIST:
          onDeckInsertHoverPicklist(itemID, status);
          break;
        case ProtocolEditorViewMode.NORMALIZATION:
          setHoveredNormalization(status ? labwareState[itemID].LabwareID : null);
          break;
        default:
          break;
      }
    });

    const getDeckInsertHoverStatus = (itemID) => {
      switch (protocolEditorMode) {
        case ProtocolEditorViewMode.PICKLIST:
          return picklistHoveredLabware[itemID];
        case ProtocolEditorViewMode.NORMALIZATION:
          return hoveredNormalization === labwareState[itemID].LabwareID;
        default:
          break;
      }
      return null;
    };

    const getIsSelectedDeckLabware = (deckId) => {
      if (protocolEditorMode === ProtocolEditorViewMode.PICKLIST) {
        return find(picklistDefinition.labwareMap, {deckId});
      }
      return false;
    };

    useImperativeHandle(ref, () => ({
      editTask(taskId, cardId, cardType, isNewAirGapTask) {
        onEditCardTask(taskId, cardId, cardType, isNewAirGapTask);
      },
      deleteCard(cardType) {
        onDeleteCard(cardType);
      },
      deleteTask(taskId, cardId, cardType) {
        onDeleteTask(taskId, cardId, cardType);
      },
      normalizationHeaderBack() {
        onNormalizationHeaderBack();
      },
      normalizationHeaderNext() {
        onNormalizationHeaderNext();
      },
      normalizationHeaderCancel() {
        onNormalizationHeaderCancel();
      },
      normalizationHeaderCancelEdit() {
        onNormalizationHeaderCancelEdit();
      },
      broadcastHeaderBack() {
        onBroadcastHeaderBack();
      },
      broadcastHeaderCancel() {
        onBroadcastHeaderCancel();
      },
      broadcastHeaderApply() {
        resetAllBroadcastTasksRef();
        initialValueVolumeModal.current = 0;
      },
      broadcastHeaderCancelEdit() {
        onBroadcastHeaderCancelEdit();
      },
      poolingHeaderBack() {
        onPoolingHeaderBack();
      },
      poolingHeaderCancel() {
        onPoolingHeaderCancel();
      },
      poolingHeaderCancelEdit() {
        onPoolingHeaderCancelEdit();
      },
      broadcastShowVolumeModal(deckNumber) {
        showBroadcastVolumeModal(deckNumber);
      },
      broadcastHideVolumeModal() {
        protocolEditorStateActionSetVolumeModalOpen(false);
        volumeModalRef.current.hide();
      },
      poolingShowVolumeModal(deckNumber) {
        showPoolingVolumeModal(deckNumber);
      },
      poolingHideVolumeModal() {
        protocolEditorStateActionSetVolumeModalOpen(false);
        volumeModalRef.current.hide();
      },
      setHoveredLabwareId(labwareID) {
        setHoveredLabwareId(labwareID);
      },
      simpleTransferHideVolumeModal() {
        simpleTransferHideVolumeModal();
      },
      onApplyPooling() {},
      poolingSetAllowedTips() {
        setPoolingAllowedTips();
      },
      onNextPooling() {
        resetAllPoolingTasksRef();
        taskListPoolingBusinessClearPoolingStateBeforeEdit();
      },
      resetBroadcastPoolingCurrentLabware() {
        broadcastCurrentLabwareRef.current = null;
        poolingCurrentLabwareRef.current = null;
      },
      onGlobalUndo() {
        onGlobalUndo();
      },
      onGlobalRedo() {
        onGlobalRedo();
      },
      getDeckLabwareRefs() {
        return deckLabwareRefs;
      },
      applyAspirateDispenseModal() {
        ADModalRef.current.apply();
      },
    }));

    const virtualTrayContexValue = useRef({
      setDraggedLayout: (newVal) => setDraggedLayout(newVal),
      setDraggedHandle: (newVal) => setDraggedHandle(newVal),
    });

    const deckTaskListRef = useRef({
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: [],
    });

    useEffect(() => {
      const currentDeckTasks = filterToArray(cardStateTasks, {
        labwareID: labwareState[1].LabwareID ?? 1,
        ID: selectedCard?.tasks,
      });
      deckTaskListRef.current[1] = currentDeckTasks;
      /* eslint-disable-next-line */
    }, [cardStateTasks, labwareState[1], selectedCard]);

    useEffect(() => {
      const currentDeckTasks = filterToArray(cardStateTasks, {
        labwareID: 2,
        ID: selectedCard?.tasks,
      });
      deckTaskListRef.current[2] = currentDeckTasks;
      /* eslint-disable-next-line */
    }, [cardStateTasks, selectedCard]);

    useEffect(() => {
      const currentDeckTasks = filterToArray(cardStateTasks, {
        labwareID: labwareState[3].LabwareID,
        ID: selectedCard?.tasks,
      });
      deckTaskListRef.current[3] = currentDeckTasks;
      /* eslint-disable-next-line */
    }, [cardStateTasks, labwareState[3], selectedCard]);

    useEffect(() => {
      const currentDeckTasks = filterToArray(cardStateTasks, {
        labwareID: labwareState[4].LabwareID,
        ID: selectedCard?.tasks,
      });
      deckTaskListRef.current[4] = currentDeckTasks;
      /* eslint-disable-next-line */
    }, [cardStateTasks, labwareState[4], selectedCard]);

    useEffect(() => {
      const currentDeckTasks = filterToArray(cardStateTasks, {
        labwareID: labwareState[5].LabwareID,
        ID: selectedCard?.tasks,
      });
      deckTaskListRef.current[5] = currentDeckTasks;
      /* eslint-disable-next-line */
    }, [cardStateTasks, labwareState[5], selectedCard]);

    useEffect(() => {
      const currentDeckTasks = filterToArray(cardStateTasks, {
        labwareID: labwareState[6].LabwareID,
        ID: selectedCard?.tasks,
      });
      deckTaskListRef.current[6] = currentDeckTasks;
      /* eslint-disable-next-line */
    }, [cardStateTasks, labwareState[6], selectedCard]);

    function renderTipCaddy(deckNumber, trayType) {
      return (
        <DeckInsertMemo
          key={`${deckNumber}-${trayType}`}
          number={deckNumber}
          tasks={deckTaskListRef.current[deckNumber]}
          className="deck-insert-tip-caddy"
          ref={deckLabwareRefs[deckNumber]}
          selectionMode={selectLabwareMode}
        >
          <TipCaddy
            showCaddyOnly={isTessaraProtocolAndRegularTessaraUser || runtimeType === RuntimeType.CONSOLIDATE_TIPS}
            itemID={deckNumber}
            onClick={onTipCaddyClick}
            header={intl.formatMessage({
              id:
                isEjectToCaddy && deckNumber === TipCaddyLocationType.TIP_WASTE_CADDY && !isConsolidateTipsCardExist
                  ? 'protocolEditor.virtualTray.ejectTip.instruction'
                  : 'protocolEditor.virtualTray.pickTip.instruction',
            })}
            runtimeMode={runtimeMode}
            tasks={deckTaskListRef.current[deckNumber]}
            protocolEditorMode={protocolEditorMode}
            isHighVolume={trayType === TrayType.HIGH_VOLUME_CADDY}
            showCaddySwitch={
              !isConsolidateTipsCardExist &&
              deckNumber === TipCaddyLocationType.TIP_WASTE_CADDY &&
              trayType === TrayType.DOUBLE_CADDY
            }
            disableSwitch={runtimeMode || isOperator || isRunOnly || isOnlyUtilityCardExists}
          />
        </DeckInsertMemo>
      );
    }

    const isLabwareUsed = (deckId) => {
      if (!deckId) {
        return null;
      }

      const labware = labwareState[deckId];

      let rawTasks = {};

      if (
        draggedLabwareType !== DragDropType.DECK_LABWARE &&
        protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION
      ) {
        rawTasks = selectedCard.sdRawTasks;
      }

      return find({...cardStateTasksRef.current, ...rawTasks}, {labwareID: labware.LabwareID});
    };

    const isDeepWellAllowed = (deckId) => {
      if (!draggedLabwareId) {
        return true;
      }

      const protocolTrayType = lastOpenedProtocol?.trayType || '';

      const {wellDepth} = find(availableLabwareState, {LabwareID: draggedLabwareId});

      const {wellDepth: wellDepthLabwareDeck5} = labwareState[5];

      if (
        protocolTrayType === TrayType.HIGH_VOLUME_CADDY &&
        ((deckId !== 5 && wellDepth > deepWellThreshold) ||
          (draggedLabwareType === DragDropType.DECK_LABWARE &&
            deckId === 5 &&
            wellDepth < deepWellThreshold &&
            wellDepthLabwareDeck5 > deepWellThreshold))
      ) {
        return false;
      }

      return true;
    };

    // TODO: fix and tidy up sequence and conditions for validation
    const allowedToSwitchLabware = (deckId) => {
      if (isConsolidateTipsCardExist) {
        return false;
      }

      if (!draggedLabwareId) {
        return true;
      }

      const {
        colCount: sourceColCount,
        rowCount: sourcetRowCount,
        isSpearBio: sourceIsSpearBio,
      } = find(availableLabwareState, {LabwareID: draggedLabwareId});
      const {
        colCount: destColCount,
        rowCount: destRowCount,
        LabwareID,
        isSpearBio: destIsSpearBio,
      } = labwareState[deckId];

      const destinationLabwareTask = find(cardStateTasks, {labwareID: LabwareID});

      if (!LabwareID) return true;

      if (destinationLabwareTask && sourceIsSpearBio !== destIsSpearBio) {
        return false;
      }

      if (protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION) {
        const {sampleLabwareID, diluentLabwareID} = normalizationState;
        const labware = labwareState[deckId];

        if (draggedLabwareType === DragDropType.DECK_LABWARE && isDraggingDeckLabware) {
          return true;
        }

        if (labware.LabwareID && (labware.LabwareID === sampleLabwareID || labware.LabwareID === diluentLabwareID)) {
          return (
            sourceColCount === labware.colCount &&
            sourcetRowCount === labware.rowCount &&
            sourceIsSpearBio === destIsSpearBio
          );
        }
        return true;
      }

      if (protocolEditorMode === ProtocolEditorViewMode.PICKLIST) {
        const existDeckId = picklistDefinition.labwareMap[picklistDefinition.currentStep]?.deckId;

        if (!existDeckId) {
          const deckIsUsed = find(picklistDefinition.labwareMap, {deckId});

          if (deckIsUsed) {
            return false;
          }
        }

        if (existDeckId && existDeckId !== deckId) {
          return false;
        }
      }

      if (!isLabwareUsed(deckId) || (draggedLabwareType === DragDropType.DECK_LABWARE && isDraggingDeckLabware)) {
        return true;
      }

      // check if picklist exist
      const forbiddenCard = filterToArray(
        cardState,
        (x) =>
          x.type === CardType.NORMALIZATION ||
          x.type === CardType.SERIAL_DILUTION ||
          x.subType === ProtocolEditorViewMode.PICKLIST,
      );
      let existForbiddenTask;

      if (forbiddenCard.length && LabwareID) {
        let forbiddenTasks = [];
        let rawTasks = {};
        forbiddenCard.forEach((c) => {
          if (c.type === CardType.SERIAL_DILUTION) {
            rawTasks = c.sdRawTasks;
          }
          forbiddenTasks = [...forbiddenTasks, ...c.tasks];
        });
        existForbiddenTask = find(cardStateTasks, {ID: forbiddenTasks, labwareID: LabwareID});

        if (!existForbiddenTask) {
          existForbiddenTask = find(rawTasks, {labwareID: LabwareID});
        }
      }

      if (existForbiddenTask && !(sourceColCount === destColCount && sourcetRowCount === destRowCount)) return false;

      // if exist task, only allow switch different type between 96 & 384
      let allowSwitch = false;
      if (
        (destColCount * destRowCount === LabwareWellCount.LABWARE_96 &&
          sourceColCount * sourcetRowCount === LabwareWellCount.LABWARE_384) ||
        (destColCount * destRowCount === LabwareWellCount.LABWARE_384 &&
          sourceColCount * sourcetRowCount === LabwareWellCount.LABWARE_96)
      ) {
        allowSwitch = true;
      }

      return (
        !labwareState[deckId].LabwareID ||
        draggedLabwareType === DragDropType.DECK_LABWARE ||
        (sourceColCount === destColCount && sourcetRowCount === destRowCount) ||
        allowSwitch
      );
    };

    // eslint-disable-next-line no-unsafe-optional-chaining
    const getWellSize = (labware) => labware?.colCount * labware?.rowCount;

    // TODO: Moves action handler into its own file (or class?)
    const onLabwareSwapped = () => {
      switch (selectedCard.type) {
        case CardType.POOLING:
          setPoolingAllowedTips();
          break;
        default:
          break;
      }
    };

    const onLabwareDropped = useStaticCallback(async (item, itemID) => {
      let showSucceedSnackbar = true;
      const targetLabware = labwareState[itemID];
      const oldCard = {
        tasks: jsonCopy(cardStateTasks),
        cards: jsonCopy(cardState),
        groups: jsonCopy(cardStateGroups),
      };
      const oldLabware = jsonCopy(labwareState);
      const oldTemporaryState = jsonCopy(temporaryState);

      if (!isDeepWellAllowed(itemID)) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({
            id: 'protocolEditor.switchLabware.deepWell',
          }),
        );

        setDraggedLabwareId(null);
        setDraggedLabwareType(null);
        return;
      }

      if (item.type === DragDropType.LIST_LABWARE) {
        const {IDPrefix: sourceIDPrefix} = find(availableLabwareState, {LabwareID: draggedLabwareId});
        const {IDPrefix: destIDPrefix} = targetLabware;

        if (targetLabware.LabwareID) {
          if (!allowedToSwitchLabware(itemID)) {
            appStateActionShowSnackbar(
              Feedback.ERROR,
              intl.formatMessage({
                id: 'protocolEditor.switchLabware.error',
              }),
            );

            setDraggedLabwareId(null);
            setDraggedLabwareType(null);
            return;
          }

          if (sourceIDPrefix === destIDPrefix && protocolEditorMode !== ProtocolEditorViewMode.NORMALIZATION) {
            setDraggedLabwareId(null);
            setDraggedLabwareType(null);
            return;
          }
        }
      }

      if (isConsolidateTipsCardExist) {
        appStateActionShowSnackbar(
          Feedback.ERROR,
          intl.formatMessage({id: 'protocolEditor.switchLabware.errorConsolidateTip'}),
        );
        setDraggedLabwareId(null);
        setDraggedLabwareType(null);
        return;
      }

      if (item.type === DragDropType.DECK_LABWARE && itemID === item.ID) {
        setDraggedLabwareId(null);
        setDraggedLabwareType(null);
        return;
      }

      let defaultLabwareName;
      const existTask = labwareState[itemID]?.LabwareID
        ? find(cardStateTasks, {labwareID: targetLabware.LabwareID})
        : null;

      switch (item.type) {
        case DragDropType.DECK_LABWARE:
          // set temporary state of picklist
          if (protocolEditorMode === ProtocolEditorViewMode.PICKLIST) {
            taskListPicklistSwapPicklistDeckId(itemID, item.ID, true);
          }
          showSucceedSnackbar = await labwareBusinessSetDeckLabware(itemID, labwareState[item.ID], item.ID);
          break;
        case DragDropType.LIST_LABWARE:
          if (protocolEditorMode === ProtocolEditorViewMode.PICKLIST && existTask) {
            appStateActionShowSnackbar(
              Feedback.ERROR,
              intl.formatMessage({
                id: 'protocolEditor.picklist.swapLabwareNotAllowed',
              }),
            );
            return;
          }

          if (
            getWellSize(targetLabware) === WellCount.WELL_96 &&
            getWellSize(availableLabwareState[item.ID]) === WellCount.WELL_384 &&
            existTask
          ) {
            // check if the task contains normalization or serial dilution
            const forbiddenCard = filterToArray(
              cardState,
              (x) =>
                x.type === CardType.NORMALIZATION ||
                x.type === CardType.SERIAL_DILUTION ||
                x.subType === ProtocolEditorViewMode.PICKLIST,
            );
            let existForbiddenTask;

            if (forbiddenCard.length) {
              let forbiddenTasks = [];
              forbiddenCard.forEach((c) => {
                forbiddenTasks = [...forbiddenTasks, ...c.tasks];
              });
              existForbiddenTask = find(cardStateTasks, {ID: forbiddenTasks, labwareID: targetLabware.LabwareID});
            }

            if (existForbiddenTask) {
              appStateActionShowSnackbar(
                Feedback.ERROR,
                intl.formatMessage({
                  id: 'protocolEditor.picklist.failedToSwapLabware',
                }),
              );
              return;
            }

            // show modal
            const result = await chooseQuadrantModalRef.current.show({1: true, 2: false, 3: false, 4: false});
            if (!result) {
              return;
            }

            showSucceedSnackbar = await labwareBusinessSetDeckLabware(
              itemID,
              availableLabwareState[item.ID],
              0,
              defaultLabwareName,
            );
            // move or duplicate task
            labwareBusinessMoveAndDuplicateTaskIntoQuadrant(itemID, result ?? {1: true});
          } else if (
            getWellSize(targetLabware) === WellCount.WELL_384 &&
            getWellSize(availableLabwareState[item.ID]) === WellCount.WELL_96 &&
            existTask
          ) {
            // check if the task contains normalization or serial dilution
            const forbiddenCard = filterToArray(
              cardState,
              (x) =>
                x.type === CardType.NORMALIZATION ||
                x.type === CardType.SERIAL_DILUTION ||
                x.subType === ProtocolEditorViewMode.PICKLIST,
            );
            let existForbiddenTask;

            if (forbiddenCard.length) {
              let forbiddenTasks = [];
              forbiddenCard.forEach((c) => {
                forbiddenTasks = [...forbiddenTasks, ...c.tasks];
              });
              existForbiddenTask = find(cardStateTasks, {ID: forbiddenTasks, labwareID: targetLabware.LabwareID});
            }

            if (existForbiddenTask) {
              appStateActionShowSnackbar(
                Feedback.ERROR,
                intl.formatMessage({
                  id: 'protocolEditor.picklist.failedToSwapLabware',
                }),
              );
              return;
            }

            const existTaskInLabware = filterToArray(cardStateTasks, {labwareID: targetLabware.LabwareID});
            const [, quadrantList] = isTasksSameQuadrant(existTaskInLabware, true, true);

            let choosenQuadrant = quadrantList[0];
            if (quadrantList.length > 1) {
              const result = await chooseQuadrantModalRef.current.show(
                {1: false, 2: false, 3: false, 4: false},
                false,
                quadrantList,
                <FormattedHTMLMessage id="modal.plateSwab.confirmation.message" />,
              );
              choosenQuadrant = findKeyByValue(result, (s) => s);
            }
            if (choosenQuadrant) choosenQuadrant = parseInt(choosenQuadrant, 10);

            showSucceedSnackbar = await labwareBusinessSetDeckLabware(
              itemID,
              availableLabwareState[item.ID],
              0,
              defaultLabwareName,
            );
            // move or merge task
            labwareBusinessMoveAndMergeTaskIntoNonQuadrantBase(itemID, choosenQuadrant);
          } else {
            showSucceedSnackbar = await labwareBusinessSetDeckLabware(
              itemID,
              availableLabwareState[item.ID],
              0,
              defaultLabwareName,
            );
            if (protocolEditorMode === ProtocolEditorViewMode.PICKLIST) {
              taskListPicklistOnDroppedLabware(itemID);
            }
          }

          onLabwareSwapped();
          break;
        default:
          setDraggedLabwareId(null);
          setDraggedLabwareType(null);
          return;
      }

      undoRedoBusinessActionGlobalAddUndoItem(
        oldCard,
        {},
        {labwareState: oldLabware, temporaryState: oldTemporaryState},
      );

      if (item.type === DragDropType.LIST_LABWARE && !targetLabware.LabwareID) {
        setDraggedLabwareId(null);
        setDraggedLabwareType(null);
        return;
      }

      if (showSucceedSnackbar) {
        appStateActionShowSnackbar(
          Feedback.SUCCESS,
          intl.formatMessage({
            id: 'protocolEditor.switchLabware.success',
          }),
        );
      }

      setDraggedLabwareId(null);
      setDraggedLabwareType(null);
    });

    function renderDeckItem(deckNumber) {
      const currentSelectedCard = selectedCardRef.current;
      const currentDeckTasks = deckTaskListRef.current[deckNumber];
      const protocolTrayType = runtimeMode ? runtimeStateTrayType : lastOpenedProtocol?.trayType || '';

      const sdTaskId = taskListSerialDilutionBusinessGetSdRawTaskIds(selectedCard.ID);

      const sdRawTasksWithStep = jsonCopy(selectedCard?.sdRawTasks ?? {});
      let sdStep = 0;

      sdTaskId.forEach((stepIds) => {
        if (stepIds) {
          const taskIds = Array.isArray(stepIds) ? stepIds : [stepIds];

          taskIds.forEach((id, idx) => {
            const task = sdRawTasksWithStep[id];

            if (task && !task?.skipped) {
              if (sdStep < 4 && idx === 0) {
                sdStep += 1;
              }
              sdRawTasksWithStep[id].sdStep = sdStep;
            }
          });
        }
      });

      const generateSdRawTasksWithVolume = () => {
        const filterdSdRawTasks = Object.values(sdRawTasksWithStep).filter(
          (task) => task.labwareID === labwareState[deckNumber].LabwareID,
        );

        if (!currentSelectedCard) {
          return [];
        }

        const {sdProperty} = currentSelectedCard;

        if (!sdProperty) {
          return [];
        }

        const {sampleVolume, aliquotVolume, stepProperties, diluentVolume} = jsonCopy(sdProperty);
        // eslint-disable-next-line no-unsafe-optional-chaining
        const totalDiluent = stepProperties?.reduce((acc, val) => acc + val?.stepDiluentVolume || 0, 0);

        for (let i = 0, ii = filterdSdRawTasks.length; i < ii; i += 1) {
          switch (filterdSdRawTasks[i].number) {
            case SerialDilutionStep.SET_DILUENT_SOURCE:
              filterdSdRawTasks[i].volume = totalDiluent ?? diluentVolume;
              break;
            case SerialDilutionStep.SET_SAMPLE_SOURCE:
              filterdSdRawTasks[i].volume = sampleVolume;
              break;
            case SerialDilutionStep.SET_SAMPLE_TARGET:
              filterdSdRawTasks[i].volume = aliquotVolume ?? sampleVolume;
              break;
            case SerialDilutionStep.SET_DILUENT_TARGET:
              filterdSdRawTasks[i].volume = totalDiluent ?? diluentVolume;
              break;
            default:
              break;
          }
        }

        return filterdSdRawTasks;
      };

      const generateNormalizationTasks = () => {
        const selectedLabwareId = labwareState[deckNumber].LabwareID;
        const targetLabwareId = selectedCard?.normalizationState?.sampleLabwareID;
        let diluentLabwareId = selectedCard?.normalizationState?.diluentLabwareID;

        if (selectedCard?.normalizationState?.selectedDiluentLabwareID) {
          diluentLabwareId = selectedCard.normalizationState.selectedDiluentLabwareID;
        }

        if (selectedLabwareId === diluentLabwareId) {
          if (selectedCard.normalizationState.type === NormalizationType.FIXED_DILUENT_VOLUME) {
            return [
              {
                number: 2,
                ID: 2,
                type: 'Dispense',
                labwareID: diluentLabwareId,
              },
              {
                number: 3,
                ID: 3,
                type: 'Dispense',
                labwareID: diluentLabwareId,
              },
            ];
          }
          return [
            {
              number: 2,
              ID: 2,
              type: 'Aspirate',
              labwareID: diluentLabwareId,
            },
          ];
        }

        if (selectedLabwareId === targetLabwareId) {
          if (selectedCard.normalizationState.type === NormalizationType.FIXED_SAMPLE_VOLUME) {
            return [
              {
                number: 1,
                ID: 1,
                type: 'Dispense',
                labwareID: targetLabwareId,
              },
              {
                number: 3,
                ID: 3,
                type: 'Dispense',
                labwareID: targetLabwareId,
              },
            ];
          }
          return [
            {
              number: 1,
              ID: 1,
              type: 'Aspirate',
              labwareID: targetLabwareId,
            },
          ];
        }

        return [];
      };

      const afterLabwareRemoved = (deckId) => {
        if (protocolEditorMode === ProtocolEditorViewMode.PICKLIST) {
          taskListPicklistBusinessUnSetPicklistDeckId(picklistDefinition.currentStep);
        }
        if (protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION) {
          switch (normalizationState.currentWizardView) {
            case NormalizationStep.SET_SAMPLE_LABWARE:
              if (labwareState[deckId].LabwareID === normalizationState.sampleLabwareID) {
                taskListNormalizationSelectNormalizationSamplePlate({});
              }
              break;
            case NormalizationStep.SET_DILUENT_LABWARE:
              if (labwareState[deckId].LabwareID === normalizationState.diluentLabwareID) {
                taskListNormalizationSelectNormalizationDiluentPlate({});
              }
              break;
            default:
              break;
          }
        }
      };

      const removeLabware = (deckId) => {
        if (protocolEditorMode === ProtocolEditorViewMode.PICKLIST) {
          const currentObject = picklistDefinition.labwareMap[picklistDefinition.currentStep];

          if (currentObject?.deckId !== deckId) {
            const belongToOtherBarcode = find(picklistDefinition.labwareMap, {deckId});
            if (belongToOtherBarcode) {
              appStateActionShowSnackbar(
                Feedback.ERROR,
                intl.formatMessage({
                  id: 'protocolEditor.picklist.cantDeleteLabware',
                }),
              );
              return;
            }
          }

          tasklistPicklistBusinessUpdatePicklistOriginalLabware(deckId, {isSelected: false});
        }
        if (protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION) {
          switch (normalizationState.currentWizardView) {
            case NormalizationStep.SET_DILUENT_LABWARE:
              if (labwareState[deckId].LabwareID === normalizationState.sampleLabwareID) {
                appStateActionShowSnackbar(
                  Feedback.ERROR,
                  intl.formatMessage({
                    id: 'labwareBusinessAction.checkAndRemoveLabware.labwareBeingUsed',
                  }),
                );
                return;
              }
              break;
            default:
              break;
          }
        }
        labwareBusinessRemoveLabware(deckId, () => afterLabwareRemoved(deckId));
      };

      const isSelectedLabware = getIsSelectedDeckLabware(deckNumber);
      return (
        <DropAbleDeckInsert
          key={deckNumber}
          itemID={deckNumber}
          acceptedItems={[DragDropType.DECK_LABWARE, DragDropType.LIST_LABWARE]}
          onDrop={onLabwareDropped}
          isDisableDrop={() => false}
          number={deckNumber}
          allowedToSwitchLabware={isDeepWellAllowed(deckNumber) && allowedToSwitchLabware(deckNumber)}
          enableHoverInteraction={selectLabwareMode && labwareState[deckNumber].name}
          selectionMode={selectLabwareMode}
          isSelected={isSelectedLabware}
          onHoverDeck={onDeckInsertHover}
          deepWellOnly={protocolTrayType === TrayType.HIGH_VOLUME_CADDY && deckNumber === 5}
        >
          {labwareState[deckNumber].name && (
            <>
              <DragAbleDeckLabware
                key={`deck-${deckNumber}`}
                itemID={deckNumber}
                itemType={DragDropType.DECK_LABWARE}
                onDrag={(itemID, itemType) => {
                  const labwareId = Number(labwareState[deckNumber].IDPrefix);
                  if (labwareId !== draggedLabwareId) setDraggedLabwareId(labwareId);
                  if (itemType !== draggedLabwareType) setDraggedLabwareType(itemType);
                  setIsDraggingDeckLabware(true);
                }}
                onDragEnd={() => {
                  setIsDraggingDeckLabware(false);
                }}
                tasks={currentDeckTasks}
                sdRawTasks={generateSdRawTasksWithVolume()}
                cardType={selectedCard?.type}
                disableDrag={runtimeMode || isRunOnly}
                runtimeMode={runtimeMode}
                runtimeStateCsvRecordID={runtimeStateCsvRecordID}
                runtimeStateDoneRecordCSVIDs={runtimeStateDoneRecordCSVIDs}
                labware={labwareState[deckNumber]}
                onLabwareClick={onLabwareClick}
                onClickWell={onClickWell}
                selectedWellStyle={enableHighlightTaskRef.current ? selectedWellStyle[deckNumber] : {}}
                ref={deckLabwareRefs[deckNumber]}
                zoomable={
                  !runtimeMode &&
                  (!protocolVolumeModalOpen ||
                    (protocolVolumeModalOpen && protocolEditorMode === ProtocolEditorViewMode.BROADCAST)) &&
                  !isSerialDilutionSwiping() &&
                  !isSwipingBroadcast() &&
                  !isSwipingPooling() &&
                  !isSwipingMixing() &&
                  !selectLabwareMode &&
                  simpleTransferEditedType !== TaskType.PICK_TIP &&
                  zoomableLabwareNormalization(labwareState[deckNumber])
                }
                selectable={!runtimeMode && !isRunOnly}
                hoverable={
                  !!protocolSelectedTipChannel ||
                  protocolEditorMode === ProtocolEditorViewMode.SERIAL_DILUTION ||
                  protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION ||
                  protocolEditorMode === ProtocolEditorViewMode.BROADCAST ||
                  protocolEditorMode === ProtocolEditorViewMode.POOLING ||
                  protocolEditorMode === ProtocolEditorViewMode.MIXING
                }
                onHoverWell={onHoverWell}
                swipeEnable
                onSwipeStart={onSwipeStart}
                onSwipeEnd={onSwipeEnd}
                onSwipeMove={onSwipeMove}
                disallowZoomOut={
                  (isAspirateDispenseModalShown && !focusedDeckNumber) ||
                  (protocolVolumeModalOpen && protocolEditorMode !== ProtocolEditorViewMode.BROADCAST) ||
                  isSerialDilutionSwiping() ||
                  isSwipingBroadcast() ||
                  isSwipingPooling() ||
                  isSwipingMixing()
                }
                onZoomIn={(itemID) => {
                  if (isSerialDilutionSwiping() || isSwipingBroadcast() || isSwipingPooling() || isSwipingMixing()) {
                    return;
                  }
                  selectLabwareHandlerMemo(itemID);
                  // labwareActionSelectLabware(itemID);
                }}
                onZoomOut={(itemID) => {
                  if (isSerialDilutionSwiping() || isSwipingBroadcast() || isSwipingPooling() || isSwipingMixing()) {
                    return;
                  }
                  unselectLabwareHandlerMemo(itemID);
                  // labwareActionUnselectLabware(itemID);
                }}
                onRemoveLabware={removeLabware}
                renameLabware={labwareBusinessRenameLabware}
                taskWellColor={colorMap[labwareState[deckNumber].LabwareID]}
                onMouseLeave={(e) => {
                  if (!runtimeMode) {
                    setHoveredLabwareId(null);
                    setIsOverCapacityTooltipShow(false);
                  }
                  if (focusedSimpleTransferTaskInfo.current) {
                    onHoverWellSimpleTransfer(deckNumber, null, null);
                    return;
                  }

                  if (groupedWellStylesRef.current.length) {
                    swipingInfoRef.current = null;

                    const flattenedSelectedWells = mergeArrayOfWellStylesByNest(groupedWellStylesRef.current);
                    setSelectedWellStyle(flattenedSelectedWells);
                    return;
                  }

                  if (isSerialDilutionSwiping() || isSwipingBroadcast() || isSwipingPooling() || isSwipingMixing()) {
                    return;
                  }
                  previousHoveredLabware.current = null;
                  setSelectedWellStyle({[e]: {}});
                  swipingInfoRef.current = null;
                }}
                thumbnail={labwareState[deckNumber].thumbnail}
                normalizationTasks={generateNormalizationTasks()}
                isHoveredLabware={
                  hoveredLabwareId === deckNumber || (!hoveredLabwareId && focusedDeckNumber === deckNumber)
                }
                isOtherLabwareHovered={hoveredLabwareId !== deckNumber && hoveredLabwareId !== null}
                initHoveredWell={hoveredWellState[deckNumber]}
                maxCharacters={protocolConfig.deckLabwareNameMaxLength}
                labwareName={labwareState[deckNumber].name}
                barcode={labwareState[deckNumber].barcode}
                showLabwareName
                oneDimensionalSwipeOnly={
                  protocolEditorMode !== ProtocolEditorViewMode.MIXING &&
                  protocolEditorMode !== ProtocolEditorViewMode.POOLING &&
                  protocolEditorMode !== ProtocolEditorViewMode.BROADCAST &&
                  protocolEditorMode !== ProtocolEditorViewMode.SERIAL_DILUTION
                }
                isDeepWell={labwareState[deckNumber]?.wellDepth > deepWellThreshold}
                isSelected={selectedDeckLabware[deckNumber]}
                labwareSelectedForNormalization={isSelectedLabwareNormalization(labwareState[deckNumber]?.LabwareID)}
                layouts={filter(TSLayout, {labwareID: deckNumber})}
                showTS={showTS}
                onHoverTransformSelection={onHoverTransformSelection}
                onDragTransformSelection={onDragTransformSelection}
                onDropTransformSelection={onDropTransformSelection}
                protocolEditorMode={protocolEditorMode}
                showLabwareButton={getDeckInsertHoverStatus(deckNumber)}
                readOnly={isOperator}
              />
              <CustomDragLayer draggedLayout={draggedLayout} />
            </>
          )}
        </DropAbleDeckInsert>
      );
    }

    function renderVirtualDeck() {
      const rowIdxArr = [0, 1];
      const deckRowIdxArr = [0, 1, 2];

      let protocolTrayType = lastOpenedProtocol?.trayType;
      if (appStateViewMode === ViewMode.RUNTIME) {
        protocolTrayType = runtimeStateTrayType;
      }

      return (
        <div className="virtual-tray__virtual-deck__trays">
          {rowIdxArr.map((rowIdx) => (
            <RowLayout key={rowIdx} alignItems="center" justifyContent="space-around" height="45%">
              {deckRowIdxArr.map((deckRowIdx) => {
                const deckNumber = deckRowIdxArr.length * rowIdx + deckRowIdx + 1;
                const doubleCaddyNumber = 1;
                const tipCaddyNumber = 2;
                if (
                  deckNumber === tipCaddyNumber ||
                  (deckNumber === doubleCaddyNumber && protocolTrayType === TrayType.DOUBLE_CADDY)
                ) {
                  return (
                    <React.Fragment key={deckNumber}>{renderTipCaddy(deckNumber, protocolTrayType)}</React.Fragment>
                  );
                }
                return <React.Fragment key={deckNumber}>{renderDeckItem(deckNumber)}</React.Fragment>;
              })}
            </RowLayout>
          ))}
        </div>
      );
    }

    const getOptionalClassName = (suffix) => {
      if (isTessaraProtocol) {
        if (isTessaraSuperUser) return `tessara-super-user${suffix ? `-${suffix}` : ''}`;

        return `tessara${suffix ? `-${suffix}` : ''}`;
      }

      return '';
    };

    const renderConsolidateTipsArrowPoint = () => {
      const show = runtimeMode && runtimeType === RuntimeType.CONSOLIDATE_TIPS;

      if (!show) {
        return null;
      }

      return (
        <DynamicArrowLayer
          sourceRef={deckLabwareRefs[2]}
          destinationRef={deckLabwareRefs[1]}
          options={{isPositionOnCenter: true, strokeWidth: 3}}
        />
      );
    };

    return (
      <VirtualTrayContext.Provider value={virtualTrayContexValue.current}>
        <ColumnLayout
          ref={containerRef}
          className={`
            virtual-tray
            virtual-tray-${runtimeMode ? 'runtime' : 'editor'}
            ${getOptionalClassName(`container-${appStateViewMode === ViewMode.RUNTIME ? 'runtime' : 'editor'}`)}
          `}
          border="2px solid #FFFFFF"
          borderRadius="5px"
          backgroundColor="#EBEBEB"
        >
          {appStateViewMode === ViewMode.RUNTIME && (
            <RowLayout
              justifyContent="center"
              alignItems="center"
              backgroundColor="white"
              height="35px"
              boxShadow="0px 1px 8px 0px #00000040"
            >
              <FmlxIcon name="Warning" variant="secondary" customColor="red" size="xs" />
              &nbsp;
              <span style={{color: 'red', fontWeight: 'bold'}}>
                {runtimeType === RuntimeType.CONSOLIDATE_TIPS
                  ? intl.formatMessage({id: 'runtime.warningInfo.consolidateTipsModeText'})
                  : intl.formatMessage({id: 'runtime.warningInfo.text'})}
              </span>
            </RowLayout>
          )}
          {!runtimeMode && (
            <span className="virtual-tray__virtual-deck__info">
              {!isRunOnly && intl.formatMessage({id: 'protocolEditor.virtualTray.footer.info'})}
            </span>
          )}
          <RowLayout
            style={{paddingTop: runtimeMode ? '7vh' : '1rem'}}
            className={`virtual-tray__virtual-deck ${getOptionalClassName('deck')}`}
            justifyContent="center"
          >
            {renderVirtualDeck()}
            <div
              className="virtual-tray__virtual-deck__waste-bin-container"
              style={{
                display: isTessaraProtocolAndRegularTessaraUser || runtimeMode ? 'flex' : 'none',
              }}
            >
              {isTessaraProtocol && <TessaraLogo className="waste-bin-container__tessara-logo" />}
              {runtimeMode && !hideWasteBin && (
                <TipsWasteBin
                  task={find(cardStateTasks, {ID: selectedCard?.tasks, type: TaskType.EJECT_TIP})}
                  showTaskVolume={selectedCard?.type === CardType.NORMALIZATION ? false : volumeDetailViewChecked}
                  protocolEditorMode={protocolEditorMode}
                />
              )}
            </div>
          </RowLayout>
          {!runtimeMode && !selectLabwareMode && (
            <VirtualTrayFooter
              isTessaraSuperUser={isTessaraProtocolAndTessaraSuperUser}
              volumeDetailView={selectedCard?.type === CardType.NORMALIZATION ? false : volumeDetailViewChecked}
              onVolumeDetailViewChange={() => setVolumeDetailViewChecked((prevValue) => !prevValue)}
              arrowDetailView={arrowDetailViewChecked}
              onArrowDetailViewChange={() => setArrowDetailViewChecked((prevValue) => !prevValue)}
              intl={intl}
              showVolumeDetailView={selectedCard?.type !== CardType.NORMALIZATION}
              enableDirectionDetailView={
                selectedCard?.type !== CardType.BROADCAST &&
                selectedCard?.type !== CardType.POOLING &&
                selectedCard?.type !== CardType.NORMALIZATION
              }
              showDetailButton={protocolEditorMode !== ProtocolEditorViewMode.PICKLIST}
            />
          )}
          {isAspirateDispenseModalShown && (
            <SetAspirateDispenseModal
              ref={ADModalRef}
              maxTipCapacity={maxAspirateVolume}
              minTipCapacity={minAspirateVolume}
              recommendedTipCapacity={recommendedAspirateVolume}
              intl={intl}
              previousSelectedTask={previousSelectedTask}
              excludedComponentRef={[headerRef]}
              onApply={onApplySDAspirateDispenseModal}
              onChange={onChangeVolumeADModal}
              highVolume={lastOpenedProtocol?.trayType === TrayType.HIGH_VOLUME_CADDY}
            />
          )}
          <SetVolumeModal
            ref={volumeModalRef}
            top={volumeModalPos.top}
            left={volumeModalPos.left}
            intl={intl}
            modalType={volumeModalType}
            allowOutsideClick={!isModalShowing}
            allowPressEnter
            excludedComponentRef={[headerRef, svmExcludedComponentRef]}
            notifyVolumeChange={notifyVolumeChange}
            notifyModalClose={notifyModalClose}
            maxValue={
              protocolEditorMode === ProtocolEditorViewMode.NORMALIZATION
                ? normalizationState?.selectedLabware?.workingCapacity
                : 9999
            }
            maxTipCapacity={maxAspirateVolume}
            minTipCapacity={minAspirateVolume}
            recommendedTipCapacity={recommendedAspirateVolume}
          />
          <ChooseQuadrantOnPlateSwabModal ref={chooseQuadrantModalRef} />
        </ColumnLayout>
        {renderConsolidateTipsArrowPoint()}
      </VirtualTrayContext.Provider>
    );
  },
);

VirtualTray.propTypes = {
  intl: PropTypes.any.isRequired,
  labwareState: PropTypes.object.isRequired,
  availableLabwareState: PropTypes.object.isRequired,
  cardStateTasks: PropTypes.object.isRequired,
  cardState: PropTypes.object.isRequired,
  cardStateGroups: PropTypes.object.isRequired,
  appStateViewMode: PropTypes.string.isRequired,
  selectedCard: PropTypes.object,
  runtimeMode: PropTypes.bool.isRequired,
  runtimeStateCsvRecordID: PropTypes.number.isRequired,
  runtimeStateDoneRecordCSVIDs: PropTypes.array.isRequired,
  runtimeStateStatus: PropTypes.string.isRequired,
  runtimeStateTrayType: PropTypes.string.isRequired,
  configStateMaxAspirateVolume: PropTypes.number.isRequired,
  configStateMaxAspirateHighVolume: PropTypes.number.isRequired,
  normalizationState: PropTypes.object.isRequired,
  isTessaraProtocol: PropTypes.bool,
  appStateActionShowSnackbar: PropTypes.func.isRequired,
  labwareActionUnselectAllLabware: PropTypes.func.isRequired,
  labwareBusinessSetDeckLabware: PropTypes.func.isRequired,
  labwareBusinessRemoveLabware: PropTypes.func.isRequired,
  labwareBusinessRenameLabware: PropTypes.func.isRequired,
  labwareBusinessGetWellStyleColorMapFromTasks: PropTypes.func.isRequired,
  labwareBusinessGetWellStyleColor: PropTypes.func.isRequired,
  labwareBusinessGetAllWellStyleColorMapFromTasks: PropTypes.func.isRequired,
  labwareBusinessMoveAndDuplicateTaskIntoQuadrant: PropTypes.func.isRequired,
  labwareBusinessMoveAndMergeTaskIntoNonQuadrantBase: PropTypes.func.isRequired,
  labwareStateActionSetLabwareBarcode: PropTypes.func.isRequired,
  taskListBusinessAddTask: PropTypes.func.isRequired,
  taskListBusinessEditWellTargetTask: PropTypes.func.isRequired,
  taskListBusinessSmarterDefaultDispenseTipPosition: PropTypes.func.isRequired,
  taskListSerialDilutionBusinessSetSdRawTask: PropTypes.func.isRequired,
  taskListSerialDilutionBusinessRemoveSdDiluentTargetRawTask: PropTypes.func.isRequired,
  taskListSerialDilutionBusinessGetSdRawTaskIds: PropTypes.func.isRequired,
  taskListBroadcastBusinessAddBroadcastTask: PropTypes.func.isRequired,
  taskListBroadcastBusinessAddBroadcastDispenseTasks: PropTypes.func.isRequired,
  taskListBroadcastBusinessSetBroadcastVolume: PropTypes.func.isRequired,
  taskListBroadcastBusinessBackHandler: PropTypes.func.isRequired,
  taskListBroadcastBusinessSaveBroadcastStateBeforeEdit: PropTypes.func.isRequired,
  taskListBroadcastBusinessRestoreBroadcastStateAfterCancelEdit: PropTypes.func.isRequired,
  taskListBroadcastBusinessSetBroadcastAspirateVolume: PropTypes.func.isRequired,
  taskListBroadcastBusinessOptimizeBroadcastCard: PropTypes.func.isRequired,
  taskListBroadcastBusinessBatchEditBroadcastDispenseTasks: PropTypes.func.isRequired,
  cardActionSetTaskIsSelected: PropTypes.func.isRequired,
  cardActionRemoveAllCardTask: PropTypes.func.isRequired,
  modalStateActionShowModal: PropTypes.func.isRequired,
  modalStateActionHideModal: PropTypes.func.isRequired,
  taskListPoolingBusinessAddPoolingDispenseTasks: PropTypes.func.isRequired,
  taskListPoolingBusinessAddPoolingAspirateTasks: PropTypes.func.isRequired,
  taskListPoolingBusinessBackHandler: PropTypes.func.isRequired,
  taskListPoolingBusinessSavePoolingStateBeforeEdit: PropTypes.func.isRequired,
  taskListPoolingBusinessBatchEditPoolingDispenseTasks: PropTypes.func.isRequired,
  taskListPoolingBusinessBatchMovePoolingAspirateTasks: PropTypes.func.isRequired,
  taskListPoolingBusinessRestorePoolingStateAfterCancelEdit: PropTypes.func.isRequired,
  taskListPoolingSetPoolingHelperState: PropTypes.func.isRequired,
  taskListPoolingBusinessBatchEditPoolingAspirateTasks: PropTypes.func.isRequired,
  taskListPoolingBusinessClosePoolingVolumeModal: PropTypes.func.isRequired,
  taskListPoolingBusinessGetPoolingDestinationAllowedTip: PropTypes.func.isRequired,
  taskListBroadcastBusinessBatchEditBroadcastAspirateTasks: PropTypes.func.isRequired,
  taskListMixingBusinessAddMixingTask: PropTypes.func.isRequired,
  taskListMixingBusinessEditMixingTask: PropTypes.func.isRequired,
  taskListNormalizationSelectNormalizationSamplePlate: PropTypes.func.isRequired,
  taskListNormalizationSelectNormalizationDiluentPlate: PropTypes.func.isRequired,
  taskListNormalizationGeneratePreviewData: PropTypes.func.isRequired,
  taskListNormalizationGenerateNormalizationTask: PropTypes.func.isRequired,
  taskListNormalizationNormalizationBackHandler: PropTypes.func.isRequired,
  taskListNormalizationNormalizationEditStep: PropTypes.func.isRequired,
  taskListNormalizationRemoveAspirateDispenseTask: PropTypes.func.isRequired,
  taskListBroadcastBusinessRestoreNormalizationStateAfterCancelEdit: PropTypes.func.isRequired,
  normalizationStateActionSetNormalizationCurrentVolume: PropTypes.func.isRequired,
  normalizationStateActionSetDiluentWell: PropTypes.func.isRequired,
  protocolConfig: PropTypes.object.isRequired,
  poolingStateBeforeEdit: PropTypes.object,
  cardStateActionRemoveCardTasks: PropTypes.func.isRequired,
  taskListPicklistBusinessSetPicklistDeckId: PropTypes.func.isRequired,
  taskListPicklistBusinessUnSetPicklistDeckId: PropTypes.func.isRequired,
  taskListPicklistBusinessIncrementCurrentStep: PropTypes.func.isRequired,
  taskListPicklistBusinessFinalizePicklist: PropTypes.func.isRequired,
  taskListPicklistSwapPicklistDeckId: PropTypes.func.isRequired,
  taskListPicklistOnDroppedLabware: PropTypes.func.isRequired,
  tasklistPicklistBusinessUpdatePicklistOriginalLabware: PropTypes.func.isRequired,
  tasklistPicklistBusinessGetPicklistLabwareIDs: PropTypes.func.isRequired,
  undoRedoBusinessActionGlobalAddUndoItem: PropTypes.func.isRequired,
  undoRedoBusinessActionGlobalUndoRedoUpdatePresentState: PropTypes.func.isRequired,
  undoRedoBusinessActionGlobalUndo: PropTypes.func.isRequired,
  undoRedoBusinessActionGlobalRedo: PropTypes.func.isRequired,
  picklistDefinition: PropTypes.object.isRequired,
  temporaryState: PropTypes.object.isRequired,
  deepWellThreshold: PropTypes.number.isRequired,
  taskListPoolingBusinessClearPoolingStateBeforeEdit: PropTypes.func.isRequired,
  taskListPoolingBusinessGetPoolingStateBeforeEdit: PropTypes.func.isRequired,
  protocolEditorState: PropTypes.object.isRequired,
  protocolEditorStateActionSetADModalShown: PropTypes.func.isRequired,
  protocolEditorStateActionSetSelectedTipChannel: PropTypes.func.isRequired,
  protocolSelectedTipChannel: PropTypes.string,
  protocolCustomTipCount: PropTypes.object,
  protocolEditorStateActionSetCustomTipCount: PropTypes.func.isRequired,
  protocolSerialDilutionStep: PropTypes.any,
  protocolEditorStateActionSetSerialDilutionStep: PropTypes.func.isRequired,
  protocolEditorStateActionSetSerialDilutionEditStep: PropTypes.func.isRequired,
  protocolEditorStateActionSetSerialDilutionPrevStep: PropTypes.func.isRequired,
  protocolBroadcastTaskEditStep: PropTypes.any,
  protocolEditorStateActionSetBroadcastTaskEditStep: PropTypes.func.isRequired,
  protocolPoolingTaskEditStep: PropTypes.any,
  protocolEditorStateActionSetPoolingTaskEditStep: PropTypes.func.isRequired,
  protocolPoolingTaskStep: PropTypes.any,
  protocolEditorStateActionSetPoolingTaskStep: PropTypes.func.isRequired,
  protocolNormalizationTaskEditStep: PropTypes.any,
  protocolEditorStateActionSetNormalizationTaskEditStep: PropTypes.func.isRequired,
  normalizationStateNormalizationStep: PropTypes.number,
  setNormalizationStep: PropTypes.func.isRequired,
  protocolIsEditMixing: PropTypes.bool.isRequired,
  protocolEditorStateActionSetIsEditMixing: PropTypes.func.isRequired,
  protocolVolumeModalOpen: PropTypes.bool.isRequired,
  protocolEditorStateActionSetVolumeModalOpen: PropTypes.func.isRequired,
  protocolEditorMode: PropTypes.string,
  setProtocolEditorMode: PropTypes.func.isRequired,
  appStateActionShowLoading: PropTypes.func.isRequired,
  appStateActionHideLoading: PropTypes.func.isRequired,
  isModalShowing: PropTypes.bool.isRequired,
  isLoadingShowing: PropTypes.bool,
  hideWasteBin: PropTypes.bool,
  hideWellHighlight: PropTypes.bool,
  temporaryStateActionRemoveTemporaryState: PropTypes.func.isRequired,
  userManagementBusinessIsRoleLevel: PropTypes.func.isRequired,
  taskListBusinessAddCardGroup: PropTypes.any.isRequired,
  simpleTransferEditedType: PropTypes.any,
  lastOpenedProtocol: PropTypes.object.isRequired,
  svmExcludedComponentRef: PropTypes.object.isRequired,
  stateBusinessSaveState: PropTypes.func.isRequired,
  setNormalizationDiluentLabwareTray: PropTypes.func.isRequired,
  isRunOnly: PropTypes.bool,
  configMinAspirateVolume: PropTypes.number.isRequired,
  configMinAspirateHighVolume: PropTypes.number.isRequired,
  configRecommendedAspirateVolume: PropTypes.number.isRequired,
  configRecommendedAspirateHighVolume: PropTypes.number.isRequired,
};

VirtualTray.defaultProps = {
  selectedCard: {},
  poolingStateBeforeEdit: {},
  protocolEditorMode: '',
  normalizationStateNormalizationStep: null,
  protocolNormalizationTaskEditStep: null,
  protocolPoolingTaskStep: null,
  protocolPoolingTaskEditStep: null,
  protocolBroadcastTaskEditStep: null,
  protocolSerialDilutionStep: null,
  protocolCustomTipCount: null,
  protocolSelectedTipChannel: '',
  isLoadingShowing: false,
  simpleTransferEditedType: null,
  hideWasteBin: false,
  hideWellHighlight: false,
  isTessaraProtocol: false,
  isRunOnly: false,
};

function virtualTrayMapStateToProps(state) {
  const {
    selectedTipChannel,
    customTipCount,
    serialDilutionStep,
    broadcastTaskEditStep,
    poolingTaskEditStep,
    poolingTaskStep,
    normalizationTaskEditStep,
    isEditMixing,
    volumeModalOpen,
    selectedMenu,
    simpleTransferEditedType,
  } = state.protocolEditorState;
  const {currentWizardView} = state.normalizationState;
  const {show} = state.modalState;
  const {loading, isAnyModalShow, viewMode} = state.appState;

  return {
    availableLabwareState: state.availableLabwareState,
    labwareState: state.labwareState,
    cardStateTasks: state.cardState.tasks,
    cardState: state.cardState.cards,
    cardStateGroups: state.cardState.groups,
    runtimeStateCsvRecordID: state.runtimeState.csvRecordID,
    runtimeStateDoneRecordCSVIDs: state.runtimeState.doneRecordCSVIDs,
    runtimeStateStatus: state.runtimeState.status,
    runtimeStateTrayType: state.runtimeState.trayType,
    configStateMaxAspirateVolume: state.configState.maxAspirateVolume.value,
    configStateMaxAspirateHighVolume: state.configState.maxAspirateHighVolume.value,
    configMinAspirateVolume: state.configState.minAspirateVolume.value,
    configMinAspirateHighVolume: state.configState.minAspirateHighVolume.value,
    configRecommendedAspirateVolume: state.configState.recommendedAspirateVolume.value,
    configRecommendedAspirateHighVolume: state.configState.recommendedAspirateHighVolume.value,
    normalizationState: state.normalizationState,
    protocolConfig: state.configState.protocolConfig,
    poolingStateBeforeEdit: state.temporaryState?.poolingStateBeforeEdit,
    picklistDefinition: state.temporaryState?.picklistDefinition ?? {
      labwareMap: {},
      currentStep: 0,
      originalLabware: {},
    },
    temporaryState: state.temporaryState,
    deepWellThreshold: state.configState.deepWellThreshold,
    protocolEditorState: state.protocolEditorState,
    protocolSelectedTipChannel: selectedTipChannel,
    protocolCustomTipCount: customTipCount,
    protocolSerialDilutionStep: serialDilutionStep,
    protocolBroadcastTaskEditStep: broadcastTaskEditStep,
    protocolPoolingTaskEditStep: poolingTaskEditStep,
    protocolPoolingTaskStep: poolingTaskStep,
    protocolNormalizationTaskEditStep: normalizationTaskEditStep,
    normalizationStateNormalizationStep: currentWizardView,
    protocolIsEditMixing: isEditMixing,
    protocolVolumeModalOpen: volumeModalOpen,
    protocolEditorMode: selectedMenu,
    isModalShowing: show || isAnyModalShow,
    isLoadingShowing: loading.show,
    appStateViewMode: viewMode,
    simpleTransferEditedType,
    lastOpenedProtocol: state.protocolState.lastOpenedProtocol,
  };
}

function virtualTraymapDispatchToProps(dispatch) {
  return {
    appStateActionShowSnackbar: bindActionCreators(showSnackbar, dispatch),
    appStateActionShowLoading: bindActionCreators(showLoading, dispatch),
    appStateActionHideLoading: bindActionCreators(hideLoading, dispatch),
    labwareActionUnselectAllLabware: bindActionCreators(unselectAllLabware, dispatch),
    labwareBusinessSetDeckLabware: bindActionCreators(setDeckLabware, dispatch),
    labwareBusinessRemoveLabware: bindActionCreators(checkAndRemoveLabware, dispatch),
    labwareBusinessGetWellStyleColor: bindActionCreators(getWellStyleColor, dispatch),
    labwareBusinessGetAllWellStyleColorMapFromTasks: bindActionCreators(getAllWellStyleColorMapFromTasks, dispatch),
    labwareBusinessRenameLabware: bindActionCreators(renameLabware, dispatch),
    labwareBusinessGetWellStyleColorMapFromTasks: bindActionCreators(getWellStyleColorMapFromTasks, dispatch),
    labwareBusinessMoveAndDuplicateTaskIntoQuadrant: bindActionCreators(moveAndDuplicateTaskIntoQuadrant, dispatch),
    labwareBusinessMoveAndMergeTaskIntoNonQuadrantBase: bindActionCreators(
      moveAndMergeTaskIntoNonQuadrantBase,
      dispatch,
    ),
    labwareStateActionSetLabwareBarcode: bindActionCreators(setLabwareBarcode, dispatch),
    taskListBusinessAddTask: bindActionCreators(addSimpleTransferTask, dispatch),
    taskListBusinessEditWellTargetTask: bindActionCreators(editSimpleTransferWellTargetTask, dispatch),
    taskListBusinessSmarterDefaultDispenseTipPosition: bindActionCreators(smarterDefaultDispenseTipPosition, dispatch),
    taskListSerialDilutionBusinessSetSdRawTask: bindActionCreators(setSdRawTask, dispatch),
    taskListSerialDilutionBusinessRemoveSdDiluentTargetRawTask: bindActionCreators(
      removeSdDiluentTargetRawTask,
      dispatch,
    ),
    taskListSerialDilutionBusinessGetSdRawTaskIds: bindActionCreators(getSdRawTaskIds, dispatch),
    taskListBroadcastBusinessAddBroadcastTask: bindActionCreators(addBroadcastTask, dispatch),
    taskListBroadcastBusinessAddBroadcastDispenseTasks: bindActionCreators(addBroadcastDispenseTasks, dispatch),
    taskListBroadcastBusinessSetBroadcastVolume: bindActionCreators(setBroadcastVolume, dispatch),
    taskListBroadcastBusinessBackHandler: bindActionCreators(backHandler, dispatch),
    taskListBroadcastBusinessSaveBroadcastStateBeforeEdit: bindActionCreators(saveBroadcastStateBeforeEdit, dispatch),
    taskListBroadcastBusinessRestoreBroadcastStateAfterCancelEdit: bindActionCreators(
      restoreBroadcastStateAfterCancelEdit,
      dispatch,
    ),
    taskListBroadcastBusinessBatchEditBroadcastAspirateTasks: bindActionCreators(
      batchEditBroadcastAspirateTasks,
      dispatch,
    ),
    taskListBroadcastBusinessSetBroadcastAspirateVolume: bindActionCreators(setBroadcastAspirateVolume, dispatch),
    taskListBroadcastBusinessOptimizeBroadcastCard: bindActionCreators(optimizeBroadcastCard, dispatch),
    taskListBroadcastBusinessBatchEditBroadcastDispenseTasks: bindActionCreators(
      batchEditBroadcastDispenseTasks,
      dispatch,
    ),
    cardStateActionRemoveCardTasks: bindActionCreators(removeCardTasks, dispatch),
    cardActionSetTaskIsSelected: bindActionCreators(setTaskIsSelected, dispatch),
    cardActionRemoveAllCardTask: bindActionCreators(removeAllCardTask, dispatch),
    modalStateActionShowModal: bindActionCreators(showModal, dispatch),
    modalStateActionHideModal: bindActionCreators(hideModal, dispatch),
    taskListPoolingBusinessAddPoolingDispenseTasks: bindActionCreators(addPoolingDispenseTasks, dispatch),
    taskListPoolingBusinessAddPoolingAspirateTasks: bindActionCreators(addPoolingAspirateTasks, dispatch),
    taskListPoolingBusinessBackHandler: bindActionCreators(poolingBackHandler, dispatch),
    taskListPoolingBusinessSavePoolingStateBeforeEdit: bindActionCreators(savePoolingStateBeforeEdit, dispatch),
    taskListPoolingBusinessBatchRedefinePoolingAspirateTasks: bindActionCreators(
      batchRedefinePoolingAspirateTasks,
      dispatch,
    ),
    taskListPoolingBusinessBatchEditPoolingDispenseTasks: bindActionCreators(batchEditPoolingDispenseTasks, dispatch),
    taskListPoolingBusinessBatchMovePoolingAspirateTasks: bindActionCreators(batchMovePoolingAspirateTasks, dispatch),
    taskListPoolingBusinessRestorePoolingStateAfterCancelEdit: bindActionCreators(
      restorePoolingStateAfterCancelEdit,
      dispatch,
    ),
    taskListPoolingBusinessGenerateAspirateRowColumnsListFromSwipingInfo: bindActionCreators(
      generateAspirateRowColumnsListFromSwipingInfo,
      dispatch,
    ),
    taskListPoolingSetPoolingHelperState: bindActionCreators(setPoolingHelperState, dispatch),
    taskListPoolingBusinessBatchEditPoolingAspirateTasks: bindActionCreators(batchEditPoolingAspirateTasks, dispatch),
    taskListPoolingBusinessRemoveExcesPoolingTask: bindActionCreators(removeExcesPoolingTask, dispatch),
    taskListPoolingBusinessClosePoolingVolumeModal: bindActionCreators(closePoolingVolumeModalBusiness, dispatch),
    taskListPoolingBusinessGetPoolingDestinationAllowedTip: bindActionCreators(
      getPoolingDestinationAllowedTip,
      dispatch,
    ),
    taskListMixingBusinessAddMixingTask: bindActionCreators(addMixingTask, dispatch),
    taskListMixingBusinessEditMixingTask: bindActionCreators(editMixingTask, dispatch),
    taskListNormalizationSelectNormalizationSamplePlate: bindActionCreators(selectNormalizationSamplePlate, dispatch),
    taskListNormalizationSelectNormalizationDiluentPlate: bindActionCreators(selectNormalizationDiluentPlate, dispatch),
    taskListNormalizationGeneratePreviewData: bindActionCreators(setAndGeneratePreviewData, dispatch),
    taskListNormalizationGenerateNormalizationTask: bindActionCreators(generateNormalizationTask, dispatch),
    taskListNormalizationNormalizationBackHandler: bindActionCreators(normalizationBackHandler, dispatch),
    taskListNormalizationNormalizationEditStep: bindActionCreators(normalizationEditStep, dispatch),
    taskListNormalizationRemoveAspirateDispenseTask: bindActionCreators(removeAspirateDispenseTask, dispatch),
    taskListBroadcastBusinessRestoreNormalizationStateAfterCancelEdit: bindActionCreators(
      restoreNormalizationStateAfterCancelEdit,
      dispatch,
    ),
    normalizationStateActionSetNormalizationCurrentVolume: bindActionCreators(setNormalizationCurrentVolume, dispatch),
    normalizationStateActionSetDiluentWell: bindActionCreators(setDiluentWell, dispatch),
    taskListPicklistBusinessSetPicklistDeckId: bindActionCreators(setPicklistDeckId, dispatch),
    taskListPicklistBusinessUnSetPicklistDeckId: bindActionCreators(unSetPicklistDeckId, dispatch),
    taskListPicklistBusinessIncrementCurrentStep: bindActionCreators(incrementCurrentStep, dispatch),
    taskListPicklistBusinessFinalizePicklist: bindActionCreators(finalizePicklist, dispatch),
    taskListPicklistSwapPicklistDeckId: bindActionCreators(swapPicklistDeckId, dispatch),
    taskListPicklistOnDroppedLabware: bindActionCreators(picklistOnDroppedLabware, dispatch),
    tasklistPicklistBusinessUpdatePicklistOriginalLabware: bindActionCreators(updatePicklistOriginalLabware, dispatch),
    tasklistPicklistBusinessGetPicklistLabwareIDs: bindActionCreators(getPicklistLabwareIDs, dispatch),
    undoRedoBusinessActionGlobalAddUndoItem: bindActionCreators(globalAddUndoItem, dispatch),
    undoRedoBusinessActionGlobalUndoRedoUpdatePresentState: bindActionCreators(
      globalUndoRedoUpdatePresentState,
      dispatch,
    ),
    undoRedoBusinessActionGlobalUndo: bindActionCreators(globalUndo, dispatch),
    undoRedoBusinessActionGlobalRedo: bindActionCreators(globalRedo, dispatch),
    taskListPoolingBusinessClearPoolingStateBeforeEdit: bindActionCreators(clearPoolingStateBeforeEdit, dispatch),
    taskListPoolingBusinessGetPoolingStateBeforeEdit: bindActionCreators(getPoolingStateBeforeEdit, dispatch),
    protocolEditorStateActionSetADModalShown: bindActionCreators(setADModalShown, dispatch),
    protocolEditorStateActionSetSelectedTipChannel: bindActionCreators(setSelectedTipChannel, dispatch),
    protocolEditorStateActionSetCustomTipCount: bindActionCreators(setCustomTipCount, dispatch),
    protocolEditorStateActionSetSerialDilutionStep: bindActionCreators(setSerialDilutionStep, dispatch),
    protocolEditorStateActionSetSerialDilutionEditStep: bindActionCreators(setSerialDilutionEditStep, dispatch),
    protocolEditorStateActionSetSerialDilutionPrevStep: bindActionCreators(setSerialDilutionPrevStep, dispatch),
    protocolEditorStateActionSetBroadcastTaskEditStep: bindActionCreators(setBroadcastTaskEditStep, dispatch),
    protocolEditorStateActionSetPoolingTaskEditStep: bindActionCreators(setPoolingTaskEditStep, dispatch),
    protocolEditorStateActionSetPoolingTaskStep: bindActionCreators(setPoolingTaskStep, dispatch),
    protocolEditorStateActionSetNormalizationTaskEditStep: bindActionCreators(setNormalizationTaskEditStep, dispatch),
    setNormalizationStep: bindActionCreators(setCurrentWizardView, dispatch),
    protocolEditorStateActionSetIsEditMixing: bindActionCreators(setIsEditMixing, dispatch),
    protocolEditorStateActionSetVolumeModalOpen: bindActionCreators(setVolumeModalOpen, dispatch),
    setProtocolEditorMode: bindActionCreators(setSelectedMenu, dispatch),
    temporaryStateActionRemoveTemporaryState: bindActionCreators(removeTemporaryState, dispatch),
    userManagementBusinessIsRoleLevel: bindActionCreators(isRoleLevel, dispatch),
    taskListBusinessAddCardGroup: bindActionCreators(addCardGroup, dispatch),
    stateBusinessSaveState: bindActionCreators(saveState, dispatch),
    setNormalizationDiluentLabwareTray: bindActionCreators(setNormalizationDiluentLabware, dispatch),
  };
}

export default connect(virtualTrayMapStateToProps, virtualTraymapDispatchToProps, null, {
  forwardRef: true,
})(withIntl(VirtualTray));
